
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0217"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0217"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lqFeq", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $f99c02721b301eaa$export$ffb0004e005737fa; }, function (v) { return $f99c02721b301eaa$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $f99c02721b301eaa$export$34b9dba7ce09269b; }, function (v) { return $f99c02721b301eaa$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $f99c02721b301eaa$export$25062201e9e25d76; }, function (v) { return $f99c02721b301eaa$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f99c02721b301eaa$export$ffb0004e005737fa;
var $f99c02721b301eaa$export$34b9dba7ce09269b;
var $f99c02721b301eaa$export$25062201e9e25d76;
"use strict";

var $x1Cpm = parcelRequire("x1Cpm");
var $f99c02721b301eaa$var$k = Symbol.for("react.element"), $f99c02721b301eaa$var$l = Symbol.for("react.fragment"), $f99c02721b301eaa$var$m = Object.prototype.hasOwnProperty, $f99c02721b301eaa$var$n = $x1Cpm.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $f99c02721b301eaa$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f99c02721b301eaa$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$f99c02721b301eaa$var$m.call(a, b) && !$f99c02721b301eaa$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $f99c02721b301eaa$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $f99c02721b301eaa$var$n.current
    };
}
$f99c02721b301eaa$export$ffb0004e005737fa = $f99c02721b301eaa$var$l;
$f99c02721b301eaa$export$34b9dba7ce09269b = $f99c02721b301eaa$var$q;
$f99c02721b301eaa$export$25062201e9e25d76 = $f99c02721b301eaa$var$q;

});
parcelRegister("x1Cpm", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gwUMv"));

});
parcelRegister("gwUMv", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c08bae1c2cd3921f$export$dca3b0875bd9a954; }, function (v) { return $c08bae1c2cd3921f$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c08bae1c2cd3921f$export$16fa2f45be04daa8; }, function (v) { return $c08bae1c2cd3921f$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c08bae1c2cd3921f$export$ffb0004e005737fa; }, function (v) { return $c08bae1c2cd3921f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c08bae1c2cd3921f$export$e2c29f18771995cb; }, function (v) { return $c08bae1c2cd3921f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c08bae1c2cd3921f$export$221d75b3f55bb0bd; }, function (v) { return $c08bae1c2cd3921f$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c08bae1c2cd3921f$export$5f8d39834fd61797; }, function (v) { return $c08bae1c2cd3921f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c08bae1c2cd3921f$export$74bf444e3cd11ea5; }, function (v) { return $c08bae1c2cd3921f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c08bae1c2cd3921f$export$ae55be85d98224ed; }, function (v) { return $c08bae1c2cd3921f$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $c08bae1c2cd3921f$export$3ba232387fd5d6dd; }, function (v) { return $c08bae1c2cd3921f$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c08bae1c2cd3921f$export$e530037191fcd5d7; }, function (v) { return $c08bae1c2cd3921f$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c08bae1c2cd3921f$export$fd42f52fd3ae1109; }, function (v) { return $c08bae1c2cd3921f$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c08bae1c2cd3921f$export$c8a8987d4410bf2d; }, function (v) { return $c08bae1c2cd3921f$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c08bae1c2cd3921f$export$d38cd72104c1f0e9; }, function (v) { return $c08bae1c2cd3921f$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c08bae1c2cd3921f$export$7d1e3a5e95ceca43; }, function (v) { return $c08bae1c2cd3921f$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c08bae1c2cd3921f$export$257a8862b851cb5b; }, function (v) { return $c08bae1c2cd3921f$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c08bae1c2cd3921f$export$a8257692ac88316c; }, function (v) { return $c08bae1c2cd3921f$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c08bae1c2cd3921f$export$488013bae63b21da; }, function (v) { return $c08bae1c2cd3921f$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c08bae1c2cd3921f$export$7c73462e0d25e514; }, function (v) { return $c08bae1c2cd3921f$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c08bae1c2cd3921f$export$7568632d0d33d16d; }, function (v) { return $c08bae1c2cd3921f$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c08bae1c2cd3921f$export$88948ce120ea2619; }, function (v) { return $c08bae1c2cd3921f$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c08bae1c2cd3921f$export$35808ee640e87ca7; }, function (v) { return $c08bae1c2cd3921f$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c08bae1c2cd3921f$export$fae74005e78b1a27; }, function (v) { return $c08bae1c2cd3921f$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c08bae1c2cd3921f$export$dc8fbce3eb94dc1e; }, function (v) { return $c08bae1c2cd3921f$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c08bae1c2cd3921f$export$6a7bc4e911dc01cf; }, function (v) { return $c08bae1c2cd3921f$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c08bae1c2cd3921f$export$6d9c69b0de29b591; }, function (v) { return $c08bae1c2cd3921f$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c08bae1c2cd3921f$export$f680877a34711e37; }, function (v) { return $c08bae1c2cd3921f$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c08bae1c2cd3921f$export$d5a552a76deda3c2; }, function (v) { return $c08bae1c2cd3921f$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c08bae1c2cd3921f$export$aaabe4eda9ed9969; }, function (v) { return $c08bae1c2cd3921f$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c08bae1c2cd3921f$export$e5c5a5f917a5871c; }, function (v) { return $c08bae1c2cd3921f$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c08bae1c2cd3921f$export$1538c33de8887b59; }, function (v) { return $c08bae1c2cd3921f$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c08bae1c2cd3921f$export$13e3392192263954; }, function (v) { return $c08bae1c2cd3921f$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c08bae1c2cd3921f$export$b8f5890fc79d6aca; }, function (v) { return $c08bae1c2cd3921f$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c08bae1c2cd3921f$export$60241385465d0a34; }, function (v) { return $c08bae1c2cd3921f$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c08bae1c2cd3921f$export$306c0aa65ff9ec16; }, function (v) { return $c08bae1c2cd3921f$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c08bae1c2cd3921f$export$7b286972b8d8ccbf; }, function (v) { return $c08bae1c2cd3921f$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c08bae1c2cd3921f$export$83d89fbfd8236492; }, function (v) { return $c08bae1c2cd3921f$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c08bae1c2cd3921f$export$dca3b0875bd9a954;
var $c08bae1c2cd3921f$export$16fa2f45be04daa8;
var $c08bae1c2cd3921f$export$ffb0004e005737fa;
var $c08bae1c2cd3921f$export$e2c29f18771995cb;
var $c08bae1c2cd3921f$export$221d75b3f55bb0bd;
var $c08bae1c2cd3921f$export$5f8d39834fd61797;
var $c08bae1c2cd3921f$export$74bf444e3cd11ea5;
var $c08bae1c2cd3921f$export$ae55be85d98224ed;
var $c08bae1c2cd3921f$export$3ba232387fd5d6dd;
var $c08bae1c2cd3921f$export$e530037191fcd5d7;
var $c08bae1c2cd3921f$export$fd42f52fd3ae1109;
var $c08bae1c2cd3921f$export$c8a8987d4410bf2d;
var $c08bae1c2cd3921f$export$d38cd72104c1f0e9;
var $c08bae1c2cd3921f$export$7d1e3a5e95ceca43;
var $c08bae1c2cd3921f$export$257a8862b851cb5b;
var $c08bae1c2cd3921f$export$a8257692ac88316c;
var $c08bae1c2cd3921f$export$488013bae63b21da;
var $c08bae1c2cd3921f$export$7c73462e0d25e514;
var $c08bae1c2cd3921f$export$7568632d0d33d16d;
var $c08bae1c2cd3921f$export$88948ce120ea2619;
var $c08bae1c2cd3921f$export$35808ee640e87ca7;
var $c08bae1c2cd3921f$export$fae74005e78b1a27;
var $c08bae1c2cd3921f$export$dc8fbce3eb94dc1e;
var $c08bae1c2cd3921f$export$6a7bc4e911dc01cf;
var $c08bae1c2cd3921f$export$6d9c69b0de29b591;
var $c08bae1c2cd3921f$export$f680877a34711e37;
var $c08bae1c2cd3921f$export$d5a552a76deda3c2;
var $c08bae1c2cd3921f$export$aaabe4eda9ed9969;
var $c08bae1c2cd3921f$export$e5c5a5f917a5871c;
var $c08bae1c2cd3921f$export$1538c33de8887b59;
var $c08bae1c2cd3921f$export$13e3392192263954;
var $c08bae1c2cd3921f$export$b8f5890fc79d6aca;
var $c08bae1c2cd3921f$export$60241385465d0a34;
var $c08bae1c2cd3921f$export$306c0aa65ff9ec16;
var $c08bae1c2cd3921f$export$7b286972b8d8ccbf;
var $c08bae1c2cd3921f$export$83d89fbfd8236492;
"use strict";
var $c08bae1c2cd3921f$var$l = Symbol.for("react.element"), $c08bae1c2cd3921f$var$n = Symbol.for("react.portal"), $c08bae1c2cd3921f$var$p = Symbol.for("react.fragment"), $c08bae1c2cd3921f$var$q = Symbol.for("react.strict_mode"), $c08bae1c2cd3921f$var$r = Symbol.for("react.profiler"), $c08bae1c2cd3921f$var$t = Symbol.for("react.provider"), $c08bae1c2cd3921f$var$u = Symbol.for("react.context"), $c08bae1c2cd3921f$var$v = Symbol.for("react.forward_ref"), $c08bae1c2cd3921f$var$w = Symbol.for("react.suspense"), $c08bae1c2cd3921f$var$x = Symbol.for("react.memo"), $c08bae1c2cd3921f$var$y = Symbol.for("react.lazy"), $c08bae1c2cd3921f$var$z = Symbol.iterator;
function $c08bae1c2cd3921f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c08bae1c2cd3921f$var$z && a[$c08bae1c2cd3921f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c08bae1c2cd3921f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c08bae1c2cd3921f$var$C = Object.assign, $c08bae1c2cd3921f$var$D = {};
function $c08bae1c2cd3921f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c08bae1c2cd3921f$var$D;
    this.updater = e || $c08bae1c2cd3921f$var$B;
}
$c08bae1c2cd3921f$var$E.prototype.isReactComponent = {};
$c08bae1c2cd3921f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c08bae1c2cd3921f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c08bae1c2cd3921f$var$F() {}
$c08bae1c2cd3921f$var$F.prototype = $c08bae1c2cd3921f$var$E.prototype;
function $c08bae1c2cd3921f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c08bae1c2cd3921f$var$D;
    this.updater = e || $c08bae1c2cd3921f$var$B;
}
var $c08bae1c2cd3921f$var$H = $c08bae1c2cd3921f$var$G.prototype = new $c08bae1c2cd3921f$var$F;
$c08bae1c2cd3921f$var$H.constructor = $c08bae1c2cd3921f$var$G;
$c08bae1c2cd3921f$var$C($c08bae1c2cd3921f$var$H, $c08bae1c2cd3921f$var$E.prototype);
$c08bae1c2cd3921f$var$H.isPureReactComponent = !0;
var $c08bae1c2cd3921f$var$I = Array.isArray, $c08bae1c2cd3921f$var$J = Object.prototype.hasOwnProperty, $c08bae1c2cd3921f$var$K = {
    current: null
}, $c08bae1c2cd3921f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c08bae1c2cd3921f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c08bae1c2cd3921f$var$J.call(b, d) && !$c08bae1c2cd3921f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c08bae1c2cd3921f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c08bae1c2cd3921f$var$K.current
    };
}
function $c08bae1c2cd3921f$var$N(a, b) {
    return {
        $$typeof: $c08bae1c2cd3921f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c08bae1c2cd3921f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c08bae1c2cd3921f$var$l;
}
function $c08bae1c2cd3921f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c08bae1c2cd3921f$var$P = /\/+/g;
function $c08bae1c2cd3921f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c08bae1c2cd3921f$var$escape("" + a.key) : b.toString(36);
}
function $c08bae1c2cd3921f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c08bae1c2cd3921f$var$l:
                case $c08bae1c2cd3921f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c08bae1c2cd3921f$var$Q(h, 0) : d, $c08bae1c2cd3921f$var$I(c) ? (e = "", null != a && (e = a.replace($c08bae1c2cd3921f$var$P, "$&/") + "/"), $c08bae1c2cd3921f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c08bae1c2cd3921f$var$O(c) && (c = $c08bae1c2cd3921f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c08bae1c2cd3921f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c08bae1c2cd3921f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c08bae1c2cd3921f$var$Q(k, g);
        h += $c08bae1c2cd3921f$var$R(k, b, e, f, c);
    }
    else if (f = $c08bae1c2cd3921f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c08bae1c2cd3921f$var$Q(k, g++), h += $c08bae1c2cd3921f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c08bae1c2cd3921f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c08bae1c2cd3921f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c08bae1c2cd3921f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c08bae1c2cd3921f$var$U = {
    current: null
}, $c08bae1c2cd3921f$var$V = {
    transition: null
}, $c08bae1c2cd3921f$var$W = {
    ReactCurrentDispatcher: $c08bae1c2cd3921f$var$U,
    ReactCurrentBatchConfig: $c08bae1c2cd3921f$var$V,
    ReactCurrentOwner: $c08bae1c2cd3921f$var$K
};
function $c08bae1c2cd3921f$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$c08bae1c2cd3921f$export$dca3b0875bd9a954 = {
    map: $c08bae1c2cd3921f$var$S,
    forEach: function(a, b, e) {
        $c08bae1c2cd3921f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c08bae1c2cd3921f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c08bae1c2cd3921f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c08bae1c2cd3921f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c08bae1c2cd3921f$export$16fa2f45be04daa8 = $c08bae1c2cd3921f$var$E;
$c08bae1c2cd3921f$export$ffb0004e005737fa = $c08bae1c2cd3921f$var$p;
$c08bae1c2cd3921f$export$e2c29f18771995cb = $c08bae1c2cd3921f$var$r;
$c08bae1c2cd3921f$export$221d75b3f55bb0bd = $c08bae1c2cd3921f$var$G;
$c08bae1c2cd3921f$export$5f8d39834fd61797 = $c08bae1c2cd3921f$var$q;
$c08bae1c2cd3921f$export$74bf444e3cd11ea5 = $c08bae1c2cd3921f$var$w;
$c08bae1c2cd3921f$export$ae55be85d98224ed = $c08bae1c2cd3921f$var$W;
$c08bae1c2cd3921f$export$3ba232387fd5d6dd = $c08bae1c2cd3921f$var$X;
$c08bae1c2cd3921f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c08bae1c2cd3921f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c08bae1c2cd3921f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c08bae1c2cd3921f$var$J.call(b, f) && !$c08bae1c2cd3921f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c08bae1c2cd3921f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c08bae1c2cd3921f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c08bae1c2cd3921f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c08bae1c2cd3921f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c08bae1c2cd3921f$export$c8a8987d4410bf2d = $c08bae1c2cd3921f$var$M;
$c08bae1c2cd3921f$export$d38cd72104c1f0e9 = function(a) {
    var b = $c08bae1c2cd3921f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c08bae1c2cd3921f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c08bae1c2cd3921f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c08bae1c2cd3921f$var$v,
        render: a
    };
};
$c08bae1c2cd3921f$export$a8257692ac88316c = $c08bae1c2cd3921f$var$O;
$c08bae1c2cd3921f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c08bae1c2cd3921f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c08bae1c2cd3921f$var$T
    };
};
$c08bae1c2cd3921f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c08bae1c2cd3921f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c08bae1c2cd3921f$export$7568632d0d33d16d = function(a) {
    var b = $c08bae1c2cd3921f$var$V.transition;
    $c08bae1c2cd3921f$var$V.transition = {};
    try {
        a();
    } finally{
        $c08bae1c2cd3921f$var$V.transition = b;
    }
};
$c08bae1c2cd3921f$export$88948ce120ea2619 = $c08bae1c2cd3921f$var$X;
$c08bae1c2cd3921f$export$35808ee640e87ca7 = function(a, b) {
    return $c08bae1c2cd3921f$var$U.current.useCallback(a, b);
};
$c08bae1c2cd3921f$export$fae74005e78b1a27 = function(a) {
    return $c08bae1c2cd3921f$var$U.current.useContext(a);
};
$c08bae1c2cd3921f$export$dc8fbce3eb94dc1e = function() {};
$c08bae1c2cd3921f$export$6a7bc4e911dc01cf = function(a) {
    return $c08bae1c2cd3921f$var$U.current.useDeferredValue(a);
};
$c08bae1c2cd3921f$export$6d9c69b0de29b591 = function(a, b) {
    return $c08bae1c2cd3921f$var$U.current.useEffect(a, b);
};
$c08bae1c2cd3921f$export$f680877a34711e37 = function() {
    return $c08bae1c2cd3921f$var$U.current.useId();
};
$c08bae1c2cd3921f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c08bae1c2cd3921f$var$U.current.useImperativeHandle(a, b, e);
};
$c08bae1c2cd3921f$export$aaabe4eda9ed9969 = function(a, b) {
    return $c08bae1c2cd3921f$var$U.current.useInsertionEffect(a, b);
};
$c08bae1c2cd3921f$export$e5c5a5f917a5871c = function(a, b) {
    return $c08bae1c2cd3921f$var$U.current.useLayoutEffect(a, b);
};
$c08bae1c2cd3921f$export$1538c33de8887b59 = function(a, b) {
    return $c08bae1c2cd3921f$var$U.current.useMemo(a, b);
};
$c08bae1c2cd3921f$export$13e3392192263954 = function(a, b, e) {
    return $c08bae1c2cd3921f$var$U.current.useReducer(a, b, e);
};
$c08bae1c2cd3921f$export$b8f5890fc79d6aca = function(a) {
    return $c08bae1c2cd3921f$var$U.current.useRef(a);
};
$c08bae1c2cd3921f$export$60241385465d0a34 = function(a) {
    return $c08bae1c2cd3921f$var$U.current.useState(a);
};
$c08bae1c2cd3921f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c08bae1c2cd3921f$var$U.current.useSyncExternalStore(a, b, e);
};
$c08bae1c2cd3921f$export$7b286972b8d8ccbf = function() {
    return $c08bae1c2cd3921f$var$U.current.useTransition();
};
$c08bae1c2cd3921f$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("a5Vvh", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $7596fa05f9d11773$export$ae55be85d98224ed; }, function (v) { return $7596fa05f9d11773$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $7596fa05f9d11773$export$d39a5bbd09211389; }, function (v) { return $7596fa05f9d11773$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $7596fa05f9d11773$export$882461b6382ed46c; }, function (v) { return $7596fa05f9d11773$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $7596fa05f9d11773$export$466bfc07425424d5; }, function (v) { return $7596fa05f9d11773$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $7596fa05f9d11773$export$cd75ccfd720a3cd4; }, function (v) { return $7596fa05f9d11773$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $7596fa05f9d11773$export$fa8d919ba61d84db; }, function (v) { return $7596fa05f9d11773$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $7596fa05f9d11773$export$757ceba2d55c277e; }, function (v) { return $7596fa05f9d11773$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $7596fa05f9d11773$export$b3890eb0ae9dca99; }, function (v) { return $7596fa05f9d11773$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $7596fa05f9d11773$export$502457920280e6be; }, function (v) { return $7596fa05f9d11773$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $7596fa05f9d11773$export$c78a37762a8d58e1; }, function (v) { return $7596fa05f9d11773$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $7596fa05f9d11773$export$dc54d992c10e8a18; }, function (v) { return $7596fa05f9d11773$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $7596fa05f9d11773$export$83d89fbfd8236492; }, function (v) { return $7596fa05f9d11773$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $7596fa05f9d11773$export$ae55be85d98224ed;
var $7596fa05f9d11773$export$d39a5bbd09211389;
var $7596fa05f9d11773$export$882461b6382ed46c;
var $7596fa05f9d11773$export$466bfc07425424d5;
var $7596fa05f9d11773$export$cd75ccfd720a3cd4;
var $7596fa05f9d11773$export$fa8d919ba61d84db;
var $7596fa05f9d11773$export$757ceba2d55c277e;
var $7596fa05f9d11773$export$b3890eb0ae9dca99;
var $7596fa05f9d11773$export$502457920280e6be;
var $7596fa05f9d11773$export$c78a37762a8d58e1;
var $7596fa05f9d11773$export$dc54d992c10e8a18;
var $7596fa05f9d11773$export$83d89fbfd8236492;
"use strict";

var $x1Cpm = parcelRequire("x1Cpm");

var $gwmVj = parcelRequire("gwmVj");
function $7596fa05f9d11773$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $7596fa05f9d11773$var$da = new Set, $7596fa05f9d11773$var$ea = {};
function $7596fa05f9d11773$var$fa(a, b) {
    $7596fa05f9d11773$var$ha(a, b);
    $7596fa05f9d11773$var$ha(a + "Capture", b);
}
function $7596fa05f9d11773$var$ha(a, b) {
    $7596fa05f9d11773$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$7596fa05f9d11773$var$da.add(b[a]);
}
var $7596fa05f9d11773$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $7596fa05f9d11773$var$ja = Object.prototype.hasOwnProperty, $7596fa05f9d11773$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $7596fa05f9d11773$var$la = {}, $7596fa05f9d11773$var$ma = {};
function $7596fa05f9d11773$var$oa(a) {
    if ($7596fa05f9d11773$var$ja.call($7596fa05f9d11773$var$ma, a)) return !0;
    if ($7596fa05f9d11773$var$ja.call($7596fa05f9d11773$var$la, a)) return !1;
    if ($7596fa05f9d11773$var$ka.test(a)) return $7596fa05f9d11773$var$ma[a] = !0;
    $7596fa05f9d11773$var$la[a] = !0;
    return !1;
}
function $7596fa05f9d11773$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $7596fa05f9d11773$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $7596fa05f9d11773$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $7596fa05f9d11773$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $7596fa05f9d11773$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $7596fa05f9d11773$var$z[a] = new $7596fa05f9d11773$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $7596fa05f9d11773$var$z[b] = new $7596fa05f9d11773$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $7596fa05f9d11773$var$z[a] = new $7596fa05f9d11773$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $7596fa05f9d11773$var$z[a] = new $7596fa05f9d11773$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $7596fa05f9d11773$var$z[a] = new $7596fa05f9d11773$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $7596fa05f9d11773$var$z[a] = new $7596fa05f9d11773$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $7596fa05f9d11773$var$z[a] = new $7596fa05f9d11773$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $7596fa05f9d11773$var$z[a] = new $7596fa05f9d11773$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $7596fa05f9d11773$var$z[a] = new $7596fa05f9d11773$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $7596fa05f9d11773$var$ra = /[\-:]([a-z])/g;
function $7596fa05f9d11773$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($7596fa05f9d11773$var$ra, $7596fa05f9d11773$var$sa);
    $7596fa05f9d11773$var$z[b] = new $7596fa05f9d11773$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($7596fa05f9d11773$var$ra, $7596fa05f9d11773$var$sa);
    $7596fa05f9d11773$var$z[b] = new $7596fa05f9d11773$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($7596fa05f9d11773$var$ra, $7596fa05f9d11773$var$sa);
    $7596fa05f9d11773$var$z[b] = new $7596fa05f9d11773$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $7596fa05f9d11773$var$z[a] = new $7596fa05f9d11773$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$7596fa05f9d11773$var$z.xlinkHref = new $7596fa05f9d11773$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $7596fa05f9d11773$var$z[a] = new $7596fa05f9d11773$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $7596fa05f9d11773$var$ta(a, b, c, d) {
    var e = $7596fa05f9d11773$var$z.hasOwnProperty(b) ? $7596fa05f9d11773$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $7596fa05f9d11773$var$qa(b, c, e, d) && (c = null), d || null === e ? $7596fa05f9d11773$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $7596fa05f9d11773$var$ua = $x1Cpm.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $7596fa05f9d11773$var$va = Symbol.for("react.element"), $7596fa05f9d11773$var$wa = Symbol.for("react.portal"), $7596fa05f9d11773$var$ya = Symbol.for("react.fragment"), $7596fa05f9d11773$var$za = Symbol.for("react.strict_mode"), $7596fa05f9d11773$var$Aa = Symbol.for("react.profiler"), $7596fa05f9d11773$var$Ba = Symbol.for("react.provider"), $7596fa05f9d11773$var$Ca = Symbol.for("react.context"), $7596fa05f9d11773$var$Da = Symbol.for("react.forward_ref"), $7596fa05f9d11773$var$Ea = Symbol.for("react.suspense"), $7596fa05f9d11773$var$Fa = Symbol.for("react.suspense_list"), $7596fa05f9d11773$var$Ga = Symbol.for("react.memo"), $7596fa05f9d11773$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $7596fa05f9d11773$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $7596fa05f9d11773$var$Ja = Symbol.iterator;
function $7596fa05f9d11773$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $7596fa05f9d11773$var$Ja && a[$7596fa05f9d11773$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7596fa05f9d11773$var$A = Object.assign, $7596fa05f9d11773$var$La;
function $7596fa05f9d11773$var$Ma(a) {
    if (void 0 === $7596fa05f9d11773$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $7596fa05f9d11773$var$La = b && b[1] || "";
    }
    return "\n" + $7596fa05f9d11773$var$La + a;
}
var $7596fa05f9d11773$var$Na = !1;
function $7596fa05f9d11773$var$Oa(a, b) {
    if (!a || $7596fa05f9d11773$var$Na) return "";
    $7596fa05f9d11773$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $7596fa05f9d11773$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $7596fa05f9d11773$var$Ma(a) : "";
}
function $7596fa05f9d11773$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $7596fa05f9d11773$var$Ma(a.type);
        case 16:
            return $7596fa05f9d11773$var$Ma("Lazy");
        case 13:
            return $7596fa05f9d11773$var$Ma("Suspense");
        case 19:
            return $7596fa05f9d11773$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $7596fa05f9d11773$var$Oa(a.type, !1), a;
        case 11:
            return a = $7596fa05f9d11773$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $7596fa05f9d11773$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $7596fa05f9d11773$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $7596fa05f9d11773$var$ya:
            return "Fragment";
        case $7596fa05f9d11773$var$wa:
            return "Portal";
        case $7596fa05f9d11773$var$Aa:
            return "Profiler";
        case $7596fa05f9d11773$var$za:
            return "StrictMode";
        case $7596fa05f9d11773$var$Ea:
            return "Suspense";
        case $7596fa05f9d11773$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $7596fa05f9d11773$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $7596fa05f9d11773$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $7596fa05f9d11773$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $7596fa05f9d11773$var$Ga:
            return b = a.displayName || null, null !== b ? b : $7596fa05f9d11773$var$Qa(a.type) || "Memo";
        case $7596fa05f9d11773$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $7596fa05f9d11773$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $7596fa05f9d11773$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $7596fa05f9d11773$var$Qa(b);
        case 8:
            return b === $7596fa05f9d11773$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $7596fa05f9d11773$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $7596fa05f9d11773$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $7596fa05f9d11773$var$Ua(a) {
    var b = $7596fa05f9d11773$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $7596fa05f9d11773$var$Va(a) {
    a._valueTracker || (a._valueTracker = $7596fa05f9d11773$var$Ua(a));
}
function $7596fa05f9d11773$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $7596fa05f9d11773$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $7596fa05f9d11773$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $7596fa05f9d11773$var$Ya(a, b) {
    var c = b.checked;
    return $7596fa05f9d11773$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $7596fa05f9d11773$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $7596fa05f9d11773$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $7596fa05f9d11773$var$ab(a, b) {
    b = b.checked;
    null != b && $7596fa05f9d11773$var$ta(a, "checked", b, !1);
}
function $7596fa05f9d11773$var$bb(a, b) {
    $7596fa05f9d11773$var$ab(a, b);
    var c = $7596fa05f9d11773$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $7596fa05f9d11773$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $7596fa05f9d11773$var$cb(a, b.type, $7596fa05f9d11773$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $7596fa05f9d11773$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $7596fa05f9d11773$var$cb(a, b, c) {
    if ("number" !== b || $7596fa05f9d11773$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $7596fa05f9d11773$var$eb = Array.isArray;
function $7596fa05f9d11773$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $7596fa05f9d11773$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $7596fa05f9d11773$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($7596fa05f9d11773$var$p(91));
    return $7596fa05f9d11773$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $7596fa05f9d11773$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($7596fa05f9d11773$var$p(92));
            if ($7596fa05f9d11773$var$eb(c)) {
                if (1 < c.length) throw Error($7596fa05f9d11773$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $7596fa05f9d11773$var$Sa(c)
    };
}
function $7596fa05f9d11773$var$ib(a, b) {
    var c = $7596fa05f9d11773$var$Sa(b.value), d = $7596fa05f9d11773$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $7596fa05f9d11773$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $7596fa05f9d11773$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $7596fa05f9d11773$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $7596fa05f9d11773$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $7596fa05f9d11773$var$mb, $7596fa05f9d11773$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $7596fa05f9d11773$var$mb = $7596fa05f9d11773$var$mb || document.createElement("div");
        $7596fa05f9d11773$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $7596fa05f9d11773$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $7596fa05f9d11773$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $7596fa05f9d11773$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $7596fa05f9d11773$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($7596fa05f9d11773$var$pb).forEach(function(a) {
    $7596fa05f9d11773$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $7596fa05f9d11773$var$pb[b] = $7596fa05f9d11773$var$pb[a];
    });
});
function $7596fa05f9d11773$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $7596fa05f9d11773$var$pb.hasOwnProperty(a) && $7596fa05f9d11773$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $7596fa05f9d11773$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $7596fa05f9d11773$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $7596fa05f9d11773$var$tb = $7596fa05f9d11773$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $7596fa05f9d11773$var$ub(a, b) {
    if (b) {
        if ($7596fa05f9d11773$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($7596fa05f9d11773$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($7596fa05f9d11773$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($7596fa05f9d11773$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($7596fa05f9d11773$var$p(62));
    }
}
function $7596fa05f9d11773$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $7596fa05f9d11773$var$wb = null;
function $7596fa05f9d11773$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $7596fa05f9d11773$var$yb = null, $7596fa05f9d11773$var$zb = null, $7596fa05f9d11773$var$Ab = null;
function $7596fa05f9d11773$var$Bb(a) {
    if (a = $7596fa05f9d11773$var$Cb(a)) {
        if ("function" !== typeof $7596fa05f9d11773$var$yb) throw Error($7596fa05f9d11773$var$p(280));
        var b = a.stateNode;
        b && (b = $7596fa05f9d11773$var$Db(b), $7596fa05f9d11773$var$yb(a.stateNode, a.type, b));
    }
}
function $7596fa05f9d11773$var$Eb(a) {
    $7596fa05f9d11773$var$zb ? $7596fa05f9d11773$var$Ab ? $7596fa05f9d11773$var$Ab.push(a) : $7596fa05f9d11773$var$Ab = [
        a
    ] : $7596fa05f9d11773$var$zb = a;
}
function $7596fa05f9d11773$var$Fb() {
    if ($7596fa05f9d11773$var$zb) {
        var a = $7596fa05f9d11773$var$zb, b = $7596fa05f9d11773$var$Ab;
        $7596fa05f9d11773$var$Ab = $7596fa05f9d11773$var$zb = null;
        $7596fa05f9d11773$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$7596fa05f9d11773$var$Bb(b[a]);
    }
}
function $7596fa05f9d11773$var$Gb(a, b) {
    return a(b);
}
function $7596fa05f9d11773$var$Hb() {}
var $7596fa05f9d11773$var$Ib = !1;
function $7596fa05f9d11773$var$Jb(a, b, c) {
    if ($7596fa05f9d11773$var$Ib) return a(b, c);
    $7596fa05f9d11773$var$Ib = !0;
    try {
        return $7596fa05f9d11773$var$Gb(a, b, c);
    } finally{
        if ($7596fa05f9d11773$var$Ib = !1, null !== $7596fa05f9d11773$var$zb || null !== $7596fa05f9d11773$var$Ab) $7596fa05f9d11773$var$Hb(), $7596fa05f9d11773$var$Fb();
    }
}
function $7596fa05f9d11773$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $7596fa05f9d11773$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($7596fa05f9d11773$var$p(231, b, typeof c));
    return c;
}
var $7596fa05f9d11773$var$Lb = !1;
if ($7596fa05f9d11773$var$ia) try {
    var $7596fa05f9d11773$var$Mb = {};
    Object.defineProperty($7596fa05f9d11773$var$Mb, "passive", {
        get: function() {
            $7596fa05f9d11773$var$Lb = !0;
        }
    });
    window.addEventListener("test", $7596fa05f9d11773$var$Mb, $7596fa05f9d11773$var$Mb);
    window.removeEventListener("test", $7596fa05f9d11773$var$Mb, $7596fa05f9d11773$var$Mb);
} catch (a) {
    $7596fa05f9d11773$var$Lb = !1;
}
function $7596fa05f9d11773$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $7596fa05f9d11773$var$Ob = !1, $7596fa05f9d11773$var$Pb = null, $7596fa05f9d11773$var$Qb = !1, $7596fa05f9d11773$var$Rb = null, $7596fa05f9d11773$var$Sb = {
    onError: function(a) {
        $7596fa05f9d11773$var$Ob = !0;
        $7596fa05f9d11773$var$Pb = a;
    }
};
function $7596fa05f9d11773$var$Tb(a, b, c, d, e, f, g, h, k) {
    $7596fa05f9d11773$var$Ob = !1;
    $7596fa05f9d11773$var$Pb = null;
    $7596fa05f9d11773$var$Nb.apply($7596fa05f9d11773$var$Sb, arguments);
}
function $7596fa05f9d11773$var$Ub(a, b, c, d, e, f, g, h, k) {
    $7596fa05f9d11773$var$Tb.apply(this, arguments);
    if ($7596fa05f9d11773$var$Ob) {
        if ($7596fa05f9d11773$var$Ob) {
            var l = $7596fa05f9d11773$var$Pb;
            $7596fa05f9d11773$var$Ob = !1;
            $7596fa05f9d11773$var$Pb = null;
        } else throw Error($7596fa05f9d11773$var$p(198));
        $7596fa05f9d11773$var$Qb || ($7596fa05f9d11773$var$Qb = !0, $7596fa05f9d11773$var$Rb = l);
    }
}
function $7596fa05f9d11773$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $7596fa05f9d11773$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $7596fa05f9d11773$var$Xb(a) {
    if ($7596fa05f9d11773$var$Vb(a) !== a) throw Error($7596fa05f9d11773$var$p(188));
}
function $7596fa05f9d11773$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $7596fa05f9d11773$var$Vb(a);
        if (null === b) throw Error($7596fa05f9d11773$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $7596fa05f9d11773$var$Xb(e), a;
                if (f === d) return $7596fa05f9d11773$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($7596fa05f9d11773$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($7596fa05f9d11773$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($7596fa05f9d11773$var$p(190));
    }
    if (3 !== c.tag) throw Error($7596fa05f9d11773$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $7596fa05f9d11773$var$Zb(a) {
    a = $7596fa05f9d11773$var$Yb(a);
    return null !== a ? $7596fa05f9d11773$var$$b(a) : null;
}
function $7596fa05f9d11773$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $7596fa05f9d11773$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $7596fa05f9d11773$var$ac = $gwmVj.unstable_scheduleCallback, $7596fa05f9d11773$var$bc = $gwmVj.unstable_cancelCallback, $7596fa05f9d11773$var$cc = $gwmVj.unstable_shouldYield, $7596fa05f9d11773$var$dc = $gwmVj.unstable_requestPaint, $7596fa05f9d11773$var$B = $gwmVj.unstable_now, $7596fa05f9d11773$var$ec = $gwmVj.unstable_getCurrentPriorityLevel, $7596fa05f9d11773$var$fc = $gwmVj.unstable_ImmediatePriority, $7596fa05f9d11773$var$gc = $gwmVj.unstable_UserBlockingPriority, $7596fa05f9d11773$var$hc = $gwmVj.unstable_NormalPriority, $7596fa05f9d11773$var$ic = $gwmVj.unstable_LowPriority, $7596fa05f9d11773$var$jc = $gwmVj.unstable_IdlePriority, $7596fa05f9d11773$var$kc = null, $7596fa05f9d11773$var$lc = null;
function $7596fa05f9d11773$var$mc(a) {
    if ($7596fa05f9d11773$var$lc && "function" === typeof $7596fa05f9d11773$var$lc.onCommitFiberRoot) try {
        $7596fa05f9d11773$var$lc.onCommitFiberRoot($7596fa05f9d11773$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $7596fa05f9d11773$var$oc = Math.clz32 ? Math.clz32 : $7596fa05f9d11773$var$nc, $7596fa05f9d11773$var$pc = Math.log, $7596fa05f9d11773$var$qc = Math.LN2;
function $7596fa05f9d11773$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($7596fa05f9d11773$var$pc(a) / $7596fa05f9d11773$var$qc | 0) | 0;
}
var $7596fa05f9d11773$var$rc = 64, $7596fa05f9d11773$var$sc = 4194304;
function $7596fa05f9d11773$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $7596fa05f9d11773$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $7596fa05f9d11773$var$tc(h) : (f &= g, 0 !== f && (d = $7596fa05f9d11773$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $7596fa05f9d11773$var$tc(g) : 0 !== f && (d = $7596fa05f9d11773$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $7596fa05f9d11773$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $7596fa05f9d11773$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $7596fa05f9d11773$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $7596fa05f9d11773$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $7596fa05f9d11773$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $7596fa05f9d11773$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $7596fa05f9d11773$var$yc() {
    var a = $7596fa05f9d11773$var$rc;
    $7596fa05f9d11773$var$rc <<= 1;
    0 === ($7596fa05f9d11773$var$rc & 4194240) && ($7596fa05f9d11773$var$rc = 64);
    return a;
}
function $7596fa05f9d11773$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $7596fa05f9d11773$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $7596fa05f9d11773$var$oc(b);
    a[b] = c;
}
function $7596fa05f9d11773$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $7596fa05f9d11773$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $7596fa05f9d11773$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $7596fa05f9d11773$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $7596fa05f9d11773$var$C = 0;
function $7596fa05f9d11773$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $7596fa05f9d11773$var$Ec, $7596fa05f9d11773$var$Fc, $7596fa05f9d11773$var$Gc, $7596fa05f9d11773$var$Hc, $7596fa05f9d11773$var$Ic, $7596fa05f9d11773$var$Jc = !1, $7596fa05f9d11773$var$Kc = [], $7596fa05f9d11773$var$Lc = null, $7596fa05f9d11773$var$Mc = null, $7596fa05f9d11773$var$Nc = null, $7596fa05f9d11773$var$Oc = new Map, $7596fa05f9d11773$var$Pc = new Map, $7596fa05f9d11773$var$Qc = [], $7596fa05f9d11773$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $7596fa05f9d11773$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $7596fa05f9d11773$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $7596fa05f9d11773$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $7596fa05f9d11773$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $7596fa05f9d11773$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $7596fa05f9d11773$var$Pc.delete(b.pointerId);
    }
}
function $7596fa05f9d11773$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $7596fa05f9d11773$var$Cb(b), null !== b && $7596fa05f9d11773$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $7596fa05f9d11773$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $7596fa05f9d11773$var$Lc = $7596fa05f9d11773$var$Tc($7596fa05f9d11773$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $7596fa05f9d11773$var$Mc = $7596fa05f9d11773$var$Tc($7596fa05f9d11773$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $7596fa05f9d11773$var$Nc = $7596fa05f9d11773$var$Tc($7596fa05f9d11773$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $7596fa05f9d11773$var$Oc.set(f, $7596fa05f9d11773$var$Tc($7596fa05f9d11773$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $7596fa05f9d11773$var$Pc.set(f, $7596fa05f9d11773$var$Tc($7596fa05f9d11773$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $7596fa05f9d11773$var$Vc(a) {
    var b = $7596fa05f9d11773$var$Wc(a.target);
    if (null !== b) {
        var c = $7596fa05f9d11773$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $7596fa05f9d11773$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $7596fa05f9d11773$var$Ic(a.priority, function() {
                        $7596fa05f9d11773$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $7596fa05f9d11773$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $7596fa05f9d11773$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $7596fa05f9d11773$var$wb = d;
            c.target.dispatchEvent(d);
            $7596fa05f9d11773$var$wb = null;
        } else return b = $7596fa05f9d11773$var$Cb(c), null !== b && $7596fa05f9d11773$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $7596fa05f9d11773$var$Zc(a, b, c) {
    $7596fa05f9d11773$var$Xc(a) && c.delete(b);
}
function $7596fa05f9d11773$var$$c() {
    $7596fa05f9d11773$var$Jc = !1;
    null !== $7596fa05f9d11773$var$Lc && $7596fa05f9d11773$var$Xc($7596fa05f9d11773$var$Lc) && ($7596fa05f9d11773$var$Lc = null);
    null !== $7596fa05f9d11773$var$Mc && $7596fa05f9d11773$var$Xc($7596fa05f9d11773$var$Mc) && ($7596fa05f9d11773$var$Mc = null);
    null !== $7596fa05f9d11773$var$Nc && $7596fa05f9d11773$var$Xc($7596fa05f9d11773$var$Nc) && ($7596fa05f9d11773$var$Nc = null);
    $7596fa05f9d11773$var$Oc.forEach($7596fa05f9d11773$var$Zc);
    $7596fa05f9d11773$var$Pc.forEach($7596fa05f9d11773$var$Zc);
}
function $7596fa05f9d11773$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $7596fa05f9d11773$var$Jc || ($7596fa05f9d11773$var$Jc = !0, $gwmVj.unstable_scheduleCallback($gwmVj.unstable_NormalPriority, $7596fa05f9d11773$var$$c)));
}
function $7596fa05f9d11773$var$bd(a) {
    function b(b) {
        return $7596fa05f9d11773$var$ad(b, a);
    }
    if (0 < $7596fa05f9d11773$var$Kc.length) {
        $7596fa05f9d11773$var$ad($7596fa05f9d11773$var$Kc[0], a);
        for(var c = 1; c < $7596fa05f9d11773$var$Kc.length; c++){
            var d = $7596fa05f9d11773$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $7596fa05f9d11773$var$Lc && $7596fa05f9d11773$var$ad($7596fa05f9d11773$var$Lc, a);
    null !== $7596fa05f9d11773$var$Mc && $7596fa05f9d11773$var$ad($7596fa05f9d11773$var$Mc, a);
    null !== $7596fa05f9d11773$var$Nc && $7596fa05f9d11773$var$ad($7596fa05f9d11773$var$Nc, a);
    $7596fa05f9d11773$var$Oc.forEach(b);
    $7596fa05f9d11773$var$Pc.forEach(b);
    for(c = 0; c < $7596fa05f9d11773$var$Qc.length; c++)d = $7596fa05f9d11773$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $7596fa05f9d11773$var$Qc.length && (c = $7596fa05f9d11773$var$Qc[0], null === c.blockedOn);)$7596fa05f9d11773$var$Vc(c), null === c.blockedOn && $7596fa05f9d11773$var$Qc.shift();
}
var $7596fa05f9d11773$var$cd = $7596fa05f9d11773$var$ua.ReactCurrentBatchConfig, $7596fa05f9d11773$var$dd = !0;
function $7596fa05f9d11773$var$ed(a, b, c, d) {
    var e = $7596fa05f9d11773$var$C, f = $7596fa05f9d11773$var$cd.transition;
    $7596fa05f9d11773$var$cd.transition = null;
    try {
        $7596fa05f9d11773$var$C = 1, $7596fa05f9d11773$var$fd(a, b, c, d);
    } finally{
        $7596fa05f9d11773$var$C = e, $7596fa05f9d11773$var$cd.transition = f;
    }
}
function $7596fa05f9d11773$var$gd(a, b, c, d) {
    var e = $7596fa05f9d11773$var$C, f = $7596fa05f9d11773$var$cd.transition;
    $7596fa05f9d11773$var$cd.transition = null;
    try {
        $7596fa05f9d11773$var$C = 4, $7596fa05f9d11773$var$fd(a, b, c, d);
    } finally{
        $7596fa05f9d11773$var$C = e, $7596fa05f9d11773$var$cd.transition = f;
    }
}
function $7596fa05f9d11773$var$fd(a, b, c, d) {
    if ($7596fa05f9d11773$var$dd) {
        var e = $7596fa05f9d11773$var$Yc(a, b, c, d);
        if (null === e) $7596fa05f9d11773$var$hd(a, b, d, $7596fa05f9d11773$var$id, c), $7596fa05f9d11773$var$Sc(a, d);
        else if ($7596fa05f9d11773$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($7596fa05f9d11773$var$Sc(a, d), b & 4 && -1 < $7596fa05f9d11773$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $7596fa05f9d11773$var$Cb(e);
                null !== f && $7596fa05f9d11773$var$Ec(f);
                f = $7596fa05f9d11773$var$Yc(a, b, c, d);
                null === f && $7596fa05f9d11773$var$hd(a, b, d, $7596fa05f9d11773$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $7596fa05f9d11773$var$hd(a, b, d, null, c);
    }
}
var $7596fa05f9d11773$var$id = null;
function $7596fa05f9d11773$var$Yc(a, b, c, d) {
    $7596fa05f9d11773$var$id = null;
    a = $7596fa05f9d11773$var$xb(d);
    a = $7596fa05f9d11773$var$Wc(a);
    if (null !== a) {
        if (b = $7596fa05f9d11773$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $7596fa05f9d11773$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $7596fa05f9d11773$var$id = a;
    return null;
}
function $7596fa05f9d11773$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($7596fa05f9d11773$var$ec()){
                case $7596fa05f9d11773$var$fc:
                    return 1;
                case $7596fa05f9d11773$var$gc:
                    return 4;
                case $7596fa05f9d11773$var$hc:
                case $7596fa05f9d11773$var$ic:
                    return 16;
                case $7596fa05f9d11773$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $7596fa05f9d11773$var$kd = null, $7596fa05f9d11773$var$ld = null, $7596fa05f9d11773$var$md = null;
function $7596fa05f9d11773$var$nd() {
    if ($7596fa05f9d11773$var$md) return $7596fa05f9d11773$var$md;
    var a, b = $7596fa05f9d11773$var$ld, c = b.length, d, e = "value" in $7596fa05f9d11773$var$kd ? $7596fa05f9d11773$var$kd.value : $7596fa05f9d11773$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $7596fa05f9d11773$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $7596fa05f9d11773$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $7596fa05f9d11773$var$pd() {
    return !0;
}
function $7596fa05f9d11773$var$qd() {
    return !1;
}
function $7596fa05f9d11773$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $7596fa05f9d11773$var$pd : $7596fa05f9d11773$var$qd;
        this.isPropagationStopped = $7596fa05f9d11773$var$qd;
        return this;
    }
    $7596fa05f9d11773$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $7596fa05f9d11773$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $7596fa05f9d11773$var$pd);
        },
        persist: function() {},
        isPersistent: $7596fa05f9d11773$var$pd
    });
    return b;
}
var $7596fa05f9d11773$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $7596fa05f9d11773$var$td = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$sd), $7596fa05f9d11773$var$ud = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$sd, {
    view: 0,
    detail: 0
}), $7596fa05f9d11773$var$vd = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$ud), $7596fa05f9d11773$var$wd, $7596fa05f9d11773$var$xd, $7596fa05f9d11773$var$yd, $7596fa05f9d11773$var$Ad = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $7596fa05f9d11773$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $7596fa05f9d11773$var$yd && ($7596fa05f9d11773$var$yd && "mousemove" === a.type ? ($7596fa05f9d11773$var$wd = a.screenX - $7596fa05f9d11773$var$yd.screenX, $7596fa05f9d11773$var$xd = a.screenY - $7596fa05f9d11773$var$yd.screenY) : $7596fa05f9d11773$var$xd = $7596fa05f9d11773$var$wd = 0, $7596fa05f9d11773$var$yd = a);
        return $7596fa05f9d11773$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $7596fa05f9d11773$var$xd;
    }
}), $7596fa05f9d11773$var$Bd = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Ad), $7596fa05f9d11773$var$Cd = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$Ad, {
    dataTransfer: 0
}), $7596fa05f9d11773$var$Dd = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Cd), $7596fa05f9d11773$var$Ed = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$ud, {
    relatedTarget: 0
}), $7596fa05f9d11773$var$Fd = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Ed), $7596fa05f9d11773$var$Gd = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $7596fa05f9d11773$var$Hd = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Gd), $7596fa05f9d11773$var$Id = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $7596fa05f9d11773$var$Jd = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Id), $7596fa05f9d11773$var$Kd = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$sd, {
    data: 0
}), $7596fa05f9d11773$var$Ld = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Kd), $7596fa05f9d11773$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $7596fa05f9d11773$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $7596fa05f9d11773$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $7596fa05f9d11773$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $7596fa05f9d11773$var$Od[a]) ? !!b[a] : !1;
}
function $7596fa05f9d11773$var$zd() {
    return $7596fa05f9d11773$var$Pd;
}
var $7596fa05f9d11773$var$Qd = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $7596fa05f9d11773$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $7596fa05f9d11773$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $7596fa05f9d11773$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $7596fa05f9d11773$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $7596fa05f9d11773$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $7596fa05f9d11773$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $7596fa05f9d11773$var$Rd = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Qd), $7596fa05f9d11773$var$Sd = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $7596fa05f9d11773$var$Td = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Sd), $7596fa05f9d11773$var$Ud = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $7596fa05f9d11773$var$zd
}), $7596fa05f9d11773$var$Vd = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Ud), $7596fa05f9d11773$var$Wd = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $7596fa05f9d11773$var$Xd = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Wd), $7596fa05f9d11773$var$Yd = $7596fa05f9d11773$var$A({}, $7596fa05f9d11773$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $7596fa05f9d11773$var$Zd = $7596fa05f9d11773$var$rd($7596fa05f9d11773$var$Yd), $7596fa05f9d11773$var$$d = [
    9,
    13,
    27,
    32
], $7596fa05f9d11773$var$ae = $7596fa05f9d11773$var$ia && "CompositionEvent" in window, $7596fa05f9d11773$var$be = null;
$7596fa05f9d11773$var$ia && "documentMode" in document && ($7596fa05f9d11773$var$be = document.documentMode);
var $7596fa05f9d11773$var$ce = $7596fa05f9d11773$var$ia && "TextEvent" in window && !$7596fa05f9d11773$var$be, $7596fa05f9d11773$var$de = $7596fa05f9d11773$var$ia && (!$7596fa05f9d11773$var$ae || $7596fa05f9d11773$var$be && 8 < $7596fa05f9d11773$var$be && 11 >= $7596fa05f9d11773$var$be), $7596fa05f9d11773$var$ee = String.fromCharCode(32), $7596fa05f9d11773$var$fe = !1;
function $7596fa05f9d11773$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $7596fa05f9d11773$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $7596fa05f9d11773$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $7596fa05f9d11773$var$ie = !1;
function $7596fa05f9d11773$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $7596fa05f9d11773$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $7596fa05f9d11773$var$fe = !0;
            return $7596fa05f9d11773$var$ee;
        case "textInput":
            return a = b.data, a === $7596fa05f9d11773$var$ee && $7596fa05f9d11773$var$fe ? null : a;
        default:
            return null;
    }
}
function $7596fa05f9d11773$var$ke(a, b) {
    if ($7596fa05f9d11773$var$ie) return "compositionend" === a || !$7596fa05f9d11773$var$ae && $7596fa05f9d11773$var$ge(a, b) ? (a = $7596fa05f9d11773$var$nd(), $7596fa05f9d11773$var$md = $7596fa05f9d11773$var$ld = $7596fa05f9d11773$var$kd = null, $7596fa05f9d11773$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $7596fa05f9d11773$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $7596fa05f9d11773$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $7596fa05f9d11773$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$7596fa05f9d11773$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $7596fa05f9d11773$var$ne(a, b, c, d) {
    $7596fa05f9d11773$var$Eb(d);
    b = $7596fa05f9d11773$var$oe(b, "onChange");
    0 < b.length && (c = new $7596fa05f9d11773$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $7596fa05f9d11773$var$pe = null, $7596fa05f9d11773$var$qe = null;
function $7596fa05f9d11773$var$re(a) {
    $7596fa05f9d11773$var$se(a, 0);
}
function $7596fa05f9d11773$var$te(a) {
    var b = $7596fa05f9d11773$var$ue(a);
    if ($7596fa05f9d11773$var$Wa(b)) return a;
}
function $7596fa05f9d11773$var$ve(a, b) {
    if ("change" === a) return b;
}
var $7596fa05f9d11773$var$we = !1;
if ($7596fa05f9d11773$var$ia) {
    var $7596fa05f9d11773$var$xe;
    if ($7596fa05f9d11773$var$ia) {
        var $7596fa05f9d11773$var$ye = "oninput" in document;
        if (!$7596fa05f9d11773$var$ye) {
            var $7596fa05f9d11773$var$ze = document.createElement("div");
            $7596fa05f9d11773$var$ze.setAttribute("oninput", "return;");
            $7596fa05f9d11773$var$ye = "function" === typeof $7596fa05f9d11773$var$ze.oninput;
        }
        $7596fa05f9d11773$var$xe = $7596fa05f9d11773$var$ye;
    } else $7596fa05f9d11773$var$xe = !1;
    $7596fa05f9d11773$var$we = $7596fa05f9d11773$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $7596fa05f9d11773$var$Ae() {
    $7596fa05f9d11773$var$pe && ($7596fa05f9d11773$var$pe.detachEvent("onpropertychange", $7596fa05f9d11773$var$Be), $7596fa05f9d11773$var$qe = $7596fa05f9d11773$var$pe = null);
}
function $7596fa05f9d11773$var$Be(a) {
    if ("value" === a.propertyName && $7596fa05f9d11773$var$te($7596fa05f9d11773$var$qe)) {
        var b = [];
        $7596fa05f9d11773$var$ne(b, $7596fa05f9d11773$var$qe, a, $7596fa05f9d11773$var$xb(a));
        $7596fa05f9d11773$var$Jb($7596fa05f9d11773$var$re, b);
    }
}
function $7596fa05f9d11773$var$Ce(a, b, c) {
    "focusin" === a ? ($7596fa05f9d11773$var$Ae(), $7596fa05f9d11773$var$pe = b, $7596fa05f9d11773$var$qe = c, $7596fa05f9d11773$var$pe.attachEvent("onpropertychange", $7596fa05f9d11773$var$Be)) : "focusout" === a && $7596fa05f9d11773$var$Ae();
}
function $7596fa05f9d11773$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $7596fa05f9d11773$var$te($7596fa05f9d11773$var$qe);
}
function $7596fa05f9d11773$var$Ee(a, b) {
    if ("click" === a) return $7596fa05f9d11773$var$te(b);
}
function $7596fa05f9d11773$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $7596fa05f9d11773$var$te(b);
}
function $7596fa05f9d11773$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $7596fa05f9d11773$var$He = "function" === typeof Object.is ? Object.is : $7596fa05f9d11773$var$Ge;
function $7596fa05f9d11773$var$Ie(a, b) {
    if ($7596fa05f9d11773$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$7596fa05f9d11773$var$ja.call(b, e) || !$7596fa05f9d11773$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $7596fa05f9d11773$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $7596fa05f9d11773$var$Ke(a, b) {
    var c = $7596fa05f9d11773$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $7596fa05f9d11773$var$Je(c);
    }
}
function $7596fa05f9d11773$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $7596fa05f9d11773$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $7596fa05f9d11773$var$Me() {
    for(var a = window, b = $7596fa05f9d11773$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $7596fa05f9d11773$var$Xa(a.document);
    }
    return b;
}
function $7596fa05f9d11773$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $7596fa05f9d11773$var$Oe(a) {
    var b = $7596fa05f9d11773$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $7596fa05f9d11773$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $7596fa05f9d11773$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $7596fa05f9d11773$var$Ke(c, f);
                var g = $7596fa05f9d11773$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $7596fa05f9d11773$var$Pe = $7596fa05f9d11773$var$ia && "documentMode" in document && 11 >= document.documentMode, $7596fa05f9d11773$var$Qe = null, $7596fa05f9d11773$var$Re = null, $7596fa05f9d11773$var$Se = null, $7596fa05f9d11773$var$Te = !1;
function $7596fa05f9d11773$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $7596fa05f9d11773$var$Te || null == $7596fa05f9d11773$var$Qe || $7596fa05f9d11773$var$Qe !== $7596fa05f9d11773$var$Xa(d) || (d = $7596fa05f9d11773$var$Qe, "selectionStart" in d && $7596fa05f9d11773$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $7596fa05f9d11773$var$Se && $7596fa05f9d11773$var$Ie($7596fa05f9d11773$var$Se, d) || ($7596fa05f9d11773$var$Se = d, d = $7596fa05f9d11773$var$oe($7596fa05f9d11773$var$Re, "onSelect"), 0 < d.length && (b = new $7596fa05f9d11773$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $7596fa05f9d11773$var$Qe)));
}
function $7596fa05f9d11773$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $7596fa05f9d11773$var$We = {
    animationend: $7596fa05f9d11773$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $7596fa05f9d11773$var$Ve("Animation", "AnimationIteration"),
    animationstart: $7596fa05f9d11773$var$Ve("Animation", "AnimationStart"),
    transitionend: $7596fa05f9d11773$var$Ve("Transition", "TransitionEnd")
}, $7596fa05f9d11773$var$Xe = {}, $7596fa05f9d11773$var$Ye = {};
$7596fa05f9d11773$var$ia && ($7596fa05f9d11773$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $7596fa05f9d11773$var$We.animationend.animation, delete $7596fa05f9d11773$var$We.animationiteration.animation, delete $7596fa05f9d11773$var$We.animationstart.animation), "TransitionEvent" in window || delete $7596fa05f9d11773$var$We.transitionend.transition);
function $7596fa05f9d11773$var$Ze(a) {
    if ($7596fa05f9d11773$var$Xe[a]) return $7596fa05f9d11773$var$Xe[a];
    if (!$7596fa05f9d11773$var$We[a]) return a;
    var b = $7596fa05f9d11773$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $7596fa05f9d11773$var$Ye) return $7596fa05f9d11773$var$Xe[a] = b[c];
    return a;
}
var $7596fa05f9d11773$var$$e = $7596fa05f9d11773$var$Ze("animationend"), $7596fa05f9d11773$var$af = $7596fa05f9d11773$var$Ze("animationiteration"), $7596fa05f9d11773$var$bf = $7596fa05f9d11773$var$Ze("animationstart"), $7596fa05f9d11773$var$cf = $7596fa05f9d11773$var$Ze("transitionend"), $7596fa05f9d11773$var$df = new Map, $7596fa05f9d11773$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $7596fa05f9d11773$var$ff(a, b) {
    $7596fa05f9d11773$var$df.set(a, b);
    $7596fa05f9d11773$var$fa(b, [
        a
    ]);
}
for(var $7596fa05f9d11773$var$gf = 0; $7596fa05f9d11773$var$gf < $7596fa05f9d11773$var$ef.length; $7596fa05f9d11773$var$gf++){
    var $7596fa05f9d11773$var$hf = $7596fa05f9d11773$var$ef[$7596fa05f9d11773$var$gf], $7596fa05f9d11773$var$jf = $7596fa05f9d11773$var$hf.toLowerCase(), $7596fa05f9d11773$var$kf = $7596fa05f9d11773$var$hf[0].toUpperCase() + $7596fa05f9d11773$var$hf.slice(1);
    $7596fa05f9d11773$var$ff($7596fa05f9d11773$var$jf, "on" + $7596fa05f9d11773$var$kf);
}
$7596fa05f9d11773$var$ff($7596fa05f9d11773$var$$e, "onAnimationEnd");
$7596fa05f9d11773$var$ff($7596fa05f9d11773$var$af, "onAnimationIteration");
$7596fa05f9d11773$var$ff($7596fa05f9d11773$var$bf, "onAnimationStart");
$7596fa05f9d11773$var$ff("dblclick", "onDoubleClick");
$7596fa05f9d11773$var$ff("focusin", "onFocus");
$7596fa05f9d11773$var$ff("focusout", "onBlur");
$7596fa05f9d11773$var$ff($7596fa05f9d11773$var$cf, "onTransitionEnd");
$7596fa05f9d11773$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$7596fa05f9d11773$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$7596fa05f9d11773$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$7596fa05f9d11773$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$7596fa05f9d11773$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$7596fa05f9d11773$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$7596fa05f9d11773$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$7596fa05f9d11773$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$7596fa05f9d11773$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$7596fa05f9d11773$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $7596fa05f9d11773$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $7596fa05f9d11773$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($7596fa05f9d11773$var$lf));
function $7596fa05f9d11773$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $7596fa05f9d11773$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $7596fa05f9d11773$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $7596fa05f9d11773$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $7596fa05f9d11773$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($7596fa05f9d11773$var$Qb) throw a = $7596fa05f9d11773$var$Rb, $7596fa05f9d11773$var$Qb = !1, $7596fa05f9d11773$var$Rb = null, a;
}
function $7596fa05f9d11773$var$D(a, b) {
    var c = b[$7596fa05f9d11773$var$of];
    void 0 === c && (c = b[$7596fa05f9d11773$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($7596fa05f9d11773$var$pf(b, a, 2, !1), c.add(d));
}
function $7596fa05f9d11773$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $7596fa05f9d11773$var$pf(c, a, d, b);
}
var $7596fa05f9d11773$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $7596fa05f9d11773$var$sf(a) {
    if (!a[$7596fa05f9d11773$var$rf]) {
        a[$7596fa05f9d11773$var$rf] = !0;
        $7596fa05f9d11773$var$da.forEach(function(b) {
            "selectionchange" !== b && ($7596fa05f9d11773$var$mf.has(b) || $7596fa05f9d11773$var$qf(b, !1, a), $7596fa05f9d11773$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$7596fa05f9d11773$var$rf] || (b[$7596fa05f9d11773$var$rf] = !0, $7596fa05f9d11773$var$qf("selectionchange", !1, b));
    }
}
function $7596fa05f9d11773$var$pf(a, b, c, d) {
    switch($7596fa05f9d11773$var$jd(b)){
        case 1:
            var e = $7596fa05f9d11773$var$ed;
            break;
        case 4:
            e = $7596fa05f9d11773$var$gd;
            break;
        default:
            e = $7596fa05f9d11773$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$7596fa05f9d11773$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $7596fa05f9d11773$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $7596fa05f9d11773$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $7596fa05f9d11773$var$Jb(function() {
        var d = f, e = $7596fa05f9d11773$var$xb(c), g = [];
        a: {
            var h = $7596fa05f9d11773$var$df.get(a);
            if (void 0 !== h) {
                var k = $7596fa05f9d11773$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $7596fa05f9d11773$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $7596fa05f9d11773$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $7596fa05f9d11773$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $7596fa05f9d11773$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $7596fa05f9d11773$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $7596fa05f9d11773$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $7596fa05f9d11773$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $7596fa05f9d11773$var$Vd;
                        break;
                    case $7596fa05f9d11773$var$$e:
                    case $7596fa05f9d11773$var$af:
                    case $7596fa05f9d11773$var$bf:
                        k = $7596fa05f9d11773$var$Hd;
                        break;
                    case $7596fa05f9d11773$var$cf:
                        k = $7596fa05f9d11773$var$Xd;
                        break;
                    case "scroll":
                        k = $7596fa05f9d11773$var$vd;
                        break;
                    case "wheel":
                        k = $7596fa05f9d11773$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $7596fa05f9d11773$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $7596fa05f9d11773$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $7596fa05f9d11773$var$Kb(w, x), null != F && t.push($7596fa05f9d11773$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $7596fa05f9d11773$var$wb && (n = c.relatedTarget || c.fromElement) && ($7596fa05f9d11773$var$Wc(n) || n[$7596fa05f9d11773$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $7596fa05f9d11773$var$Wc(n) : null, null !== n && (J = $7596fa05f9d11773$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $7596fa05f9d11773$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $7596fa05f9d11773$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $7596fa05f9d11773$var$ue(k);
                        u = null == n ? h : $7596fa05f9d11773$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $7596fa05f9d11773$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $7596fa05f9d11773$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $7596fa05f9d11773$var$vf(F))u++;
                            for(; 0 < w - u;)t = $7596fa05f9d11773$var$vf(t), w--;
                            for(; 0 < u - w;)x = $7596fa05f9d11773$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $7596fa05f9d11773$var$vf(t);
                                x = $7596fa05f9d11773$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $7596fa05f9d11773$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $7596fa05f9d11773$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $7596fa05f9d11773$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $7596fa05f9d11773$var$ve;
                else if ($7596fa05f9d11773$var$me(h)) {
                    if ($7596fa05f9d11773$var$we) na = $7596fa05f9d11773$var$Fe;
                    else {
                        na = $7596fa05f9d11773$var$De;
                        var xa = $7596fa05f9d11773$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $7596fa05f9d11773$var$Ee);
                if (na && (na = na(a, d))) {
                    $7596fa05f9d11773$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $7596fa05f9d11773$var$cb(h, "number", h.value);
            }
            xa = d ? $7596fa05f9d11773$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($7596fa05f9d11773$var$me(xa) || "true" === xa.contentEditable) $7596fa05f9d11773$var$Qe = xa, $7596fa05f9d11773$var$Re = d, $7596fa05f9d11773$var$Se = null;
                    break;
                case "focusout":
                    $7596fa05f9d11773$var$Se = $7596fa05f9d11773$var$Re = $7596fa05f9d11773$var$Qe = null;
                    break;
                case "mousedown":
                    $7596fa05f9d11773$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $7596fa05f9d11773$var$Te = !1;
                    $7596fa05f9d11773$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($7596fa05f9d11773$var$Pe) break;
                case "keydown":
                case "keyup":
                    $7596fa05f9d11773$var$Ue(g, c, e);
            }
            var $a;
            if ($7596fa05f9d11773$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $7596fa05f9d11773$var$ie ? $7596fa05f9d11773$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($7596fa05f9d11773$var$de && "ko" !== c.locale && ($7596fa05f9d11773$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $7596fa05f9d11773$var$ie && ($a = $7596fa05f9d11773$var$nd()) : ($7596fa05f9d11773$var$kd = e, $7596fa05f9d11773$var$ld = "value" in $7596fa05f9d11773$var$kd ? $7596fa05f9d11773$var$kd.value : $7596fa05f9d11773$var$kd.textContent, $7596fa05f9d11773$var$ie = !0)), xa = $7596fa05f9d11773$var$oe(d, ba), 0 < xa.length && (ba = new $7596fa05f9d11773$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $7596fa05f9d11773$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $7596fa05f9d11773$var$ce ? $7596fa05f9d11773$var$je(a, c) : $7596fa05f9d11773$var$ke(a, c)) d = $7596fa05f9d11773$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $7596fa05f9d11773$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $7596fa05f9d11773$var$se(g, b);
    });
}
function $7596fa05f9d11773$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $7596fa05f9d11773$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $7596fa05f9d11773$var$Kb(a, c), null != f && d.unshift($7596fa05f9d11773$var$tf(a, f, e)), f = $7596fa05f9d11773$var$Kb(a, b), null != f && d.push($7596fa05f9d11773$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $7596fa05f9d11773$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $7596fa05f9d11773$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $7596fa05f9d11773$var$Kb(c, f), null != k && g.unshift($7596fa05f9d11773$var$tf(c, k, h))) : e || (k = $7596fa05f9d11773$var$Kb(c, f), null != k && g.push($7596fa05f9d11773$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $7596fa05f9d11773$var$xf = /\r\n?/g, $7596fa05f9d11773$var$yf = /\u0000|\uFFFD/g;
function $7596fa05f9d11773$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($7596fa05f9d11773$var$xf, "\n").replace($7596fa05f9d11773$var$yf, "");
}
function $7596fa05f9d11773$var$Af(a, b, c) {
    b = $7596fa05f9d11773$var$zf(b);
    if ($7596fa05f9d11773$var$zf(a) !== b && c) throw Error($7596fa05f9d11773$var$p(425));
}
function $7596fa05f9d11773$var$Bf() {}
var $7596fa05f9d11773$var$Cf = null, $7596fa05f9d11773$var$Df = null;
function $7596fa05f9d11773$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $7596fa05f9d11773$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $7596fa05f9d11773$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $7596fa05f9d11773$var$Hf = "function" === typeof Promise ? Promise : void 0, $7596fa05f9d11773$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $7596fa05f9d11773$var$Hf ? function(a) {
    return $7596fa05f9d11773$var$Hf.resolve(null).then(a).catch($7596fa05f9d11773$var$If);
} : $7596fa05f9d11773$var$Ff;
function $7596fa05f9d11773$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $7596fa05f9d11773$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $7596fa05f9d11773$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $7596fa05f9d11773$var$bd(b);
}
function $7596fa05f9d11773$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $7596fa05f9d11773$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $7596fa05f9d11773$var$Nf = Math.random().toString(36).slice(2), $7596fa05f9d11773$var$Of = "__reactFiber$" + $7596fa05f9d11773$var$Nf, $7596fa05f9d11773$var$Pf = "__reactProps$" + $7596fa05f9d11773$var$Nf, $7596fa05f9d11773$var$uf = "__reactContainer$" + $7596fa05f9d11773$var$Nf, $7596fa05f9d11773$var$of = "__reactEvents$" + $7596fa05f9d11773$var$Nf, $7596fa05f9d11773$var$Qf = "__reactListeners$" + $7596fa05f9d11773$var$Nf, $7596fa05f9d11773$var$Rf = "__reactHandles$" + $7596fa05f9d11773$var$Nf;
function $7596fa05f9d11773$var$Wc(a) {
    var b = a[$7596fa05f9d11773$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$7596fa05f9d11773$var$uf] || c[$7596fa05f9d11773$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $7596fa05f9d11773$var$Mf(a); null !== a;){
                if (c = a[$7596fa05f9d11773$var$Of]) return c;
                a = $7596fa05f9d11773$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $7596fa05f9d11773$var$Cb(a) {
    a = a[$7596fa05f9d11773$var$Of] || a[$7596fa05f9d11773$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $7596fa05f9d11773$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($7596fa05f9d11773$var$p(33));
}
function $7596fa05f9d11773$var$Db(a) {
    return a[$7596fa05f9d11773$var$Pf] || null;
}
var $7596fa05f9d11773$var$Sf = [], $7596fa05f9d11773$var$Tf = -1;
function $7596fa05f9d11773$var$Uf(a) {
    return {
        current: a
    };
}
function $7596fa05f9d11773$var$E(a) {
    0 > $7596fa05f9d11773$var$Tf || (a.current = $7596fa05f9d11773$var$Sf[$7596fa05f9d11773$var$Tf], $7596fa05f9d11773$var$Sf[$7596fa05f9d11773$var$Tf] = null, $7596fa05f9d11773$var$Tf--);
}
function $7596fa05f9d11773$var$G(a, b) {
    $7596fa05f9d11773$var$Tf++;
    $7596fa05f9d11773$var$Sf[$7596fa05f9d11773$var$Tf] = a.current;
    a.current = b;
}
var $7596fa05f9d11773$var$Vf = {}, $7596fa05f9d11773$var$H = $7596fa05f9d11773$var$Uf($7596fa05f9d11773$var$Vf), $7596fa05f9d11773$var$Wf = $7596fa05f9d11773$var$Uf(!1), $7596fa05f9d11773$var$Xf = $7596fa05f9d11773$var$Vf;
function $7596fa05f9d11773$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $7596fa05f9d11773$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $7596fa05f9d11773$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $7596fa05f9d11773$var$$f() {
    $7596fa05f9d11773$var$E($7596fa05f9d11773$var$Wf);
    $7596fa05f9d11773$var$E($7596fa05f9d11773$var$H);
}
function $7596fa05f9d11773$var$ag(a, b, c) {
    if ($7596fa05f9d11773$var$H.current !== $7596fa05f9d11773$var$Vf) throw Error($7596fa05f9d11773$var$p(168));
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$H, b);
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$Wf, c);
}
function $7596fa05f9d11773$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($7596fa05f9d11773$var$p(108, $7596fa05f9d11773$var$Ra(a) || "Unknown", e));
    return $7596fa05f9d11773$var$A({}, c, d);
}
function $7596fa05f9d11773$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $7596fa05f9d11773$var$Vf;
    $7596fa05f9d11773$var$Xf = $7596fa05f9d11773$var$H.current;
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$H, a);
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$Wf, $7596fa05f9d11773$var$Wf.current);
    return !0;
}
function $7596fa05f9d11773$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($7596fa05f9d11773$var$p(169));
    c ? (a = $7596fa05f9d11773$var$bg(a, b, $7596fa05f9d11773$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $7596fa05f9d11773$var$E($7596fa05f9d11773$var$Wf), $7596fa05f9d11773$var$E($7596fa05f9d11773$var$H), $7596fa05f9d11773$var$G($7596fa05f9d11773$var$H, a)) : $7596fa05f9d11773$var$E($7596fa05f9d11773$var$Wf);
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$Wf, c);
}
var $7596fa05f9d11773$var$eg = null, $7596fa05f9d11773$var$fg = !1, $7596fa05f9d11773$var$gg = !1;
function $7596fa05f9d11773$var$hg(a) {
    null === $7596fa05f9d11773$var$eg ? $7596fa05f9d11773$var$eg = [
        a
    ] : $7596fa05f9d11773$var$eg.push(a);
}
function $7596fa05f9d11773$var$ig(a) {
    $7596fa05f9d11773$var$fg = !0;
    $7596fa05f9d11773$var$hg(a);
}
function $7596fa05f9d11773$var$jg() {
    if (!$7596fa05f9d11773$var$gg && null !== $7596fa05f9d11773$var$eg) {
        $7596fa05f9d11773$var$gg = !0;
        var a = 0, b = $7596fa05f9d11773$var$C;
        try {
            var c = $7596fa05f9d11773$var$eg;
            for($7596fa05f9d11773$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $7596fa05f9d11773$var$eg = null;
            $7596fa05f9d11773$var$fg = !1;
        } catch (e) {
            throw null !== $7596fa05f9d11773$var$eg && ($7596fa05f9d11773$var$eg = $7596fa05f9d11773$var$eg.slice(a + 1)), $7596fa05f9d11773$var$ac($7596fa05f9d11773$var$fc, $7596fa05f9d11773$var$jg), e;
        } finally{
            $7596fa05f9d11773$var$C = b, $7596fa05f9d11773$var$gg = !1;
        }
    }
    return null;
}
var $7596fa05f9d11773$var$kg = [], $7596fa05f9d11773$var$lg = 0, $7596fa05f9d11773$var$mg = null, $7596fa05f9d11773$var$ng = 0, $7596fa05f9d11773$var$og = [], $7596fa05f9d11773$var$pg = 0, $7596fa05f9d11773$var$qg = null, $7596fa05f9d11773$var$rg = 1, $7596fa05f9d11773$var$sg = "";
function $7596fa05f9d11773$var$tg(a, b) {
    $7596fa05f9d11773$var$kg[$7596fa05f9d11773$var$lg++] = $7596fa05f9d11773$var$ng;
    $7596fa05f9d11773$var$kg[$7596fa05f9d11773$var$lg++] = $7596fa05f9d11773$var$mg;
    $7596fa05f9d11773$var$mg = a;
    $7596fa05f9d11773$var$ng = b;
}
function $7596fa05f9d11773$var$ug(a, b, c) {
    $7596fa05f9d11773$var$og[$7596fa05f9d11773$var$pg++] = $7596fa05f9d11773$var$rg;
    $7596fa05f9d11773$var$og[$7596fa05f9d11773$var$pg++] = $7596fa05f9d11773$var$sg;
    $7596fa05f9d11773$var$og[$7596fa05f9d11773$var$pg++] = $7596fa05f9d11773$var$qg;
    $7596fa05f9d11773$var$qg = a;
    var d = $7596fa05f9d11773$var$rg;
    a = $7596fa05f9d11773$var$sg;
    var e = 32 - $7596fa05f9d11773$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $7596fa05f9d11773$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $7596fa05f9d11773$var$rg = 1 << 32 - $7596fa05f9d11773$var$oc(b) + e | c << e | d;
        $7596fa05f9d11773$var$sg = f + a;
    } else $7596fa05f9d11773$var$rg = 1 << f | c << e | d, $7596fa05f9d11773$var$sg = a;
}
function $7596fa05f9d11773$var$vg(a) {
    null !== a.return && ($7596fa05f9d11773$var$tg(a, 1), $7596fa05f9d11773$var$ug(a, 1, 0));
}
function $7596fa05f9d11773$var$wg(a) {
    for(; a === $7596fa05f9d11773$var$mg;)$7596fa05f9d11773$var$mg = $7596fa05f9d11773$var$kg[--$7596fa05f9d11773$var$lg], $7596fa05f9d11773$var$kg[$7596fa05f9d11773$var$lg] = null, $7596fa05f9d11773$var$ng = $7596fa05f9d11773$var$kg[--$7596fa05f9d11773$var$lg], $7596fa05f9d11773$var$kg[$7596fa05f9d11773$var$lg] = null;
    for(; a === $7596fa05f9d11773$var$qg;)$7596fa05f9d11773$var$qg = $7596fa05f9d11773$var$og[--$7596fa05f9d11773$var$pg], $7596fa05f9d11773$var$og[$7596fa05f9d11773$var$pg] = null, $7596fa05f9d11773$var$sg = $7596fa05f9d11773$var$og[--$7596fa05f9d11773$var$pg], $7596fa05f9d11773$var$og[$7596fa05f9d11773$var$pg] = null, $7596fa05f9d11773$var$rg = $7596fa05f9d11773$var$og[--$7596fa05f9d11773$var$pg], $7596fa05f9d11773$var$og[$7596fa05f9d11773$var$pg] = null;
}
var $7596fa05f9d11773$var$xg = null, $7596fa05f9d11773$var$yg = null, $7596fa05f9d11773$var$I = !1, $7596fa05f9d11773$var$zg = null;
function $7596fa05f9d11773$var$Ag(a, b) {
    var c = $7596fa05f9d11773$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $7596fa05f9d11773$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $7596fa05f9d11773$var$xg = a, $7596fa05f9d11773$var$yg = $7596fa05f9d11773$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $7596fa05f9d11773$var$xg = a, $7596fa05f9d11773$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $7596fa05f9d11773$var$qg ? {
                id: $7596fa05f9d11773$var$rg,
                overflow: $7596fa05f9d11773$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $7596fa05f9d11773$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $7596fa05f9d11773$var$xg = a, $7596fa05f9d11773$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $7596fa05f9d11773$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $7596fa05f9d11773$var$Eg(a) {
    if ($7596fa05f9d11773$var$I) {
        var b = $7596fa05f9d11773$var$yg;
        if (b) {
            var c = b;
            if (!$7596fa05f9d11773$var$Cg(a, b)) {
                if ($7596fa05f9d11773$var$Dg(a)) throw Error($7596fa05f9d11773$var$p(418));
                b = $7596fa05f9d11773$var$Lf(c.nextSibling);
                var d = $7596fa05f9d11773$var$xg;
                b && $7596fa05f9d11773$var$Cg(a, b) ? $7596fa05f9d11773$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $7596fa05f9d11773$var$I = !1, $7596fa05f9d11773$var$xg = a);
            }
        } else {
            if ($7596fa05f9d11773$var$Dg(a)) throw Error($7596fa05f9d11773$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $7596fa05f9d11773$var$I = !1;
            $7596fa05f9d11773$var$xg = a;
        }
    }
}
function $7596fa05f9d11773$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $7596fa05f9d11773$var$xg = a;
}
function $7596fa05f9d11773$var$Gg(a) {
    if (a !== $7596fa05f9d11773$var$xg) return !1;
    if (!$7596fa05f9d11773$var$I) return $7596fa05f9d11773$var$Fg(a), $7596fa05f9d11773$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$7596fa05f9d11773$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $7596fa05f9d11773$var$yg)) {
        if ($7596fa05f9d11773$var$Dg(a)) throw $7596fa05f9d11773$var$Hg(), Error($7596fa05f9d11773$var$p(418));
        for(; b;)$7596fa05f9d11773$var$Ag(a, b), b = $7596fa05f9d11773$var$Lf(b.nextSibling);
    }
    $7596fa05f9d11773$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($7596fa05f9d11773$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $7596fa05f9d11773$var$yg = $7596fa05f9d11773$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $7596fa05f9d11773$var$yg = null;
        }
    } else $7596fa05f9d11773$var$yg = $7596fa05f9d11773$var$xg ? $7596fa05f9d11773$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $7596fa05f9d11773$var$Hg() {
    for(var a = $7596fa05f9d11773$var$yg; a;)a = $7596fa05f9d11773$var$Lf(a.nextSibling);
}
function $7596fa05f9d11773$var$Ig() {
    $7596fa05f9d11773$var$yg = $7596fa05f9d11773$var$xg = null;
    $7596fa05f9d11773$var$I = !1;
}
function $7596fa05f9d11773$var$Jg(a) {
    null === $7596fa05f9d11773$var$zg ? $7596fa05f9d11773$var$zg = [
        a
    ] : $7596fa05f9d11773$var$zg.push(a);
}
var $7596fa05f9d11773$var$Kg = $7596fa05f9d11773$var$ua.ReactCurrentBatchConfig;
function $7596fa05f9d11773$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($7596fa05f9d11773$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($7596fa05f9d11773$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($7596fa05f9d11773$var$p(284));
        if (!c._owner) throw Error($7596fa05f9d11773$var$p(290, a));
    }
    return a;
}
function $7596fa05f9d11773$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($7596fa05f9d11773$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $7596fa05f9d11773$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $7596fa05f9d11773$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $7596fa05f9d11773$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $7596fa05f9d11773$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $7596fa05f9d11773$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $7596fa05f9d11773$var$Ha && $7596fa05f9d11773$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $7596fa05f9d11773$var$Lg(a, b, c), d.return = a, d;
        d = $7596fa05f9d11773$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $7596fa05f9d11773$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $7596fa05f9d11773$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $7596fa05f9d11773$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $7596fa05f9d11773$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $7596fa05f9d11773$var$va:
                    return c = $7596fa05f9d11773$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $7596fa05f9d11773$var$Lg(a, null, b), c.return = a, c;
                case $7596fa05f9d11773$var$wa:
                    return b = $7596fa05f9d11773$var$Sg(b, a.mode, c), b.return = a, b;
                case $7596fa05f9d11773$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($7596fa05f9d11773$var$eb(b) || $7596fa05f9d11773$var$Ka(b)) return b = $7596fa05f9d11773$var$Tg(b, a.mode, c, null), b.return = a, b;
            $7596fa05f9d11773$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $7596fa05f9d11773$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $7596fa05f9d11773$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $7596fa05f9d11773$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($7596fa05f9d11773$var$eb(c) || $7596fa05f9d11773$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $7596fa05f9d11773$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $7596fa05f9d11773$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $7596fa05f9d11773$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $7596fa05f9d11773$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($7596fa05f9d11773$var$eb(d) || $7596fa05f9d11773$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $7596fa05f9d11773$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $7596fa05f9d11773$var$I && $7596fa05f9d11773$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $7596fa05f9d11773$var$I && $7596fa05f9d11773$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $7596fa05f9d11773$var$I && $7596fa05f9d11773$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $7596fa05f9d11773$var$Ka(h);
        if ("function" !== typeof l) throw Error($7596fa05f9d11773$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($7596fa05f9d11773$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $7596fa05f9d11773$var$I && $7596fa05f9d11773$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $7596fa05f9d11773$var$I && $7596fa05f9d11773$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $7596fa05f9d11773$var$I && $7596fa05f9d11773$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $7596fa05f9d11773$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $7596fa05f9d11773$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $7596fa05f9d11773$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $7596fa05f9d11773$var$Ha && $7596fa05f9d11773$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $7596fa05f9d11773$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $7596fa05f9d11773$var$ya ? (d = $7596fa05f9d11773$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $7596fa05f9d11773$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $7596fa05f9d11773$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $7596fa05f9d11773$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $7596fa05f9d11773$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $7596fa05f9d11773$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($7596fa05f9d11773$var$eb(f)) return n(a, d, f, h);
            if ($7596fa05f9d11773$var$Ka(f)) return t(a, d, f, h);
            $7596fa05f9d11773$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $7596fa05f9d11773$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $7596fa05f9d11773$var$Ug = $7596fa05f9d11773$var$Og(!0), $7596fa05f9d11773$var$Vg = $7596fa05f9d11773$var$Og(!1), $7596fa05f9d11773$var$Wg = $7596fa05f9d11773$var$Uf(null), $7596fa05f9d11773$var$Xg = null, $7596fa05f9d11773$var$Yg = null, $7596fa05f9d11773$var$Zg = null;
function $7596fa05f9d11773$var$$g() {
    $7596fa05f9d11773$var$Zg = $7596fa05f9d11773$var$Yg = $7596fa05f9d11773$var$Xg = null;
}
function $7596fa05f9d11773$var$ah(a) {
    var b = $7596fa05f9d11773$var$Wg.current;
    $7596fa05f9d11773$var$E($7596fa05f9d11773$var$Wg);
    a._currentValue = b;
}
function $7596fa05f9d11773$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $7596fa05f9d11773$var$ch(a, b) {
    $7596fa05f9d11773$var$Xg = a;
    $7596fa05f9d11773$var$Zg = $7596fa05f9d11773$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($7596fa05f9d11773$var$dh = !0), a.firstContext = null);
}
function $7596fa05f9d11773$var$eh(a) {
    var b = a._currentValue;
    if ($7596fa05f9d11773$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $7596fa05f9d11773$var$Yg) {
            if (null === $7596fa05f9d11773$var$Xg) throw Error($7596fa05f9d11773$var$p(308));
            $7596fa05f9d11773$var$Yg = a;
            $7596fa05f9d11773$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $7596fa05f9d11773$var$Yg = $7596fa05f9d11773$var$Yg.next = a;
    }
    return b;
}
var $7596fa05f9d11773$var$fh = null;
function $7596fa05f9d11773$var$gh(a) {
    null === $7596fa05f9d11773$var$fh ? $7596fa05f9d11773$var$fh = [
        a
    ] : $7596fa05f9d11773$var$fh.push(a);
}
function $7596fa05f9d11773$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $7596fa05f9d11773$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $7596fa05f9d11773$var$ih(a, d);
}
function $7596fa05f9d11773$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $7596fa05f9d11773$var$jh = !1;
function $7596fa05f9d11773$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $7596fa05f9d11773$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $7596fa05f9d11773$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $7596fa05f9d11773$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($7596fa05f9d11773$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $7596fa05f9d11773$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $7596fa05f9d11773$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $7596fa05f9d11773$var$ih(a, c);
}
function $7596fa05f9d11773$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $7596fa05f9d11773$var$Cc(a, c);
    }
}
function $7596fa05f9d11773$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $7596fa05f9d11773$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $7596fa05f9d11773$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $7596fa05f9d11773$var$A({}, q, r);
                            break a;
                        case 2:
                            $7596fa05f9d11773$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $7596fa05f9d11773$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $7596fa05f9d11773$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($7596fa05f9d11773$var$p(191, e));
            e.call(d);
        }
    }
}
var $7596fa05f9d11773$var$th = {}, $7596fa05f9d11773$var$uh = $7596fa05f9d11773$var$Uf($7596fa05f9d11773$var$th), $7596fa05f9d11773$var$vh = $7596fa05f9d11773$var$Uf($7596fa05f9d11773$var$th), $7596fa05f9d11773$var$wh = $7596fa05f9d11773$var$Uf($7596fa05f9d11773$var$th);
function $7596fa05f9d11773$var$xh(a) {
    if (a === $7596fa05f9d11773$var$th) throw Error($7596fa05f9d11773$var$p(174));
    return a;
}
function $7596fa05f9d11773$var$yh(a, b) {
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$wh, b);
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$vh, a);
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$uh, $7596fa05f9d11773$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $7596fa05f9d11773$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $7596fa05f9d11773$var$lb(b, a);
    }
    $7596fa05f9d11773$var$E($7596fa05f9d11773$var$uh);
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$uh, b);
}
function $7596fa05f9d11773$var$zh() {
    $7596fa05f9d11773$var$E($7596fa05f9d11773$var$uh);
    $7596fa05f9d11773$var$E($7596fa05f9d11773$var$vh);
    $7596fa05f9d11773$var$E($7596fa05f9d11773$var$wh);
}
function $7596fa05f9d11773$var$Ah(a) {
    $7596fa05f9d11773$var$xh($7596fa05f9d11773$var$wh.current);
    var b = $7596fa05f9d11773$var$xh($7596fa05f9d11773$var$uh.current);
    var c = $7596fa05f9d11773$var$lb(b, a.type);
    b !== c && ($7596fa05f9d11773$var$G($7596fa05f9d11773$var$vh, a), $7596fa05f9d11773$var$G($7596fa05f9d11773$var$uh, c));
}
function $7596fa05f9d11773$var$Bh(a) {
    $7596fa05f9d11773$var$vh.current === a && ($7596fa05f9d11773$var$E($7596fa05f9d11773$var$uh), $7596fa05f9d11773$var$E($7596fa05f9d11773$var$vh));
}
var $7596fa05f9d11773$var$L = $7596fa05f9d11773$var$Uf(0);
function $7596fa05f9d11773$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $7596fa05f9d11773$var$Dh = [];
function $7596fa05f9d11773$var$Eh() {
    for(var a = 0; a < $7596fa05f9d11773$var$Dh.length; a++)$7596fa05f9d11773$var$Dh[a]._workInProgressVersionPrimary = null;
    $7596fa05f9d11773$var$Dh.length = 0;
}
var $7596fa05f9d11773$var$Fh = $7596fa05f9d11773$var$ua.ReactCurrentDispatcher, $7596fa05f9d11773$var$Gh = $7596fa05f9d11773$var$ua.ReactCurrentBatchConfig, $7596fa05f9d11773$var$Hh = 0, $7596fa05f9d11773$var$M = null, $7596fa05f9d11773$var$N = null, $7596fa05f9d11773$var$O = null, $7596fa05f9d11773$var$Ih = !1, $7596fa05f9d11773$var$Jh = !1, $7596fa05f9d11773$var$Kh = 0, $7596fa05f9d11773$var$Lh = 0;
function $7596fa05f9d11773$var$P() {
    throw Error($7596fa05f9d11773$var$p(321));
}
function $7596fa05f9d11773$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$7596fa05f9d11773$var$He(a[c], b[c])) return !1;
    return !0;
}
function $7596fa05f9d11773$var$Nh(a, b, c, d, e, f) {
    $7596fa05f9d11773$var$Hh = f;
    $7596fa05f9d11773$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $7596fa05f9d11773$var$Fh.current = null === a || null === a.memoizedState ? $7596fa05f9d11773$var$Oh : $7596fa05f9d11773$var$Ph;
    a = c(d, e);
    if ($7596fa05f9d11773$var$Jh) {
        f = 0;
        do {
            $7596fa05f9d11773$var$Jh = !1;
            $7596fa05f9d11773$var$Kh = 0;
            if (25 <= f) throw Error($7596fa05f9d11773$var$p(301));
            f += 1;
            $7596fa05f9d11773$var$O = $7596fa05f9d11773$var$N = null;
            b.updateQueue = null;
            $7596fa05f9d11773$var$Fh.current = $7596fa05f9d11773$var$Qh;
            a = c(d, e);
        }while ($7596fa05f9d11773$var$Jh);
    }
    $7596fa05f9d11773$var$Fh.current = $7596fa05f9d11773$var$Rh;
    b = null !== $7596fa05f9d11773$var$N && null !== $7596fa05f9d11773$var$N.next;
    $7596fa05f9d11773$var$Hh = 0;
    $7596fa05f9d11773$var$O = $7596fa05f9d11773$var$N = $7596fa05f9d11773$var$M = null;
    $7596fa05f9d11773$var$Ih = !1;
    if (b) throw Error($7596fa05f9d11773$var$p(300));
    return a;
}
function $7596fa05f9d11773$var$Sh() {
    var a = 0 !== $7596fa05f9d11773$var$Kh;
    $7596fa05f9d11773$var$Kh = 0;
    return a;
}
function $7596fa05f9d11773$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $7596fa05f9d11773$var$O ? $7596fa05f9d11773$var$M.memoizedState = $7596fa05f9d11773$var$O = a : $7596fa05f9d11773$var$O = $7596fa05f9d11773$var$O.next = a;
    return $7596fa05f9d11773$var$O;
}
function $7596fa05f9d11773$var$Uh() {
    if (null === $7596fa05f9d11773$var$N) {
        var a = $7596fa05f9d11773$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $7596fa05f9d11773$var$N.next;
    var b = null === $7596fa05f9d11773$var$O ? $7596fa05f9d11773$var$M.memoizedState : $7596fa05f9d11773$var$O.next;
    if (null !== b) $7596fa05f9d11773$var$O = b, $7596fa05f9d11773$var$N = a;
    else {
        if (null === a) throw Error($7596fa05f9d11773$var$p(310));
        $7596fa05f9d11773$var$N = a;
        a = {
            memoizedState: $7596fa05f9d11773$var$N.memoizedState,
            baseState: $7596fa05f9d11773$var$N.baseState,
            baseQueue: $7596fa05f9d11773$var$N.baseQueue,
            queue: $7596fa05f9d11773$var$N.queue,
            next: null
        };
        null === $7596fa05f9d11773$var$O ? $7596fa05f9d11773$var$M.memoizedState = $7596fa05f9d11773$var$O = a : $7596fa05f9d11773$var$O = $7596fa05f9d11773$var$O.next = a;
    }
    return $7596fa05f9d11773$var$O;
}
function $7596fa05f9d11773$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $7596fa05f9d11773$var$Wh(a) {
    var b = $7596fa05f9d11773$var$Uh(), c = b.queue;
    if (null === c) throw Error($7596fa05f9d11773$var$p(311));
    c.lastRenderedReducer = a;
    var d = $7596fa05f9d11773$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($7596fa05f9d11773$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $7596fa05f9d11773$var$M.lanes |= m;
                $7596fa05f9d11773$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $7596fa05f9d11773$var$He(d, b.memoizedState) || ($7596fa05f9d11773$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $7596fa05f9d11773$var$M.lanes |= f, $7596fa05f9d11773$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $7596fa05f9d11773$var$Xh(a) {
    var b = $7596fa05f9d11773$var$Uh(), c = b.queue;
    if (null === c) throw Error($7596fa05f9d11773$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $7596fa05f9d11773$var$He(f, b.memoizedState) || ($7596fa05f9d11773$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $7596fa05f9d11773$var$Yh() {}
function $7596fa05f9d11773$var$Zh(a, b) {
    var c = $7596fa05f9d11773$var$M, d = $7596fa05f9d11773$var$Uh(), e = b(), f = !$7596fa05f9d11773$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $7596fa05f9d11773$var$dh = !0);
    d = d.queue;
    $7596fa05f9d11773$var$$h($7596fa05f9d11773$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $7596fa05f9d11773$var$O && $7596fa05f9d11773$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $7596fa05f9d11773$var$bi(9, $7596fa05f9d11773$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $7596fa05f9d11773$var$Q) throw Error($7596fa05f9d11773$var$p(349));
        0 !== ($7596fa05f9d11773$var$Hh & 30) || $7596fa05f9d11773$var$di(c, b, e);
    }
    return e;
}
function $7596fa05f9d11773$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $7596fa05f9d11773$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $7596fa05f9d11773$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $7596fa05f9d11773$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $7596fa05f9d11773$var$ei(b) && $7596fa05f9d11773$var$fi(a);
}
function $7596fa05f9d11773$var$ai(a, b, c) {
    return c(function() {
        $7596fa05f9d11773$var$ei(b) && $7596fa05f9d11773$var$fi(a);
    });
}
function $7596fa05f9d11773$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$7596fa05f9d11773$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $7596fa05f9d11773$var$fi(a) {
    var b = $7596fa05f9d11773$var$ih(a, 1);
    null !== b && $7596fa05f9d11773$var$gi(b, a, 1, -1);
}
function $7596fa05f9d11773$var$hi(a) {
    var b = $7596fa05f9d11773$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $7596fa05f9d11773$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $7596fa05f9d11773$var$ii.bind(null, $7596fa05f9d11773$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $7596fa05f9d11773$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $7596fa05f9d11773$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $7596fa05f9d11773$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $7596fa05f9d11773$var$ji() {
    return $7596fa05f9d11773$var$Uh().memoizedState;
}
function $7596fa05f9d11773$var$ki(a, b, c, d) {
    var e = $7596fa05f9d11773$var$Th();
    $7596fa05f9d11773$var$M.flags |= a;
    e.memoizedState = $7596fa05f9d11773$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $7596fa05f9d11773$var$li(a, b, c, d) {
    var e = $7596fa05f9d11773$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $7596fa05f9d11773$var$N) {
        var g = $7596fa05f9d11773$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $7596fa05f9d11773$var$Mh(d, g.deps)) {
            e.memoizedState = $7596fa05f9d11773$var$bi(b, c, f, d);
            return;
        }
    }
    $7596fa05f9d11773$var$M.flags |= a;
    e.memoizedState = $7596fa05f9d11773$var$bi(1 | b, c, f, d);
}
function $7596fa05f9d11773$var$mi(a, b) {
    return $7596fa05f9d11773$var$ki(8390656, 8, a, b);
}
function $7596fa05f9d11773$var$$h(a, b) {
    return $7596fa05f9d11773$var$li(2048, 8, a, b);
}
function $7596fa05f9d11773$var$ni(a, b) {
    return $7596fa05f9d11773$var$li(4, 2, a, b);
}
function $7596fa05f9d11773$var$oi(a, b) {
    return $7596fa05f9d11773$var$li(4, 4, a, b);
}
function $7596fa05f9d11773$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $7596fa05f9d11773$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $7596fa05f9d11773$var$li(4, 4, $7596fa05f9d11773$var$pi.bind(null, b, a), c);
}
function $7596fa05f9d11773$var$ri() {}
function $7596fa05f9d11773$var$si(a, b) {
    var c = $7596fa05f9d11773$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $7596fa05f9d11773$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $7596fa05f9d11773$var$ti(a, b) {
    var c = $7596fa05f9d11773$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $7596fa05f9d11773$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $7596fa05f9d11773$var$ui(a, b, c) {
    if (0 === ($7596fa05f9d11773$var$Hh & 21)) return a.baseState && (a.baseState = !1, $7596fa05f9d11773$var$dh = !0), a.memoizedState = c;
    $7596fa05f9d11773$var$He(c, b) || (c = $7596fa05f9d11773$var$yc(), $7596fa05f9d11773$var$M.lanes |= c, $7596fa05f9d11773$var$rh |= c, a.baseState = !0);
    return b;
}
function $7596fa05f9d11773$var$vi(a, b) {
    var c = $7596fa05f9d11773$var$C;
    $7596fa05f9d11773$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $7596fa05f9d11773$var$Gh.transition;
    $7596fa05f9d11773$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $7596fa05f9d11773$var$C = c, $7596fa05f9d11773$var$Gh.transition = d;
    }
}
function $7596fa05f9d11773$var$wi() {
    return $7596fa05f9d11773$var$Uh().memoizedState;
}
function $7596fa05f9d11773$var$xi(a, b, c) {
    var d = $7596fa05f9d11773$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($7596fa05f9d11773$var$zi(a)) $7596fa05f9d11773$var$Ai(b, c);
    else if (c = $7596fa05f9d11773$var$hh(a, b, c, d), null !== c) {
        var e = $7596fa05f9d11773$var$R();
        $7596fa05f9d11773$var$gi(c, a, d, e);
        $7596fa05f9d11773$var$Bi(c, b, d);
    }
}
function $7596fa05f9d11773$var$ii(a, b, c) {
    var d = $7596fa05f9d11773$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($7596fa05f9d11773$var$zi(a)) $7596fa05f9d11773$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($7596fa05f9d11773$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $7596fa05f9d11773$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $7596fa05f9d11773$var$hh(a, b, e, d);
        null !== c && (e = $7596fa05f9d11773$var$R(), $7596fa05f9d11773$var$gi(c, a, d, e), $7596fa05f9d11773$var$Bi(c, b, d));
    }
}
function $7596fa05f9d11773$var$zi(a) {
    var b = a.alternate;
    return a === $7596fa05f9d11773$var$M || null !== b && b === $7596fa05f9d11773$var$M;
}
function $7596fa05f9d11773$var$Ai(a, b) {
    $7596fa05f9d11773$var$Jh = $7596fa05f9d11773$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $7596fa05f9d11773$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $7596fa05f9d11773$var$Cc(a, c);
    }
}
var $7596fa05f9d11773$var$Rh = {
    readContext: $7596fa05f9d11773$var$eh,
    useCallback: $7596fa05f9d11773$var$P,
    useContext: $7596fa05f9d11773$var$P,
    useEffect: $7596fa05f9d11773$var$P,
    useImperativeHandle: $7596fa05f9d11773$var$P,
    useInsertionEffect: $7596fa05f9d11773$var$P,
    useLayoutEffect: $7596fa05f9d11773$var$P,
    useMemo: $7596fa05f9d11773$var$P,
    useReducer: $7596fa05f9d11773$var$P,
    useRef: $7596fa05f9d11773$var$P,
    useState: $7596fa05f9d11773$var$P,
    useDebugValue: $7596fa05f9d11773$var$P,
    useDeferredValue: $7596fa05f9d11773$var$P,
    useTransition: $7596fa05f9d11773$var$P,
    useMutableSource: $7596fa05f9d11773$var$P,
    useSyncExternalStore: $7596fa05f9d11773$var$P,
    useId: $7596fa05f9d11773$var$P,
    unstable_isNewReconciler: !1
}, $7596fa05f9d11773$var$Oh = {
    readContext: $7596fa05f9d11773$var$eh,
    useCallback: function(a, b) {
        $7596fa05f9d11773$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $7596fa05f9d11773$var$eh,
    useEffect: $7596fa05f9d11773$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $7596fa05f9d11773$var$ki(4194308, 4, $7596fa05f9d11773$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $7596fa05f9d11773$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $7596fa05f9d11773$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $7596fa05f9d11773$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $7596fa05f9d11773$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $7596fa05f9d11773$var$xi.bind(null, $7596fa05f9d11773$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $7596fa05f9d11773$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $7596fa05f9d11773$var$hi,
    useDebugValue: $7596fa05f9d11773$var$ri,
    useDeferredValue: function(a) {
        return $7596fa05f9d11773$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $7596fa05f9d11773$var$hi(!1), b = a[0];
        a = $7596fa05f9d11773$var$vi.bind(null, a[1]);
        $7596fa05f9d11773$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $7596fa05f9d11773$var$M, e = $7596fa05f9d11773$var$Th();
        if ($7596fa05f9d11773$var$I) {
            if (void 0 === c) throw Error($7596fa05f9d11773$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $7596fa05f9d11773$var$Q) throw Error($7596fa05f9d11773$var$p(349));
            0 !== ($7596fa05f9d11773$var$Hh & 30) || $7596fa05f9d11773$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $7596fa05f9d11773$var$mi($7596fa05f9d11773$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $7596fa05f9d11773$var$bi(9, $7596fa05f9d11773$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $7596fa05f9d11773$var$Th(), b = $7596fa05f9d11773$var$Q.identifierPrefix;
        if ($7596fa05f9d11773$var$I) {
            var c = $7596fa05f9d11773$var$sg;
            var d = $7596fa05f9d11773$var$rg;
            c = (d & ~(1 << 32 - $7596fa05f9d11773$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $7596fa05f9d11773$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $7596fa05f9d11773$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $7596fa05f9d11773$var$Ph = {
    readContext: $7596fa05f9d11773$var$eh,
    useCallback: $7596fa05f9d11773$var$si,
    useContext: $7596fa05f9d11773$var$eh,
    useEffect: $7596fa05f9d11773$var$$h,
    useImperativeHandle: $7596fa05f9d11773$var$qi,
    useInsertionEffect: $7596fa05f9d11773$var$ni,
    useLayoutEffect: $7596fa05f9d11773$var$oi,
    useMemo: $7596fa05f9d11773$var$ti,
    useReducer: $7596fa05f9d11773$var$Wh,
    useRef: $7596fa05f9d11773$var$ji,
    useState: function() {
        return $7596fa05f9d11773$var$Wh($7596fa05f9d11773$var$Vh);
    },
    useDebugValue: $7596fa05f9d11773$var$ri,
    useDeferredValue: function(a) {
        var b = $7596fa05f9d11773$var$Uh();
        return $7596fa05f9d11773$var$ui(b, $7596fa05f9d11773$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $7596fa05f9d11773$var$Wh($7596fa05f9d11773$var$Vh)[0], b = $7596fa05f9d11773$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $7596fa05f9d11773$var$Yh,
    useSyncExternalStore: $7596fa05f9d11773$var$Zh,
    useId: $7596fa05f9d11773$var$wi,
    unstable_isNewReconciler: !1
}, $7596fa05f9d11773$var$Qh = {
    readContext: $7596fa05f9d11773$var$eh,
    useCallback: $7596fa05f9d11773$var$si,
    useContext: $7596fa05f9d11773$var$eh,
    useEffect: $7596fa05f9d11773$var$$h,
    useImperativeHandle: $7596fa05f9d11773$var$qi,
    useInsertionEffect: $7596fa05f9d11773$var$ni,
    useLayoutEffect: $7596fa05f9d11773$var$oi,
    useMemo: $7596fa05f9d11773$var$ti,
    useReducer: $7596fa05f9d11773$var$Xh,
    useRef: $7596fa05f9d11773$var$ji,
    useState: function() {
        return $7596fa05f9d11773$var$Xh($7596fa05f9d11773$var$Vh);
    },
    useDebugValue: $7596fa05f9d11773$var$ri,
    useDeferredValue: function(a) {
        var b = $7596fa05f9d11773$var$Uh();
        return null === $7596fa05f9d11773$var$N ? b.memoizedState = a : $7596fa05f9d11773$var$ui(b, $7596fa05f9d11773$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $7596fa05f9d11773$var$Xh($7596fa05f9d11773$var$Vh)[0], b = $7596fa05f9d11773$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $7596fa05f9d11773$var$Yh,
    useSyncExternalStore: $7596fa05f9d11773$var$Zh,
    useId: $7596fa05f9d11773$var$wi,
    unstable_isNewReconciler: !1
};
function $7596fa05f9d11773$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $7596fa05f9d11773$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $7596fa05f9d11773$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $7596fa05f9d11773$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $7596fa05f9d11773$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $7596fa05f9d11773$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $7596fa05f9d11773$var$R(), e = $7596fa05f9d11773$var$yi(a), f = $7596fa05f9d11773$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $7596fa05f9d11773$var$nh(a, f, e);
        null !== b && ($7596fa05f9d11773$var$gi(b, a, e, d), $7596fa05f9d11773$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $7596fa05f9d11773$var$R(), e = $7596fa05f9d11773$var$yi(a), f = $7596fa05f9d11773$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $7596fa05f9d11773$var$nh(a, f, e);
        null !== b && ($7596fa05f9d11773$var$gi(b, a, e, d), $7596fa05f9d11773$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $7596fa05f9d11773$var$R(), d = $7596fa05f9d11773$var$yi(a), e = $7596fa05f9d11773$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $7596fa05f9d11773$var$nh(a, e, d);
        null !== b && ($7596fa05f9d11773$var$gi(b, a, d, c), $7596fa05f9d11773$var$oh(b, a, d));
    }
};
function $7596fa05f9d11773$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$7596fa05f9d11773$var$Ie(c, d) || !$7596fa05f9d11773$var$Ie(e, f) : !0;
}
function $7596fa05f9d11773$var$Gi(a, b, c) {
    var d = !1, e = $7596fa05f9d11773$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $7596fa05f9d11773$var$eh(f) : (e = $7596fa05f9d11773$var$Zf(b) ? $7596fa05f9d11773$var$Xf : $7596fa05f9d11773$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $7596fa05f9d11773$var$Yf(a, e) : $7596fa05f9d11773$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $7596fa05f9d11773$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $7596fa05f9d11773$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $7596fa05f9d11773$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $7596fa05f9d11773$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $7596fa05f9d11773$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $7596fa05f9d11773$var$eh(f) : (f = $7596fa05f9d11773$var$Zf(b) ? $7596fa05f9d11773$var$Xf : $7596fa05f9d11773$var$H.current, e.context = $7596fa05f9d11773$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($7596fa05f9d11773$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $7596fa05f9d11773$var$Ei.enqueueReplaceState(e, e.state, null), $7596fa05f9d11773$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $7596fa05f9d11773$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $7596fa05f9d11773$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $7596fa05f9d11773$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $7596fa05f9d11773$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $7596fa05f9d11773$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $7596fa05f9d11773$var$Ni(a, b, c) {
    c = $7596fa05f9d11773$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $7596fa05f9d11773$var$Oi || ($7596fa05f9d11773$var$Oi = !0, $7596fa05f9d11773$var$Pi = d);
        $7596fa05f9d11773$var$Li(a, b);
    };
    return c;
}
function $7596fa05f9d11773$var$Qi(a, b, c) {
    c = $7596fa05f9d11773$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $7596fa05f9d11773$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $7596fa05f9d11773$var$Li(a, b);
        "function" !== typeof d && (null === $7596fa05f9d11773$var$Ri ? $7596fa05f9d11773$var$Ri = new Set([
            this
        ]) : $7596fa05f9d11773$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $7596fa05f9d11773$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $7596fa05f9d11773$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $7596fa05f9d11773$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $7596fa05f9d11773$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $7596fa05f9d11773$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $7596fa05f9d11773$var$mh(-1, 1), b.tag = 2, $7596fa05f9d11773$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $7596fa05f9d11773$var$Wi = $7596fa05f9d11773$var$ua.ReactCurrentOwner, $7596fa05f9d11773$var$dh = !1;
function $7596fa05f9d11773$var$Xi(a, b, c, d) {
    b.child = null === a ? $7596fa05f9d11773$var$Vg(b, null, c, d) : $7596fa05f9d11773$var$Ug(b, a.child, c, d);
}
function $7596fa05f9d11773$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $7596fa05f9d11773$var$ch(b, e);
    d = $7596fa05f9d11773$var$Nh(a, b, c, d, f, e);
    c = $7596fa05f9d11773$var$Sh();
    if (null !== a && !$7596fa05f9d11773$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $7596fa05f9d11773$var$Zi(a, b, e);
    $7596fa05f9d11773$var$I && c && $7596fa05f9d11773$var$vg(b);
    b.flags |= 1;
    $7596fa05f9d11773$var$Xi(a, b, d, e);
    return b.child;
}
function $7596fa05f9d11773$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$7596fa05f9d11773$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $7596fa05f9d11773$var$bj(a, b, f, d, e);
        a = $7596fa05f9d11773$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $7596fa05f9d11773$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $7596fa05f9d11773$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $7596fa05f9d11773$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $7596fa05f9d11773$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($7596fa05f9d11773$var$Ie(f, d) && a.ref === b.ref) {
            if ($7596fa05f9d11773$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($7596fa05f9d11773$var$dh = !0);
            else return b.lanes = a.lanes, $7596fa05f9d11773$var$Zi(a, b, e);
        }
    }
    return $7596fa05f9d11773$var$cj(a, b, c, d, e);
}
function $7596fa05f9d11773$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $7596fa05f9d11773$var$G($7596fa05f9d11773$var$ej, $7596fa05f9d11773$var$fj), $7596fa05f9d11773$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $7596fa05f9d11773$var$G($7596fa05f9d11773$var$ej, $7596fa05f9d11773$var$fj), $7596fa05f9d11773$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $7596fa05f9d11773$var$G($7596fa05f9d11773$var$ej, $7596fa05f9d11773$var$fj);
            $7596fa05f9d11773$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $7596fa05f9d11773$var$G($7596fa05f9d11773$var$ej, $7596fa05f9d11773$var$fj), $7596fa05f9d11773$var$fj |= d;
    $7596fa05f9d11773$var$Xi(a, b, e, c);
    return b.child;
}
function $7596fa05f9d11773$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $7596fa05f9d11773$var$cj(a, b, c, d, e) {
    var f = $7596fa05f9d11773$var$Zf(c) ? $7596fa05f9d11773$var$Xf : $7596fa05f9d11773$var$H.current;
    f = $7596fa05f9d11773$var$Yf(b, f);
    $7596fa05f9d11773$var$ch(b, e);
    c = $7596fa05f9d11773$var$Nh(a, b, c, d, f, e);
    d = $7596fa05f9d11773$var$Sh();
    if (null !== a && !$7596fa05f9d11773$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $7596fa05f9d11773$var$Zi(a, b, e);
    $7596fa05f9d11773$var$I && d && $7596fa05f9d11773$var$vg(b);
    b.flags |= 1;
    $7596fa05f9d11773$var$Xi(a, b, c, e);
    return b.child;
}
function $7596fa05f9d11773$var$hj(a, b, c, d, e) {
    if ($7596fa05f9d11773$var$Zf(c)) {
        var f = !0;
        $7596fa05f9d11773$var$cg(b);
    } else f = !1;
    $7596fa05f9d11773$var$ch(b, e);
    if (null === b.stateNode) $7596fa05f9d11773$var$ij(a, b), $7596fa05f9d11773$var$Gi(b, c, d), $7596fa05f9d11773$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $7596fa05f9d11773$var$eh(l) : (l = $7596fa05f9d11773$var$Zf(c) ? $7596fa05f9d11773$var$Xf : $7596fa05f9d11773$var$H.current, l = $7596fa05f9d11773$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $7596fa05f9d11773$var$Hi(b, g, d, l);
        $7596fa05f9d11773$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $7596fa05f9d11773$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $7596fa05f9d11773$var$Wf.current || $7596fa05f9d11773$var$jh ? ("function" === typeof m && ($7596fa05f9d11773$var$Di(b, c, m, d), k = b.memoizedState), (h = $7596fa05f9d11773$var$jh || $7596fa05f9d11773$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $7596fa05f9d11773$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $7596fa05f9d11773$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $7596fa05f9d11773$var$eh(k) : (k = $7596fa05f9d11773$var$Zf(c) ? $7596fa05f9d11773$var$Xf : $7596fa05f9d11773$var$H.current, k = $7596fa05f9d11773$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $7596fa05f9d11773$var$Hi(b, g, d, k);
        $7596fa05f9d11773$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $7596fa05f9d11773$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $7596fa05f9d11773$var$Wf.current || $7596fa05f9d11773$var$jh ? ("function" === typeof y && ($7596fa05f9d11773$var$Di(b, c, y, d), n = b.memoizedState), (l = $7596fa05f9d11773$var$jh || $7596fa05f9d11773$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $7596fa05f9d11773$var$jj(a, b, c, d, f, e);
}
function $7596fa05f9d11773$var$jj(a, b, c, d, e, f) {
    $7596fa05f9d11773$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $7596fa05f9d11773$var$dg(b, c, !1), $7596fa05f9d11773$var$Zi(a, b, f);
    d = b.stateNode;
    $7596fa05f9d11773$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $7596fa05f9d11773$var$Ug(b, a.child, null, f), b.child = $7596fa05f9d11773$var$Ug(b, null, h, f)) : $7596fa05f9d11773$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $7596fa05f9d11773$var$dg(b, c, !0);
    return b.child;
}
function $7596fa05f9d11773$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $7596fa05f9d11773$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $7596fa05f9d11773$var$ag(a, b.context, !1);
    $7596fa05f9d11773$var$yh(a, b.containerInfo);
}
function $7596fa05f9d11773$var$lj(a, b, c, d, e) {
    $7596fa05f9d11773$var$Ig();
    $7596fa05f9d11773$var$Jg(e);
    b.flags |= 256;
    $7596fa05f9d11773$var$Xi(a, b, c, d);
    return b.child;
}
var $7596fa05f9d11773$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $7596fa05f9d11773$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $7596fa05f9d11773$var$oj(a, b, c) {
    var d = b.pendingProps, e = $7596fa05f9d11773$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$L, e & 1);
    if (null === a) {
        $7596fa05f9d11773$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $7596fa05f9d11773$var$pj(g, d, 0, null), a = $7596fa05f9d11773$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $7596fa05f9d11773$var$nj(c), b.memoizedState = $7596fa05f9d11773$var$mj, a) : $7596fa05f9d11773$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $7596fa05f9d11773$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $7596fa05f9d11773$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $7596fa05f9d11773$var$Pg(h, f) : (f = $7596fa05f9d11773$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $7596fa05f9d11773$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $7596fa05f9d11773$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $7596fa05f9d11773$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $7596fa05f9d11773$var$qj(a, b) {
    b = $7596fa05f9d11773$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $7596fa05f9d11773$var$sj(a, b, c, d) {
    null !== d && $7596fa05f9d11773$var$Jg(d);
    $7596fa05f9d11773$var$Ug(b, a.child, null, c);
    a = $7596fa05f9d11773$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $7596fa05f9d11773$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $7596fa05f9d11773$var$Ki(Error($7596fa05f9d11773$var$p(422))), $7596fa05f9d11773$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $7596fa05f9d11773$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $7596fa05f9d11773$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $7596fa05f9d11773$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $7596fa05f9d11773$var$nj(g);
        b.memoizedState = $7596fa05f9d11773$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $7596fa05f9d11773$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($7596fa05f9d11773$var$p(419));
        d = $7596fa05f9d11773$var$Ki(f, d, void 0);
        return $7596fa05f9d11773$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($7596fa05f9d11773$var$dh || h) {
        d = $7596fa05f9d11773$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $7596fa05f9d11773$var$ih(a, e), $7596fa05f9d11773$var$gi(d, a, e, -1));
        }
        $7596fa05f9d11773$var$tj();
        d = $7596fa05f9d11773$var$Ki(Error($7596fa05f9d11773$var$p(421)));
        return $7596fa05f9d11773$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $7596fa05f9d11773$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $7596fa05f9d11773$var$yg = $7596fa05f9d11773$var$Lf(e.nextSibling);
    $7596fa05f9d11773$var$xg = b;
    $7596fa05f9d11773$var$I = !0;
    $7596fa05f9d11773$var$zg = null;
    null !== a && ($7596fa05f9d11773$var$og[$7596fa05f9d11773$var$pg++] = $7596fa05f9d11773$var$rg, $7596fa05f9d11773$var$og[$7596fa05f9d11773$var$pg++] = $7596fa05f9d11773$var$sg, $7596fa05f9d11773$var$og[$7596fa05f9d11773$var$pg++] = $7596fa05f9d11773$var$qg, $7596fa05f9d11773$var$rg = a.id, $7596fa05f9d11773$var$sg = a.overflow, $7596fa05f9d11773$var$qg = b);
    b = $7596fa05f9d11773$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $7596fa05f9d11773$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $7596fa05f9d11773$var$bh(a.return, b, c);
}
function $7596fa05f9d11773$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $7596fa05f9d11773$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $7596fa05f9d11773$var$Xi(a, b, d.children, c);
    d = $7596fa05f9d11773$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $7596fa05f9d11773$var$vj(a, c, b);
            else if (19 === a.tag) $7596fa05f9d11773$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $7596fa05f9d11773$var$G($7596fa05f9d11773$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $7596fa05f9d11773$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $7596fa05f9d11773$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $7596fa05f9d11773$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $7596fa05f9d11773$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $7596fa05f9d11773$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $7596fa05f9d11773$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $7596fa05f9d11773$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $7596fa05f9d11773$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($7596fa05f9d11773$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $7596fa05f9d11773$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $7596fa05f9d11773$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $7596fa05f9d11773$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $7596fa05f9d11773$var$kj(b);
            $7596fa05f9d11773$var$Ig();
            break;
        case 5:
            $7596fa05f9d11773$var$Ah(b);
            break;
        case 1:
            $7596fa05f9d11773$var$Zf(b.type) && $7596fa05f9d11773$var$cg(b);
            break;
        case 4:
            $7596fa05f9d11773$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $7596fa05f9d11773$var$G($7596fa05f9d11773$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $7596fa05f9d11773$var$G($7596fa05f9d11773$var$L, $7596fa05f9d11773$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $7596fa05f9d11773$var$oj(a, b, c);
                $7596fa05f9d11773$var$G($7596fa05f9d11773$var$L, $7596fa05f9d11773$var$L.current & 1);
                a = $7596fa05f9d11773$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $7596fa05f9d11773$var$G($7596fa05f9d11773$var$L, $7596fa05f9d11773$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $7596fa05f9d11773$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $7596fa05f9d11773$var$G($7596fa05f9d11773$var$L, $7596fa05f9d11773$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $7596fa05f9d11773$var$dj(a, b, c);
    }
    return $7596fa05f9d11773$var$Zi(a, b, c);
}
var $7596fa05f9d11773$var$zj, $7596fa05f9d11773$var$Aj, $7596fa05f9d11773$var$Bj, $7596fa05f9d11773$var$Cj;
$7596fa05f9d11773$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$7596fa05f9d11773$var$Aj = function() {};
$7596fa05f9d11773$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $7596fa05f9d11773$var$xh($7596fa05f9d11773$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $7596fa05f9d11773$var$Ya(a, e);
                d = $7596fa05f9d11773$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $7596fa05f9d11773$var$A({}, e, {
                    value: void 0
                });
                d = $7596fa05f9d11773$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $7596fa05f9d11773$var$gb(a, e);
                d = $7596fa05f9d11773$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $7596fa05f9d11773$var$Bf);
        }
        $7596fa05f9d11773$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($7596fa05f9d11773$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($7596fa05f9d11773$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $7596fa05f9d11773$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$7596fa05f9d11773$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $7596fa05f9d11773$var$Dj(a, b) {
    if (!$7596fa05f9d11773$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $7596fa05f9d11773$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $7596fa05f9d11773$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $7596fa05f9d11773$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $7596fa05f9d11773$var$S(b), null;
        case 1:
            return $7596fa05f9d11773$var$Zf(b.type) && $7596fa05f9d11773$var$$f(), $7596fa05f9d11773$var$S(b), null;
        case 3:
            d = b.stateNode;
            $7596fa05f9d11773$var$zh();
            $7596fa05f9d11773$var$E($7596fa05f9d11773$var$Wf);
            $7596fa05f9d11773$var$E($7596fa05f9d11773$var$H);
            $7596fa05f9d11773$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $7596fa05f9d11773$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $7596fa05f9d11773$var$zg && ($7596fa05f9d11773$var$Fj($7596fa05f9d11773$var$zg), $7596fa05f9d11773$var$zg = null));
            $7596fa05f9d11773$var$Aj(a, b);
            $7596fa05f9d11773$var$S(b);
            return null;
        case 5:
            $7596fa05f9d11773$var$Bh(b);
            var e = $7596fa05f9d11773$var$xh($7596fa05f9d11773$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $7596fa05f9d11773$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($7596fa05f9d11773$var$p(166));
                    $7596fa05f9d11773$var$S(b);
                    return null;
                }
                a = $7596fa05f9d11773$var$xh($7596fa05f9d11773$var$uh.current);
                if ($7596fa05f9d11773$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$7596fa05f9d11773$var$Of] = b;
                    d[$7596fa05f9d11773$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $7596fa05f9d11773$var$D("cancel", d);
                            $7596fa05f9d11773$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $7596fa05f9d11773$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $7596fa05f9d11773$var$lf.length; e++)$7596fa05f9d11773$var$D($7596fa05f9d11773$var$lf[e], d);
                            break;
                        case "source":
                            $7596fa05f9d11773$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $7596fa05f9d11773$var$D("error", d);
                            $7596fa05f9d11773$var$D("load", d);
                            break;
                        case "details":
                            $7596fa05f9d11773$var$D("toggle", d);
                            break;
                        case "input":
                            $7596fa05f9d11773$var$Za(d, f);
                            $7596fa05f9d11773$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $7596fa05f9d11773$var$D("invalid", d);
                            break;
                        case "textarea":
                            $7596fa05f9d11773$var$hb(d, f), $7596fa05f9d11773$var$D("invalid", d);
                    }
                    $7596fa05f9d11773$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $7596fa05f9d11773$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $7596fa05f9d11773$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $7596fa05f9d11773$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $7596fa05f9d11773$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $7596fa05f9d11773$var$Va(d);
                            $7596fa05f9d11773$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $7596fa05f9d11773$var$Va(d);
                            $7596fa05f9d11773$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $7596fa05f9d11773$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $7596fa05f9d11773$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$7596fa05f9d11773$var$Of] = b;
                    a[$7596fa05f9d11773$var$Pf] = d;
                    $7596fa05f9d11773$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $7596fa05f9d11773$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $7596fa05f9d11773$var$D("cancel", a);
                                $7596fa05f9d11773$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $7596fa05f9d11773$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $7596fa05f9d11773$var$lf.length; e++)$7596fa05f9d11773$var$D($7596fa05f9d11773$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $7596fa05f9d11773$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $7596fa05f9d11773$var$D("error", a);
                                $7596fa05f9d11773$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $7596fa05f9d11773$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $7596fa05f9d11773$var$Za(a, d);
                                e = $7596fa05f9d11773$var$Ya(a, d);
                                $7596fa05f9d11773$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $7596fa05f9d11773$var$A({}, d, {
                                    value: void 0
                                });
                                $7596fa05f9d11773$var$D("invalid", a);
                                break;
                            case "textarea":
                                $7596fa05f9d11773$var$hb(a, d);
                                e = $7596fa05f9d11773$var$gb(a, d);
                                $7596fa05f9d11773$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $7596fa05f9d11773$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $7596fa05f9d11773$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $7596fa05f9d11773$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $7596fa05f9d11773$var$ob(a, k) : "number" === typeof k && $7596fa05f9d11773$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($7596fa05f9d11773$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $7596fa05f9d11773$var$D("scroll", a) : null != k && $7596fa05f9d11773$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $7596fa05f9d11773$var$Va(a);
                                $7596fa05f9d11773$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $7596fa05f9d11773$var$Va(a);
                                $7596fa05f9d11773$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $7596fa05f9d11773$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $7596fa05f9d11773$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $7596fa05f9d11773$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $7596fa05f9d11773$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $7596fa05f9d11773$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $7596fa05f9d11773$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($7596fa05f9d11773$var$p(166));
                c = $7596fa05f9d11773$var$xh($7596fa05f9d11773$var$wh.current);
                $7596fa05f9d11773$var$xh($7596fa05f9d11773$var$uh.current);
                if ($7596fa05f9d11773$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$7596fa05f9d11773$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $7596fa05f9d11773$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $7596fa05f9d11773$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $7596fa05f9d11773$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$7596fa05f9d11773$var$Of] = b, b.stateNode = d;
            }
            $7596fa05f9d11773$var$S(b);
            return null;
        case 13:
            $7596fa05f9d11773$var$E($7596fa05f9d11773$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($7596fa05f9d11773$var$I && null !== $7596fa05f9d11773$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $7596fa05f9d11773$var$Hg(), $7596fa05f9d11773$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $7596fa05f9d11773$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($7596fa05f9d11773$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($7596fa05f9d11773$var$p(317));
                        f[$7596fa05f9d11773$var$Of] = b;
                    } else $7596fa05f9d11773$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $7596fa05f9d11773$var$S(b);
                    f = !1;
                } else null !== $7596fa05f9d11773$var$zg && ($7596fa05f9d11773$var$Fj($7596fa05f9d11773$var$zg), $7596fa05f9d11773$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($7596fa05f9d11773$var$L.current & 1) ? 0 === $7596fa05f9d11773$var$T && ($7596fa05f9d11773$var$T = 3) : $7596fa05f9d11773$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $7596fa05f9d11773$var$S(b);
            return null;
        case 4:
            return $7596fa05f9d11773$var$zh(), $7596fa05f9d11773$var$Aj(a, b), null === a && $7596fa05f9d11773$var$sf(b.stateNode.containerInfo), $7596fa05f9d11773$var$S(b), null;
        case 10:
            return $7596fa05f9d11773$var$ah(b.type._context), $7596fa05f9d11773$var$S(b), null;
        case 17:
            return $7596fa05f9d11773$var$Zf(b.type) && $7596fa05f9d11773$var$$f(), $7596fa05f9d11773$var$S(b), null;
        case 19:
            $7596fa05f9d11773$var$E($7596fa05f9d11773$var$L);
            f = b.memoizedState;
            if (null === f) return $7596fa05f9d11773$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $7596fa05f9d11773$var$Dj(f, !1);
                else {
                    if (0 !== $7596fa05f9d11773$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $7596fa05f9d11773$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $7596fa05f9d11773$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $7596fa05f9d11773$var$G($7596fa05f9d11773$var$L, $7596fa05f9d11773$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $7596fa05f9d11773$var$B() > $7596fa05f9d11773$var$Gj && (b.flags |= 128, d = !0, $7596fa05f9d11773$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $7596fa05f9d11773$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $7596fa05f9d11773$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$7596fa05f9d11773$var$I) return $7596fa05f9d11773$var$S(b), null;
                    } else 2 * $7596fa05f9d11773$var$B() - f.renderingStartTime > $7596fa05f9d11773$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $7596fa05f9d11773$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $7596fa05f9d11773$var$B(), b.sibling = null, c = $7596fa05f9d11773$var$L.current, $7596fa05f9d11773$var$G($7596fa05f9d11773$var$L, d ? c & 1 | 2 : c & 1), b;
            $7596fa05f9d11773$var$S(b);
            return null;
        case 22:
        case 23:
            return $7596fa05f9d11773$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($7596fa05f9d11773$var$fj & 1073741824) && ($7596fa05f9d11773$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $7596fa05f9d11773$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($7596fa05f9d11773$var$p(156, b.tag));
}
function $7596fa05f9d11773$var$Ij(a, b) {
    $7596fa05f9d11773$var$wg(b);
    switch(b.tag){
        case 1:
            return $7596fa05f9d11773$var$Zf(b.type) && $7596fa05f9d11773$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $7596fa05f9d11773$var$zh(), $7596fa05f9d11773$var$E($7596fa05f9d11773$var$Wf), $7596fa05f9d11773$var$E($7596fa05f9d11773$var$H), $7596fa05f9d11773$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $7596fa05f9d11773$var$Bh(b), null;
        case 13:
            $7596fa05f9d11773$var$E($7596fa05f9d11773$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($7596fa05f9d11773$var$p(340));
                $7596fa05f9d11773$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $7596fa05f9d11773$var$E($7596fa05f9d11773$var$L), null;
        case 4:
            return $7596fa05f9d11773$var$zh(), null;
        case 10:
            return $7596fa05f9d11773$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $7596fa05f9d11773$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $7596fa05f9d11773$var$Jj = !1, $7596fa05f9d11773$var$U = !1, $7596fa05f9d11773$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $7596fa05f9d11773$var$V = null;
function $7596fa05f9d11773$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $7596fa05f9d11773$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $7596fa05f9d11773$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $7596fa05f9d11773$var$W(a, b, d);
    }
}
var $7596fa05f9d11773$var$Nj = !1;
function $7596fa05f9d11773$var$Oj(a, b) {
    $7596fa05f9d11773$var$Cf = $7596fa05f9d11773$var$dd;
    a = $7596fa05f9d11773$var$Me();
    if ($7596fa05f9d11773$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $7596fa05f9d11773$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $7596fa05f9d11773$var$dd = !1;
    for($7596fa05f9d11773$var$V = b; null !== $7596fa05f9d11773$var$V;)if (b = $7596fa05f9d11773$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $7596fa05f9d11773$var$V = a;
    else for(; null !== $7596fa05f9d11773$var$V;){
        b = $7596fa05f9d11773$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $7596fa05f9d11773$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($7596fa05f9d11773$var$p(163));
            }
        } catch (F) {
            $7596fa05f9d11773$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $7596fa05f9d11773$var$V = a;
            break;
        }
        $7596fa05f9d11773$var$V = b.return;
    }
    n = $7596fa05f9d11773$var$Nj;
    $7596fa05f9d11773$var$Nj = !1;
    return n;
}
function $7596fa05f9d11773$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $7596fa05f9d11773$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $7596fa05f9d11773$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $7596fa05f9d11773$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $7596fa05f9d11773$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $7596fa05f9d11773$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$7596fa05f9d11773$var$Of], delete b[$7596fa05f9d11773$var$Pf], delete b[$7596fa05f9d11773$var$of], delete b[$7596fa05f9d11773$var$Qf], delete b[$7596fa05f9d11773$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $7596fa05f9d11773$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $7596fa05f9d11773$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $7596fa05f9d11773$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $7596fa05f9d11773$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $7596fa05f9d11773$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($7596fa05f9d11773$var$Vj(a, b, c), a = a.sibling; null !== a;)$7596fa05f9d11773$var$Vj(a, b, c), a = a.sibling;
}
function $7596fa05f9d11773$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($7596fa05f9d11773$var$Wj(a, b, c), a = a.sibling; null !== a;)$7596fa05f9d11773$var$Wj(a, b, c), a = a.sibling;
}
var $7596fa05f9d11773$var$X = null, $7596fa05f9d11773$var$Xj = !1;
function $7596fa05f9d11773$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$7596fa05f9d11773$var$Zj(a, b, c), c = c.sibling;
}
function $7596fa05f9d11773$var$Zj(a, b, c) {
    if ($7596fa05f9d11773$var$lc && "function" === typeof $7596fa05f9d11773$var$lc.onCommitFiberUnmount) try {
        $7596fa05f9d11773$var$lc.onCommitFiberUnmount($7596fa05f9d11773$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $7596fa05f9d11773$var$U || $7596fa05f9d11773$var$Lj(c, b);
        case 6:
            var d = $7596fa05f9d11773$var$X, e = $7596fa05f9d11773$var$Xj;
            $7596fa05f9d11773$var$X = null;
            $7596fa05f9d11773$var$Yj(a, b, c);
            $7596fa05f9d11773$var$X = d;
            $7596fa05f9d11773$var$Xj = e;
            null !== $7596fa05f9d11773$var$X && ($7596fa05f9d11773$var$Xj ? (a = $7596fa05f9d11773$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $7596fa05f9d11773$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $7596fa05f9d11773$var$X && ($7596fa05f9d11773$var$Xj ? (a = $7596fa05f9d11773$var$X, c = c.stateNode, 8 === a.nodeType ? $7596fa05f9d11773$var$Kf(a.parentNode, c) : 1 === a.nodeType && $7596fa05f9d11773$var$Kf(a, c), $7596fa05f9d11773$var$bd(a)) : $7596fa05f9d11773$var$Kf($7596fa05f9d11773$var$X, c.stateNode));
            break;
        case 4:
            d = $7596fa05f9d11773$var$X;
            e = $7596fa05f9d11773$var$Xj;
            $7596fa05f9d11773$var$X = c.stateNode.containerInfo;
            $7596fa05f9d11773$var$Xj = !0;
            $7596fa05f9d11773$var$Yj(a, b, c);
            $7596fa05f9d11773$var$X = d;
            $7596fa05f9d11773$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$7596fa05f9d11773$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $7596fa05f9d11773$var$Mj(c, b, g) : 0 !== (f & 4) && $7596fa05f9d11773$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $7596fa05f9d11773$var$Yj(a, b, c);
            break;
        case 1:
            if (!$7596fa05f9d11773$var$U && ($7596fa05f9d11773$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $7596fa05f9d11773$var$W(c, b, h);
            }
            $7596fa05f9d11773$var$Yj(a, b, c);
            break;
        case 21:
            $7596fa05f9d11773$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($7596fa05f9d11773$var$U = (d = $7596fa05f9d11773$var$U) || null !== c.memoizedState, $7596fa05f9d11773$var$Yj(a, b, c), $7596fa05f9d11773$var$U = d) : $7596fa05f9d11773$var$Yj(a, b, c);
            break;
        default:
            $7596fa05f9d11773$var$Yj(a, b, c);
    }
}
function $7596fa05f9d11773$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $7596fa05f9d11773$var$Kj);
        b.forEach(function(b) {
            var d = $7596fa05f9d11773$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $7596fa05f9d11773$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $7596fa05f9d11773$var$X = h.stateNode;
                        $7596fa05f9d11773$var$Xj = !1;
                        break a;
                    case 3:
                        $7596fa05f9d11773$var$X = h.stateNode.containerInfo;
                        $7596fa05f9d11773$var$Xj = !0;
                        break a;
                    case 4:
                        $7596fa05f9d11773$var$X = h.stateNode.containerInfo;
                        $7596fa05f9d11773$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $7596fa05f9d11773$var$X) throw Error($7596fa05f9d11773$var$p(160));
            $7596fa05f9d11773$var$Zj(f, g, e);
            $7596fa05f9d11773$var$X = null;
            $7596fa05f9d11773$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $7596fa05f9d11773$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$7596fa05f9d11773$var$dk(b, a), b = b.sibling;
}
function $7596fa05f9d11773$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $7596fa05f9d11773$var$ck(b, a);
            $7596fa05f9d11773$var$ek(a);
            if (d & 4) {
                try {
                    $7596fa05f9d11773$var$Pj(3, a, a.return), $7596fa05f9d11773$var$Qj(3, a);
                } catch (t) {
                    $7596fa05f9d11773$var$W(a, a.return, t);
                }
                try {
                    $7596fa05f9d11773$var$Pj(5, a, a.return);
                } catch (t) {
                    $7596fa05f9d11773$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $7596fa05f9d11773$var$ck(b, a);
            $7596fa05f9d11773$var$ek(a);
            d & 512 && null !== c && $7596fa05f9d11773$var$Lj(c, c.return);
            break;
        case 5:
            $7596fa05f9d11773$var$ck(b, a);
            $7596fa05f9d11773$var$ek(a);
            d & 512 && null !== c && $7596fa05f9d11773$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $7596fa05f9d11773$var$ob(e, "");
                } catch (t) {
                    $7596fa05f9d11773$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $7596fa05f9d11773$var$ab(e, f);
                    $7596fa05f9d11773$var$vb(h, g);
                    var l = $7596fa05f9d11773$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $7596fa05f9d11773$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $7596fa05f9d11773$var$nb(e, q) : "children" === m ? $7596fa05f9d11773$var$ob(e, q) : $7596fa05f9d11773$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $7596fa05f9d11773$var$bb(e, f);
                            break;
                        case "textarea":
                            $7596fa05f9d11773$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $7596fa05f9d11773$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $7596fa05f9d11773$var$fb(e, !!f.multiple, f.defaultValue, !0) : $7596fa05f9d11773$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$7596fa05f9d11773$var$Pf] = f;
                } catch (t) {
                    $7596fa05f9d11773$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $7596fa05f9d11773$var$ck(b, a);
            $7596fa05f9d11773$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($7596fa05f9d11773$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $7596fa05f9d11773$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $7596fa05f9d11773$var$ck(b, a);
            $7596fa05f9d11773$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $7596fa05f9d11773$var$bd(b.containerInfo);
            } catch (t) {
                $7596fa05f9d11773$var$W(a, a.return, t);
            }
            break;
        case 4:
            $7596fa05f9d11773$var$ck(b, a);
            $7596fa05f9d11773$var$ek(a);
            break;
        case 13:
            $7596fa05f9d11773$var$ck(b, a);
            $7596fa05f9d11773$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($7596fa05f9d11773$var$fk = $7596fa05f9d11773$var$B()));
            d & 4 && $7596fa05f9d11773$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($7596fa05f9d11773$var$U = (l = $7596fa05f9d11773$var$U) || m, $7596fa05f9d11773$var$ck(b, a), $7596fa05f9d11773$var$U = l) : $7596fa05f9d11773$var$ck(b, a);
            $7596fa05f9d11773$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($7596fa05f9d11773$var$V = a, m = a.child; null !== m;){
                    for(q = $7596fa05f9d11773$var$V = m; null !== $7596fa05f9d11773$var$V;){
                        r = $7596fa05f9d11773$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $7596fa05f9d11773$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $7596fa05f9d11773$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $7596fa05f9d11773$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $7596fa05f9d11773$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $7596fa05f9d11773$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $7596fa05f9d11773$var$V = y) : $7596fa05f9d11773$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $7596fa05f9d11773$var$rb("display", g));
                            } catch (t) {
                                $7596fa05f9d11773$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $7596fa05f9d11773$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $7596fa05f9d11773$var$ck(b, a);
            $7596fa05f9d11773$var$ek(a);
            d & 4 && $7596fa05f9d11773$var$ak(a);
            break;
        case 21:
            break;
        default:
            $7596fa05f9d11773$var$ck(b, a), $7596fa05f9d11773$var$ek(a);
    }
}
function $7596fa05f9d11773$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($7596fa05f9d11773$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($7596fa05f9d11773$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($7596fa05f9d11773$var$ob(e, ""), d.flags &= -33);
                    var f = $7596fa05f9d11773$var$Uj(a);
                    $7596fa05f9d11773$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $7596fa05f9d11773$var$Uj(a);
                    $7596fa05f9d11773$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($7596fa05f9d11773$var$p(161));
            }
        } catch (k) {
            $7596fa05f9d11773$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $7596fa05f9d11773$var$hk(a, b, c) {
    $7596fa05f9d11773$var$V = a;
    $7596fa05f9d11773$var$ik(a, b, c);
}
function $7596fa05f9d11773$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $7596fa05f9d11773$var$V;){
        var e = $7596fa05f9d11773$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $7596fa05f9d11773$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $7596fa05f9d11773$var$U;
                h = $7596fa05f9d11773$var$Jj;
                var l = $7596fa05f9d11773$var$U;
                $7596fa05f9d11773$var$Jj = g;
                if (($7596fa05f9d11773$var$U = k) && !l) for($7596fa05f9d11773$var$V = e; null !== $7596fa05f9d11773$var$V;)g = $7596fa05f9d11773$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $7596fa05f9d11773$var$jk(e) : null !== k ? (k.return = g, $7596fa05f9d11773$var$V = k) : $7596fa05f9d11773$var$jk(e);
                for(; null !== f;)$7596fa05f9d11773$var$V = f, $7596fa05f9d11773$var$ik(f, b, c), f = f.sibling;
                $7596fa05f9d11773$var$V = e;
                $7596fa05f9d11773$var$Jj = h;
                $7596fa05f9d11773$var$U = l;
            }
            $7596fa05f9d11773$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $7596fa05f9d11773$var$V = f) : $7596fa05f9d11773$var$kk(a, b, c);
    }
}
function $7596fa05f9d11773$var$kk(a) {
    for(; null !== $7596fa05f9d11773$var$V;){
        var b = $7596fa05f9d11773$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $7596fa05f9d11773$var$U || $7596fa05f9d11773$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$7596fa05f9d11773$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $7596fa05f9d11773$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $7596fa05f9d11773$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $7596fa05f9d11773$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $7596fa05f9d11773$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($7596fa05f9d11773$var$p(163));
                }
                $7596fa05f9d11773$var$U || b.flags & 512 && $7596fa05f9d11773$var$Rj(b);
            } catch (r) {
                $7596fa05f9d11773$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $7596fa05f9d11773$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $7596fa05f9d11773$var$V = c;
            break;
        }
        $7596fa05f9d11773$var$V = b.return;
    }
}
function $7596fa05f9d11773$var$gk(a) {
    for(; null !== $7596fa05f9d11773$var$V;){
        var b = $7596fa05f9d11773$var$V;
        if (b === a) {
            $7596fa05f9d11773$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $7596fa05f9d11773$var$V = c;
            break;
        }
        $7596fa05f9d11773$var$V = b.return;
    }
}
function $7596fa05f9d11773$var$jk(a) {
    for(; null !== $7596fa05f9d11773$var$V;){
        var b = $7596fa05f9d11773$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $7596fa05f9d11773$var$Qj(4, b);
                    } catch (k) {
                        $7596fa05f9d11773$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $7596fa05f9d11773$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $7596fa05f9d11773$var$Rj(b);
                    } catch (k) {
                        $7596fa05f9d11773$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $7596fa05f9d11773$var$Rj(b);
                    } catch (k) {
                        $7596fa05f9d11773$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $7596fa05f9d11773$var$W(b, b.return, k);
        }
        if (b === a) {
            $7596fa05f9d11773$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $7596fa05f9d11773$var$V = h;
            break;
        }
        $7596fa05f9d11773$var$V = b.return;
    }
}
var $7596fa05f9d11773$var$lk = Math.ceil, $7596fa05f9d11773$var$mk = $7596fa05f9d11773$var$ua.ReactCurrentDispatcher, $7596fa05f9d11773$var$nk = $7596fa05f9d11773$var$ua.ReactCurrentOwner, $7596fa05f9d11773$var$ok = $7596fa05f9d11773$var$ua.ReactCurrentBatchConfig, $7596fa05f9d11773$var$K = 0, $7596fa05f9d11773$var$Q = null, $7596fa05f9d11773$var$Y = null, $7596fa05f9d11773$var$Z = 0, $7596fa05f9d11773$var$fj = 0, $7596fa05f9d11773$var$ej = $7596fa05f9d11773$var$Uf(0), $7596fa05f9d11773$var$T = 0, $7596fa05f9d11773$var$pk = null, $7596fa05f9d11773$var$rh = 0, $7596fa05f9d11773$var$qk = 0, $7596fa05f9d11773$var$rk = 0, $7596fa05f9d11773$var$sk = null, $7596fa05f9d11773$var$tk = null, $7596fa05f9d11773$var$fk = 0, $7596fa05f9d11773$var$Gj = Infinity, $7596fa05f9d11773$var$uk = null, $7596fa05f9d11773$var$Oi = !1, $7596fa05f9d11773$var$Pi = null, $7596fa05f9d11773$var$Ri = null, $7596fa05f9d11773$var$vk = !1, $7596fa05f9d11773$var$wk = null, $7596fa05f9d11773$var$xk = 0, $7596fa05f9d11773$var$yk = 0, $7596fa05f9d11773$var$zk = null, $7596fa05f9d11773$var$Ak = -1, $7596fa05f9d11773$var$Bk = 0;
function $7596fa05f9d11773$var$R() {
    return 0 !== ($7596fa05f9d11773$var$K & 6) ? $7596fa05f9d11773$var$B() : -1 !== $7596fa05f9d11773$var$Ak ? $7596fa05f9d11773$var$Ak : $7596fa05f9d11773$var$Ak = $7596fa05f9d11773$var$B();
}
function $7596fa05f9d11773$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($7596fa05f9d11773$var$K & 2) && 0 !== $7596fa05f9d11773$var$Z) return $7596fa05f9d11773$var$Z & -$7596fa05f9d11773$var$Z;
    if (null !== $7596fa05f9d11773$var$Kg.transition) return 0 === $7596fa05f9d11773$var$Bk && ($7596fa05f9d11773$var$Bk = $7596fa05f9d11773$var$yc()), $7596fa05f9d11773$var$Bk;
    a = $7596fa05f9d11773$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $7596fa05f9d11773$var$jd(a.type);
    return a;
}
function $7596fa05f9d11773$var$gi(a, b, c, d) {
    if (50 < $7596fa05f9d11773$var$yk) throw $7596fa05f9d11773$var$yk = 0, $7596fa05f9d11773$var$zk = null, Error($7596fa05f9d11773$var$p(185));
    $7596fa05f9d11773$var$Ac(a, c, d);
    if (0 === ($7596fa05f9d11773$var$K & 2) || a !== $7596fa05f9d11773$var$Q) a === $7596fa05f9d11773$var$Q && (0 === ($7596fa05f9d11773$var$K & 2) && ($7596fa05f9d11773$var$qk |= c), 4 === $7596fa05f9d11773$var$T && $7596fa05f9d11773$var$Ck(a, $7596fa05f9d11773$var$Z)), $7596fa05f9d11773$var$Dk(a, d), 1 === c && 0 === $7596fa05f9d11773$var$K && 0 === (b.mode & 1) && ($7596fa05f9d11773$var$Gj = $7596fa05f9d11773$var$B() + 500, $7596fa05f9d11773$var$fg && $7596fa05f9d11773$var$jg());
}
function $7596fa05f9d11773$var$Dk(a, b) {
    var c = a.callbackNode;
    $7596fa05f9d11773$var$wc(a, b);
    var d = $7596fa05f9d11773$var$uc(a, a === $7596fa05f9d11773$var$Q ? $7596fa05f9d11773$var$Z : 0);
    if (0 === d) null !== c && $7596fa05f9d11773$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $7596fa05f9d11773$var$bc(c);
        if (1 === b) 0 === a.tag ? $7596fa05f9d11773$var$ig($7596fa05f9d11773$var$Ek.bind(null, a)) : $7596fa05f9d11773$var$hg($7596fa05f9d11773$var$Ek.bind(null, a)), $7596fa05f9d11773$var$Jf(function() {
            0 === ($7596fa05f9d11773$var$K & 6) && $7596fa05f9d11773$var$jg();
        }), c = null;
        else {
            switch($7596fa05f9d11773$var$Dc(d)){
                case 1:
                    c = $7596fa05f9d11773$var$fc;
                    break;
                case 4:
                    c = $7596fa05f9d11773$var$gc;
                    break;
                case 16:
                    c = $7596fa05f9d11773$var$hc;
                    break;
                case 536870912:
                    c = $7596fa05f9d11773$var$jc;
                    break;
                default:
                    c = $7596fa05f9d11773$var$hc;
            }
            c = $7596fa05f9d11773$var$Fk(c, $7596fa05f9d11773$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $7596fa05f9d11773$var$Gk(a, b) {
    $7596fa05f9d11773$var$Ak = -1;
    $7596fa05f9d11773$var$Bk = 0;
    if (0 !== ($7596fa05f9d11773$var$K & 6)) throw Error($7596fa05f9d11773$var$p(327));
    var c = a.callbackNode;
    if ($7596fa05f9d11773$var$Hk() && a.callbackNode !== c) return null;
    var d = $7596fa05f9d11773$var$uc(a, a === $7596fa05f9d11773$var$Q ? $7596fa05f9d11773$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $7596fa05f9d11773$var$Ik(a, d);
    else {
        b = d;
        var e = $7596fa05f9d11773$var$K;
        $7596fa05f9d11773$var$K |= 2;
        var f = $7596fa05f9d11773$var$Jk();
        if ($7596fa05f9d11773$var$Q !== a || $7596fa05f9d11773$var$Z !== b) $7596fa05f9d11773$var$uk = null, $7596fa05f9d11773$var$Gj = $7596fa05f9d11773$var$B() + 500, $7596fa05f9d11773$var$Kk(a, b);
        for(;;)try {
            $7596fa05f9d11773$var$Lk();
            break;
        } catch (h) {
            $7596fa05f9d11773$var$Mk(a, h);
        }
        $7596fa05f9d11773$var$$g();
        $7596fa05f9d11773$var$mk.current = f;
        $7596fa05f9d11773$var$K = e;
        null !== $7596fa05f9d11773$var$Y ? b = 0 : ($7596fa05f9d11773$var$Q = null, $7596fa05f9d11773$var$Z = 0, b = $7596fa05f9d11773$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $7596fa05f9d11773$var$xc(a), 0 !== e && (d = e, b = $7596fa05f9d11773$var$Nk(a, e)));
        if (1 === b) throw c = $7596fa05f9d11773$var$pk, $7596fa05f9d11773$var$Kk(a, 0), $7596fa05f9d11773$var$Ck(a, d), $7596fa05f9d11773$var$Dk(a, $7596fa05f9d11773$var$B()), c;
        if (6 === b) $7596fa05f9d11773$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$7596fa05f9d11773$var$Ok(e) && (b = $7596fa05f9d11773$var$Ik(a, d), 2 === b && (f = $7596fa05f9d11773$var$xc(a), 0 !== f && (d = f, b = $7596fa05f9d11773$var$Nk(a, f))), 1 === b)) throw c = $7596fa05f9d11773$var$pk, $7596fa05f9d11773$var$Kk(a, 0), $7596fa05f9d11773$var$Ck(a, d), $7596fa05f9d11773$var$Dk(a, $7596fa05f9d11773$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($7596fa05f9d11773$var$p(345));
                case 2:
                    $7596fa05f9d11773$var$Pk(a, $7596fa05f9d11773$var$tk, $7596fa05f9d11773$var$uk);
                    break;
                case 3:
                    $7596fa05f9d11773$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $7596fa05f9d11773$var$fk + 500 - $7596fa05f9d11773$var$B(), 10 < b)) {
                        if (0 !== $7596fa05f9d11773$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $7596fa05f9d11773$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $7596fa05f9d11773$var$Ff($7596fa05f9d11773$var$Pk.bind(null, a, $7596fa05f9d11773$var$tk, $7596fa05f9d11773$var$uk), b);
                        break;
                    }
                    $7596fa05f9d11773$var$Pk(a, $7596fa05f9d11773$var$tk, $7596fa05f9d11773$var$uk);
                    break;
                case 4:
                    $7596fa05f9d11773$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $7596fa05f9d11773$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $7596fa05f9d11773$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $7596fa05f9d11773$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $7596fa05f9d11773$var$Ff($7596fa05f9d11773$var$Pk.bind(null, a, $7596fa05f9d11773$var$tk, $7596fa05f9d11773$var$uk), d);
                        break;
                    }
                    $7596fa05f9d11773$var$Pk(a, $7596fa05f9d11773$var$tk, $7596fa05f9d11773$var$uk);
                    break;
                case 5:
                    $7596fa05f9d11773$var$Pk(a, $7596fa05f9d11773$var$tk, $7596fa05f9d11773$var$uk);
                    break;
                default:
                    throw Error($7596fa05f9d11773$var$p(329));
            }
        }
    }
    $7596fa05f9d11773$var$Dk(a, $7596fa05f9d11773$var$B());
    return a.callbackNode === c ? $7596fa05f9d11773$var$Gk.bind(null, a) : null;
}
function $7596fa05f9d11773$var$Nk(a, b) {
    var c = $7596fa05f9d11773$var$sk;
    a.current.memoizedState.isDehydrated && ($7596fa05f9d11773$var$Kk(a, b).flags |= 256);
    a = $7596fa05f9d11773$var$Ik(a, b);
    2 !== a && (b = $7596fa05f9d11773$var$tk, $7596fa05f9d11773$var$tk = c, null !== b && $7596fa05f9d11773$var$Fj(b));
    return a;
}
function $7596fa05f9d11773$var$Fj(a) {
    null === $7596fa05f9d11773$var$tk ? $7596fa05f9d11773$var$tk = a : $7596fa05f9d11773$var$tk.push.apply($7596fa05f9d11773$var$tk, a);
}
function $7596fa05f9d11773$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$7596fa05f9d11773$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $7596fa05f9d11773$var$Ck(a, b) {
    b &= ~$7596fa05f9d11773$var$rk;
    b &= ~$7596fa05f9d11773$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $7596fa05f9d11773$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $7596fa05f9d11773$var$Ek(a) {
    if (0 !== ($7596fa05f9d11773$var$K & 6)) throw Error($7596fa05f9d11773$var$p(327));
    $7596fa05f9d11773$var$Hk();
    var b = $7596fa05f9d11773$var$uc(a, 0);
    if (0 === (b & 1)) return $7596fa05f9d11773$var$Dk(a, $7596fa05f9d11773$var$B()), null;
    var c = $7596fa05f9d11773$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $7596fa05f9d11773$var$xc(a);
        0 !== d && (b = d, c = $7596fa05f9d11773$var$Nk(a, d));
    }
    if (1 === c) throw c = $7596fa05f9d11773$var$pk, $7596fa05f9d11773$var$Kk(a, 0), $7596fa05f9d11773$var$Ck(a, b), $7596fa05f9d11773$var$Dk(a, $7596fa05f9d11773$var$B()), c;
    if (6 === c) throw Error($7596fa05f9d11773$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $7596fa05f9d11773$var$Pk(a, $7596fa05f9d11773$var$tk, $7596fa05f9d11773$var$uk);
    $7596fa05f9d11773$var$Dk(a, $7596fa05f9d11773$var$B());
    return null;
}
function $7596fa05f9d11773$var$Qk(a, b) {
    var c = $7596fa05f9d11773$var$K;
    $7596fa05f9d11773$var$K |= 1;
    try {
        return a(b);
    } finally{
        $7596fa05f9d11773$var$K = c, 0 === $7596fa05f9d11773$var$K && ($7596fa05f9d11773$var$Gj = $7596fa05f9d11773$var$B() + 500, $7596fa05f9d11773$var$fg && $7596fa05f9d11773$var$jg());
    }
}
function $7596fa05f9d11773$var$Rk(a) {
    null !== $7596fa05f9d11773$var$wk && 0 === $7596fa05f9d11773$var$wk.tag && 0 === ($7596fa05f9d11773$var$K & 6) && $7596fa05f9d11773$var$Hk();
    var b = $7596fa05f9d11773$var$K;
    $7596fa05f9d11773$var$K |= 1;
    var c = $7596fa05f9d11773$var$ok.transition, d = $7596fa05f9d11773$var$C;
    try {
        if ($7596fa05f9d11773$var$ok.transition = null, $7596fa05f9d11773$var$C = 1, a) return a();
    } finally{
        $7596fa05f9d11773$var$C = d, $7596fa05f9d11773$var$ok.transition = c, $7596fa05f9d11773$var$K = b, 0 === ($7596fa05f9d11773$var$K & 6) && $7596fa05f9d11773$var$jg();
    }
}
function $7596fa05f9d11773$var$Hj() {
    $7596fa05f9d11773$var$fj = $7596fa05f9d11773$var$ej.current;
    $7596fa05f9d11773$var$E($7596fa05f9d11773$var$ej);
}
function $7596fa05f9d11773$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $7596fa05f9d11773$var$Gf(c));
    if (null !== $7596fa05f9d11773$var$Y) for(c = $7596fa05f9d11773$var$Y.return; null !== c;){
        var d = c;
        $7596fa05f9d11773$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $7596fa05f9d11773$var$$f();
                break;
            case 3:
                $7596fa05f9d11773$var$zh();
                $7596fa05f9d11773$var$E($7596fa05f9d11773$var$Wf);
                $7596fa05f9d11773$var$E($7596fa05f9d11773$var$H);
                $7596fa05f9d11773$var$Eh();
                break;
            case 5:
                $7596fa05f9d11773$var$Bh(d);
                break;
            case 4:
                $7596fa05f9d11773$var$zh();
                break;
            case 13:
                $7596fa05f9d11773$var$E($7596fa05f9d11773$var$L);
                break;
            case 19:
                $7596fa05f9d11773$var$E($7596fa05f9d11773$var$L);
                break;
            case 10:
                $7596fa05f9d11773$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $7596fa05f9d11773$var$Hj();
        }
        c = c.return;
    }
    $7596fa05f9d11773$var$Q = a;
    $7596fa05f9d11773$var$Y = a = $7596fa05f9d11773$var$Pg(a.current, null);
    $7596fa05f9d11773$var$Z = $7596fa05f9d11773$var$fj = b;
    $7596fa05f9d11773$var$T = 0;
    $7596fa05f9d11773$var$pk = null;
    $7596fa05f9d11773$var$rk = $7596fa05f9d11773$var$qk = $7596fa05f9d11773$var$rh = 0;
    $7596fa05f9d11773$var$tk = $7596fa05f9d11773$var$sk = null;
    if (null !== $7596fa05f9d11773$var$fh) {
        for(b = 0; b < $7596fa05f9d11773$var$fh.length; b++)if (c = $7596fa05f9d11773$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $7596fa05f9d11773$var$fh = null;
    }
    return a;
}
function $7596fa05f9d11773$var$Mk(a, b) {
    do {
        var c = $7596fa05f9d11773$var$Y;
        try {
            $7596fa05f9d11773$var$$g();
            $7596fa05f9d11773$var$Fh.current = $7596fa05f9d11773$var$Rh;
            if ($7596fa05f9d11773$var$Ih) {
                for(var d = $7596fa05f9d11773$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $7596fa05f9d11773$var$Ih = !1;
            }
            $7596fa05f9d11773$var$Hh = 0;
            $7596fa05f9d11773$var$O = $7596fa05f9d11773$var$N = $7596fa05f9d11773$var$M = null;
            $7596fa05f9d11773$var$Jh = !1;
            $7596fa05f9d11773$var$Kh = 0;
            $7596fa05f9d11773$var$nk.current = null;
            if (null === c || null === c.return) {
                $7596fa05f9d11773$var$T = 1;
                $7596fa05f9d11773$var$pk = b;
                $7596fa05f9d11773$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $7596fa05f9d11773$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $7596fa05f9d11773$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $7596fa05f9d11773$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $7596fa05f9d11773$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $7596fa05f9d11773$var$Si(f, l, b);
                            $7596fa05f9d11773$var$tj();
                            break a;
                        }
                        k = Error($7596fa05f9d11773$var$p(426));
                    }
                } else if ($7596fa05f9d11773$var$I && h.mode & 1) {
                    var J = $7596fa05f9d11773$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $7596fa05f9d11773$var$Vi(J, g, h, f, b);
                        $7596fa05f9d11773$var$Jg($7596fa05f9d11773$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $7596fa05f9d11773$var$Ji(k, h);
                4 !== $7596fa05f9d11773$var$T && ($7596fa05f9d11773$var$T = 2);
                null === $7596fa05f9d11773$var$sk ? $7596fa05f9d11773$var$sk = [
                    f
                ] : $7596fa05f9d11773$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $7596fa05f9d11773$var$Ni(f, k, b);
                            $7596fa05f9d11773$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $7596fa05f9d11773$var$Ri || !$7596fa05f9d11773$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $7596fa05f9d11773$var$Qi(f, h, b);
                                $7596fa05f9d11773$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $7596fa05f9d11773$var$Sk(c);
        } catch (na) {
            b = na;
            $7596fa05f9d11773$var$Y === c && null !== c && ($7596fa05f9d11773$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $7596fa05f9d11773$var$Jk() {
    var a = $7596fa05f9d11773$var$mk.current;
    $7596fa05f9d11773$var$mk.current = $7596fa05f9d11773$var$Rh;
    return null === a ? $7596fa05f9d11773$var$Rh : a;
}
function $7596fa05f9d11773$var$tj() {
    if (0 === $7596fa05f9d11773$var$T || 3 === $7596fa05f9d11773$var$T || 2 === $7596fa05f9d11773$var$T) $7596fa05f9d11773$var$T = 4;
    null === $7596fa05f9d11773$var$Q || 0 === ($7596fa05f9d11773$var$rh & 268435455) && 0 === ($7596fa05f9d11773$var$qk & 268435455) || $7596fa05f9d11773$var$Ck($7596fa05f9d11773$var$Q, $7596fa05f9d11773$var$Z);
}
function $7596fa05f9d11773$var$Ik(a, b) {
    var c = $7596fa05f9d11773$var$K;
    $7596fa05f9d11773$var$K |= 2;
    var d = $7596fa05f9d11773$var$Jk();
    if ($7596fa05f9d11773$var$Q !== a || $7596fa05f9d11773$var$Z !== b) $7596fa05f9d11773$var$uk = null, $7596fa05f9d11773$var$Kk(a, b);
    for(;;)try {
        $7596fa05f9d11773$var$Tk();
        break;
    } catch (e) {
        $7596fa05f9d11773$var$Mk(a, e);
    }
    $7596fa05f9d11773$var$$g();
    $7596fa05f9d11773$var$K = c;
    $7596fa05f9d11773$var$mk.current = d;
    if (null !== $7596fa05f9d11773$var$Y) throw Error($7596fa05f9d11773$var$p(261));
    $7596fa05f9d11773$var$Q = null;
    $7596fa05f9d11773$var$Z = 0;
    return $7596fa05f9d11773$var$T;
}
function $7596fa05f9d11773$var$Tk() {
    for(; null !== $7596fa05f9d11773$var$Y;)$7596fa05f9d11773$var$Uk($7596fa05f9d11773$var$Y);
}
function $7596fa05f9d11773$var$Lk() {
    for(; null !== $7596fa05f9d11773$var$Y && !$7596fa05f9d11773$var$cc();)$7596fa05f9d11773$var$Uk($7596fa05f9d11773$var$Y);
}
function $7596fa05f9d11773$var$Uk(a) {
    var b = $7596fa05f9d11773$var$Vk(a.alternate, a, $7596fa05f9d11773$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $7596fa05f9d11773$var$Sk(a) : $7596fa05f9d11773$var$Y = b;
    $7596fa05f9d11773$var$nk.current = null;
}
function $7596fa05f9d11773$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $7596fa05f9d11773$var$Ej(c, b, $7596fa05f9d11773$var$fj), null !== c) {
                $7596fa05f9d11773$var$Y = c;
                return;
            }
        } else {
            c = $7596fa05f9d11773$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $7596fa05f9d11773$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $7596fa05f9d11773$var$T = 6;
                $7596fa05f9d11773$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $7596fa05f9d11773$var$Y = b;
            return;
        }
        $7596fa05f9d11773$var$Y = b = a;
    }while (null !== b);
    0 === $7596fa05f9d11773$var$T && ($7596fa05f9d11773$var$T = 5);
}
function $7596fa05f9d11773$var$Pk(a, b, c) {
    var d = $7596fa05f9d11773$var$C, e = $7596fa05f9d11773$var$ok.transition;
    try {
        $7596fa05f9d11773$var$ok.transition = null, $7596fa05f9d11773$var$C = 1, $7596fa05f9d11773$var$Wk(a, b, c, d);
    } finally{
        $7596fa05f9d11773$var$ok.transition = e, $7596fa05f9d11773$var$C = d;
    }
    return null;
}
function $7596fa05f9d11773$var$Wk(a, b, c, d) {
    do $7596fa05f9d11773$var$Hk();
    while (null !== $7596fa05f9d11773$var$wk);
    if (0 !== ($7596fa05f9d11773$var$K & 6)) throw Error($7596fa05f9d11773$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($7596fa05f9d11773$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $7596fa05f9d11773$var$Bc(a, f);
    a === $7596fa05f9d11773$var$Q && ($7596fa05f9d11773$var$Y = $7596fa05f9d11773$var$Q = null, $7596fa05f9d11773$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $7596fa05f9d11773$var$vk || ($7596fa05f9d11773$var$vk = !0, $7596fa05f9d11773$var$Fk($7596fa05f9d11773$var$hc, function() {
        $7596fa05f9d11773$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $7596fa05f9d11773$var$ok.transition;
        $7596fa05f9d11773$var$ok.transition = null;
        var g = $7596fa05f9d11773$var$C;
        $7596fa05f9d11773$var$C = 1;
        var h = $7596fa05f9d11773$var$K;
        $7596fa05f9d11773$var$K |= 4;
        $7596fa05f9d11773$var$nk.current = null;
        $7596fa05f9d11773$var$Oj(a, c);
        $7596fa05f9d11773$var$dk(c, a);
        $7596fa05f9d11773$var$Oe($7596fa05f9d11773$var$Df);
        $7596fa05f9d11773$var$dd = !!$7596fa05f9d11773$var$Cf;
        $7596fa05f9d11773$var$Df = $7596fa05f9d11773$var$Cf = null;
        a.current = c;
        $7596fa05f9d11773$var$hk(c, a, e);
        $7596fa05f9d11773$var$dc();
        $7596fa05f9d11773$var$K = h;
        $7596fa05f9d11773$var$C = g;
        $7596fa05f9d11773$var$ok.transition = f;
    } else a.current = c;
    $7596fa05f9d11773$var$vk && ($7596fa05f9d11773$var$vk = !1, $7596fa05f9d11773$var$wk = a, $7596fa05f9d11773$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($7596fa05f9d11773$var$Ri = null);
    $7596fa05f9d11773$var$mc(c.stateNode, d);
    $7596fa05f9d11773$var$Dk(a, $7596fa05f9d11773$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($7596fa05f9d11773$var$Oi) throw $7596fa05f9d11773$var$Oi = !1, a = $7596fa05f9d11773$var$Pi, $7596fa05f9d11773$var$Pi = null, a;
    0 !== ($7596fa05f9d11773$var$xk & 1) && 0 !== a.tag && $7596fa05f9d11773$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $7596fa05f9d11773$var$zk ? $7596fa05f9d11773$var$yk++ : ($7596fa05f9d11773$var$yk = 0, $7596fa05f9d11773$var$zk = a) : $7596fa05f9d11773$var$yk = 0;
    $7596fa05f9d11773$var$jg();
    return null;
}
function $7596fa05f9d11773$var$Hk() {
    if (null !== $7596fa05f9d11773$var$wk) {
        var a = $7596fa05f9d11773$var$Dc($7596fa05f9d11773$var$xk), b = $7596fa05f9d11773$var$ok.transition, c = $7596fa05f9d11773$var$C;
        try {
            $7596fa05f9d11773$var$ok.transition = null;
            $7596fa05f9d11773$var$C = 16 > a ? 16 : a;
            if (null === $7596fa05f9d11773$var$wk) var d = !1;
            else {
                a = $7596fa05f9d11773$var$wk;
                $7596fa05f9d11773$var$wk = null;
                $7596fa05f9d11773$var$xk = 0;
                if (0 !== ($7596fa05f9d11773$var$K & 6)) throw Error($7596fa05f9d11773$var$p(331));
                var e = $7596fa05f9d11773$var$K;
                $7596fa05f9d11773$var$K |= 4;
                for($7596fa05f9d11773$var$V = a.current; null !== $7596fa05f9d11773$var$V;){
                    var f = $7596fa05f9d11773$var$V, g = f.child;
                    if (0 !== ($7596fa05f9d11773$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($7596fa05f9d11773$var$V = l; null !== $7596fa05f9d11773$var$V;){
                                    var m = $7596fa05f9d11773$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $7596fa05f9d11773$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $7596fa05f9d11773$var$V = q;
                                    else for(; null !== $7596fa05f9d11773$var$V;){
                                        m = $7596fa05f9d11773$var$V;
                                        var r = m.sibling, y = m.return;
                                        $7596fa05f9d11773$var$Sj(m);
                                        if (m === l) {
                                            $7596fa05f9d11773$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $7596fa05f9d11773$var$V = r;
                                            break;
                                        }
                                        $7596fa05f9d11773$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $7596fa05f9d11773$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $7596fa05f9d11773$var$V = g;
                    else b: for(; null !== $7596fa05f9d11773$var$V;){
                        f = $7596fa05f9d11773$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $7596fa05f9d11773$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $7596fa05f9d11773$var$V = x;
                            break b;
                        }
                        $7596fa05f9d11773$var$V = f.return;
                    }
                }
                var w = a.current;
                for($7596fa05f9d11773$var$V = w; null !== $7596fa05f9d11773$var$V;){
                    g = $7596fa05f9d11773$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $7596fa05f9d11773$var$V = u;
                    else b: for(g = w; null !== $7596fa05f9d11773$var$V;){
                        h = $7596fa05f9d11773$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $7596fa05f9d11773$var$Qj(9, h);
                            }
                        } catch (na) {
                            $7596fa05f9d11773$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $7596fa05f9d11773$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $7596fa05f9d11773$var$V = F;
                            break b;
                        }
                        $7596fa05f9d11773$var$V = h.return;
                    }
                }
                $7596fa05f9d11773$var$K = e;
                $7596fa05f9d11773$var$jg();
                if ($7596fa05f9d11773$var$lc && "function" === typeof $7596fa05f9d11773$var$lc.onPostCommitFiberRoot) try {
                    $7596fa05f9d11773$var$lc.onPostCommitFiberRoot($7596fa05f9d11773$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $7596fa05f9d11773$var$C = c, $7596fa05f9d11773$var$ok.transition = b;
        }
    }
    return !1;
}
function $7596fa05f9d11773$var$Xk(a, b, c) {
    b = $7596fa05f9d11773$var$Ji(c, b);
    b = $7596fa05f9d11773$var$Ni(a, b, 1);
    a = $7596fa05f9d11773$var$nh(a, b, 1);
    b = $7596fa05f9d11773$var$R();
    null !== a && ($7596fa05f9d11773$var$Ac(a, 1, b), $7596fa05f9d11773$var$Dk(a, b));
}
function $7596fa05f9d11773$var$W(a, b, c) {
    if (3 === a.tag) $7596fa05f9d11773$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $7596fa05f9d11773$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $7596fa05f9d11773$var$Ri || !$7596fa05f9d11773$var$Ri.has(d))) {
                a = $7596fa05f9d11773$var$Ji(c, a);
                a = $7596fa05f9d11773$var$Qi(b, a, 1);
                b = $7596fa05f9d11773$var$nh(b, a, 1);
                a = $7596fa05f9d11773$var$R();
                null !== b && ($7596fa05f9d11773$var$Ac(b, 1, a), $7596fa05f9d11773$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $7596fa05f9d11773$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $7596fa05f9d11773$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $7596fa05f9d11773$var$Q === a && ($7596fa05f9d11773$var$Z & c) === c && (4 === $7596fa05f9d11773$var$T || 3 === $7596fa05f9d11773$var$T && ($7596fa05f9d11773$var$Z & 130023424) === $7596fa05f9d11773$var$Z && 500 > $7596fa05f9d11773$var$B() - $7596fa05f9d11773$var$fk ? $7596fa05f9d11773$var$Kk(a, 0) : $7596fa05f9d11773$var$rk |= c);
    $7596fa05f9d11773$var$Dk(a, b);
}
function $7596fa05f9d11773$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $7596fa05f9d11773$var$sc, $7596fa05f9d11773$var$sc <<= 1, 0 === ($7596fa05f9d11773$var$sc & 130023424) && ($7596fa05f9d11773$var$sc = 4194304)));
    var c = $7596fa05f9d11773$var$R();
    a = $7596fa05f9d11773$var$ih(a, b);
    null !== a && ($7596fa05f9d11773$var$Ac(a, b, c), $7596fa05f9d11773$var$Dk(a, c));
}
function $7596fa05f9d11773$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $7596fa05f9d11773$var$Yk(a, c);
}
function $7596fa05f9d11773$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($7596fa05f9d11773$var$p(314));
    }
    null !== d && d.delete(b);
    $7596fa05f9d11773$var$Yk(a, c);
}
var $7596fa05f9d11773$var$Vk;
$7596fa05f9d11773$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $7596fa05f9d11773$var$Wf.current) $7596fa05f9d11773$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $7596fa05f9d11773$var$dh = !1, $7596fa05f9d11773$var$yj(a, b, c);
            $7596fa05f9d11773$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $7596fa05f9d11773$var$dh = !1, $7596fa05f9d11773$var$I && 0 !== (b.flags & 1048576) && $7596fa05f9d11773$var$ug(b, $7596fa05f9d11773$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $7596fa05f9d11773$var$ij(a, b);
            a = b.pendingProps;
            var e = $7596fa05f9d11773$var$Yf(b, $7596fa05f9d11773$var$H.current);
            $7596fa05f9d11773$var$ch(b, c);
            e = $7596fa05f9d11773$var$Nh(null, b, d, a, e, c);
            var f = $7596fa05f9d11773$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $7596fa05f9d11773$var$Zf(d) ? (f = !0, $7596fa05f9d11773$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $7596fa05f9d11773$var$kh(b), e.updater = $7596fa05f9d11773$var$Ei, b.stateNode = e, e._reactInternals = b, $7596fa05f9d11773$var$Ii(b, d, a, c), b = $7596fa05f9d11773$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $7596fa05f9d11773$var$I && f && $7596fa05f9d11773$var$vg(b), $7596fa05f9d11773$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $7596fa05f9d11773$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $7596fa05f9d11773$var$Zk(d);
                a = $7596fa05f9d11773$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $7596fa05f9d11773$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $7596fa05f9d11773$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $7596fa05f9d11773$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $7596fa05f9d11773$var$$i(null, b, d, $7596fa05f9d11773$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($7596fa05f9d11773$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7596fa05f9d11773$var$Ci(d, e), $7596fa05f9d11773$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7596fa05f9d11773$var$Ci(d, e), $7596fa05f9d11773$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $7596fa05f9d11773$var$kj(b);
                if (null === a) throw Error($7596fa05f9d11773$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $7596fa05f9d11773$var$lh(a, b);
                $7596fa05f9d11773$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $7596fa05f9d11773$var$Ji(Error($7596fa05f9d11773$var$p(423)), b);
                        b = $7596fa05f9d11773$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $7596fa05f9d11773$var$Ji(Error($7596fa05f9d11773$var$p(424)), b);
                        b = $7596fa05f9d11773$var$lj(a, b, d, c, e);
                        break a;
                    } else for($7596fa05f9d11773$var$yg = $7596fa05f9d11773$var$Lf(b.stateNode.containerInfo.firstChild), $7596fa05f9d11773$var$xg = b, $7596fa05f9d11773$var$I = !0, $7596fa05f9d11773$var$zg = null, c = $7596fa05f9d11773$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $7596fa05f9d11773$var$Ig();
                    if (d === e) {
                        b = $7596fa05f9d11773$var$Zi(a, b, c);
                        break a;
                    }
                    $7596fa05f9d11773$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $7596fa05f9d11773$var$Ah(b), null === a && $7596fa05f9d11773$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $7596fa05f9d11773$var$Ef(d, e) ? g = null : null !== f && $7596fa05f9d11773$var$Ef(d, f) && (b.flags |= 32), $7596fa05f9d11773$var$gj(a, b), $7596fa05f9d11773$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $7596fa05f9d11773$var$Eg(b), null;
        case 13:
            return $7596fa05f9d11773$var$oj(a, b, c);
        case 4:
            return $7596fa05f9d11773$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $7596fa05f9d11773$var$Ug(b, null, d, c) : $7596fa05f9d11773$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7596fa05f9d11773$var$Ci(d, e), $7596fa05f9d11773$var$Yi(a, b, d, e, c);
        case 7:
            return $7596fa05f9d11773$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $7596fa05f9d11773$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $7596fa05f9d11773$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $7596fa05f9d11773$var$G($7596fa05f9d11773$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($7596fa05f9d11773$var$He(f.value, g)) {
                        if (f.children === e.children && !$7596fa05f9d11773$var$Wf.current) {
                            b = $7596fa05f9d11773$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $7596fa05f9d11773$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $7596fa05f9d11773$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($7596fa05f9d11773$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $7596fa05f9d11773$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $7596fa05f9d11773$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $7596fa05f9d11773$var$ch(b, c), e = $7596fa05f9d11773$var$eh(e), d = d(e), b.flags |= 1, $7596fa05f9d11773$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $7596fa05f9d11773$var$Ci(d, b.pendingProps), e = $7596fa05f9d11773$var$Ci(d.type, e), $7596fa05f9d11773$var$$i(a, b, d, e, c);
        case 15:
            return $7596fa05f9d11773$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7596fa05f9d11773$var$Ci(d, e), $7596fa05f9d11773$var$ij(a, b), b.tag = 1, $7596fa05f9d11773$var$Zf(d) ? (a = !0, $7596fa05f9d11773$var$cg(b)) : a = !1, $7596fa05f9d11773$var$ch(b, c), $7596fa05f9d11773$var$Gi(b, d, e), $7596fa05f9d11773$var$Ii(b, d, e, c), $7596fa05f9d11773$var$jj(null, b, d, !0, a, c);
        case 19:
            return $7596fa05f9d11773$var$xj(a, b, c);
        case 22:
            return $7596fa05f9d11773$var$dj(a, b, c);
    }
    throw Error($7596fa05f9d11773$var$p(156, b.tag));
};
function $7596fa05f9d11773$var$Fk(a, b) {
    return $7596fa05f9d11773$var$ac(a, b);
}
function $7596fa05f9d11773$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $7596fa05f9d11773$var$Bg(a, b, c, d) {
    return new $7596fa05f9d11773$var$$k(a, b, c, d);
}
function $7596fa05f9d11773$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $7596fa05f9d11773$var$Zk(a) {
    if ("function" === typeof a) return $7596fa05f9d11773$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $7596fa05f9d11773$var$Da) return 11;
        if (a === $7596fa05f9d11773$var$Ga) return 14;
    }
    return 2;
}
function $7596fa05f9d11773$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $7596fa05f9d11773$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $7596fa05f9d11773$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $7596fa05f9d11773$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $7596fa05f9d11773$var$ya:
            return $7596fa05f9d11773$var$Tg(c.children, e, f, b);
        case $7596fa05f9d11773$var$za:
            g = 8;
            e |= 8;
            break;
        case $7596fa05f9d11773$var$Aa:
            return a = $7596fa05f9d11773$var$Bg(12, c, b, e | 2), a.elementType = $7596fa05f9d11773$var$Aa, a.lanes = f, a;
        case $7596fa05f9d11773$var$Ea:
            return a = $7596fa05f9d11773$var$Bg(13, c, b, e), a.elementType = $7596fa05f9d11773$var$Ea, a.lanes = f, a;
        case $7596fa05f9d11773$var$Fa:
            return a = $7596fa05f9d11773$var$Bg(19, c, b, e), a.elementType = $7596fa05f9d11773$var$Fa, a.lanes = f, a;
        case $7596fa05f9d11773$var$Ia:
            return $7596fa05f9d11773$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $7596fa05f9d11773$var$Ba:
                    g = 10;
                    break a;
                case $7596fa05f9d11773$var$Ca:
                    g = 9;
                    break a;
                case $7596fa05f9d11773$var$Da:
                    g = 11;
                    break a;
                case $7596fa05f9d11773$var$Ga:
                    g = 14;
                    break a;
                case $7596fa05f9d11773$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($7596fa05f9d11773$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $7596fa05f9d11773$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $7596fa05f9d11773$var$Tg(a, b, c, d) {
    a = $7596fa05f9d11773$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $7596fa05f9d11773$var$pj(a, b, c, d) {
    a = $7596fa05f9d11773$var$Bg(22, a, d, b);
    a.elementType = $7596fa05f9d11773$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $7596fa05f9d11773$var$Qg(a, b, c) {
    a = $7596fa05f9d11773$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $7596fa05f9d11773$var$Sg(a, b, c) {
    b = $7596fa05f9d11773$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $7596fa05f9d11773$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $7596fa05f9d11773$var$zc(0);
    this.expirationTimes = $7596fa05f9d11773$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $7596fa05f9d11773$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $7596fa05f9d11773$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $7596fa05f9d11773$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $7596fa05f9d11773$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $7596fa05f9d11773$var$kh(f);
    return a;
}
function $7596fa05f9d11773$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $7596fa05f9d11773$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $7596fa05f9d11773$var$dl(a) {
    if (!a) return $7596fa05f9d11773$var$Vf;
    a = a._reactInternals;
    a: {
        if ($7596fa05f9d11773$var$Vb(a) !== a || 1 !== a.tag) throw Error($7596fa05f9d11773$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($7596fa05f9d11773$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($7596fa05f9d11773$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($7596fa05f9d11773$var$Zf(c)) return $7596fa05f9d11773$var$bg(a, c, b);
    }
    return b;
}
function $7596fa05f9d11773$var$el(a, b, c, d, e, f, g, h, k) {
    a = $7596fa05f9d11773$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $7596fa05f9d11773$var$dl(null);
    c = a.current;
    d = $7596fa05f9d11773$var$R();
    e = $7596fa05f9d11773$var$yi(c);
    f = $7596fa05f9d11773$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $7596fa05f9d11773$var$nh(c, f, e);
    a.current.lanes = e;
    $7596fa05f9d11773$var$Ac(a, e, d);
    $7596fa05f9d11773$var$Dk(a, d);
    return a;
}
function $7596fa05f9d11773$var$fl(a, b, c, d) {
    var e = b.current, f = $7596fa05f9d11773$var$R(), g = $7596fa05f9d11773$var$yi(e);
    c = $7596fa05f9d11773$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $7596fa05f9d11773$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $7596fa05f9d11773$var$nh(e, b, g);
    null !== a && ($7596fa05f9d11773$var$gi(a, e, g, f), $7596fa05f9d11773$var$oh(a, e, g));
    return g;
}
function $7596fa05f9d11773$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $7596fa05f9d11773$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $7596fa05f9d11773$var$il(a, b) {
    $7596fa05f9d11773$var$hl(a, b);
    (a = a.alternate) && $7596fa05f9d11773$var$hl(a, b);
}
function $7596fa05f9d11773$var$jl() {
    return null;
}
var $7596fa05f9d11773$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $7596fa05f9d11773$var$ll(a) {
    this._internalRoot = a;
}
$7596fa05f9d11773$var$ml.prototype.render = $7596fa05f9d11773$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($7596fa05f9d11773$var$p(409));
    $7596fa05f9d11773$var$fl(a, b, null, null);
};
$7596fa05f9d11773$var$ml.prototype.unmount = $7596fa05f9d11773$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $7596fa05f9d11773$var$Rk(function() {
            $7596fa05f9d11773$var$fl(null, a, null, null);
        });
        b[$7596fa05f9d11773$var$uf] = null;
    }
};
function $7596fa05f9d11773$var$ml(a) {
    this._internalRoot = a;
}
$7596fa05f9d11773$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $7596fa05f9d11773$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $7596fa05f9d11773$var$Qc.length && 0 !== b && b < $7596fa05f9d11773$var$Qc[c].priority; c++);
        $7596fa05f9d11773$var$Qc.splice(c, 0, a);
        0 === c && $7596fa05f9d11773$var$Vc(a);
    }
};
function $7596fa05f9d11773$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $7596fa05f9d11773$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $7596fa05f9d11773$var$pl() {}
function $7596fa05f9d11773$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $7596fa05f9d11773$var$gl(g);
                f.call(a);
            };
        }
        var g = $7596fa05f9d11773$var$el(b, d, a, 0, null, !1, !1, "", $7596fa05f9d11773$var$pl);
        a._reactRootContainer = g;
        a[$7596fa05f9d11773$var$uf] = g.current;
        $7596fa05f9d11773$var$sf(8 === a.nodeType ? a.parentNode : a);
        $7596fa05f9d11773$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $7596fa05f9d11773$var$gl(k);
            h.call(a);
        };
    }
    var k = $7596fa05f9d11773$var$bl(a, 0, !1, null, null, !1, !1, "", $7596fa05f9d11773$var$pl);
    a._reactRootContainer = k;
    a[$7596fa05f9d11773$var$uf] = k.current;
    $7596fa05f9d11773$var$sf(8 === a.nodeType ? a.parentNode : a);
    $7596fa05f9d11773$var$Rk(function() {
        $7596fa05f9d11773$var$fl(b, k, c, d);
    });
    return k;
}
function $7596fa05f9d11773$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $7596fa05f9d11773$var$gl(g);
                h.call(a);
            };
        }
        $7596fa05f9d11773$var$fl(b, g, a, e);
    } else g = $7596fa05f9d11773$var$ql(c, b, a, e, d);
    return $7596fa05f9d11773$var$gl(g);
}
$7596fa05f9d11773$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $7596fa05f9d11773$var$tc(b.pendingLanes);
                0 !== c && ($7596fa05f9d11773$var$Cc(b, c | 1), $7596fa05f9d11773$var$Dk(b, $7596fa05f9d11773$var$B()), 0 === ($7596fa05f9d11773$var$K & 6) && ($7596fa05f9d11773$var$Gj = $7596fa05f9d11773$var$B() + 500, $7596fa05f9d11773$var$jg()));
            }
            break;
        case 13:
            $7596fa05f9d11773$var$Rk(function() {
                var b = $7596fa05f9d11773$var$ih(a, 1);
                if (null !== b) {
                    var c = $7596fa05f9d11773$var$R();
                    $7596fa05f9d11773$var$gi(b, a, 1, c);
                }
            }), $7596fa05f9d11773$var$il(a, 1);
    }
};
$7596fa05f9d11773$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $7596fa05f9d11773$var$ih(a, 134217728);
        if (null !== b) {
            var c = $7596fa05f9d11773$var$R();
            $7596fa05f9d11773$var$gi(b, a, 134217728, c);
        }
        $7596fa05f9d11773$var$il(a, 134217728);
    }
};
$7596fa05f9d11773$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $7596fa05f9d11773$var$yi(a), c = $7596fa05f9d11773$var$ih(a, b);
        if (null !== c) {
            var d = $7596fa05f9d11773$var$R();
            $7596fa05f9d11773$var$gi(c, a, b, d);
        }
        $7596fa05f9d11773$var$il(a, b);
    }
};
$7596fa05f9d11773$var$Hc = function() {
    return $7596fa05f9d11773$var$C;
};
$7596fa05f9d11773$var$Ic = function(a, b) {
    var c = $7596fa05f9d11773$var$C;
    try {
        return $7596fa05f9d11773$var$C = a, b();
    } finally{
        $7596fa05f9d11773$var$C = c;
    }
};
$7596fa05f9d11773$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $7596fa05f9d11773$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $7596fa05f9d11773$var$Db(d);
                        if (!e) throw Error($7596fa05f9d11773$var$p(90));
                        $7596fa05f9d11773$var$Wa(d);
                        $7596fa05f9d11773$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $7596fa05f9d11773$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $7596fa05f9d11773$var$fb(a, !!c.multiple, b, !1);
    }
};
$7596fa05f9d11773$var$Gb = $7596fa05f9d11773$var$Qk;
$7596fa05f9d11773$var$Hb = $7596fa05f9d11773$var$Rk;
var $7596fa05f9d11773$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $7596fa05f9d11773$var$Cb,
        $7596fa05f9d11773$var$ue,
        $7596fa05f9d11773$var$Db,
        $7596fa05f9d11773$var$Eb,
        $7596fa05f9d11773$var$Fb,
        $7596fa05f9d11773$var$Qk
    ]
}, $7596fa05f9d11773$var$tl = {
    findFiberByHostInstance: $7596fa05f9d11773$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $7596fa05f9d11773$var$ul = {
    bundleType: $7596fa05f9d11773$var$tl.bundleType,
    version: $7596fa05f9d11773$var$tl.version,
    rendererPackageName: $7596fa05f9d11773$var$tl.rendererPackageName,
    rendererConfig: $7596fa05f9d11773$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $7596fa05f9d11773$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $7596fa05f9d11773$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $7596fa05f9d11773$var$tl.findFiberByHostInstance || $7596fa05f9d11773$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $7596fa05f9d11773$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$7596fa05f9d11773$var$vl.isDisabled && $7596fa05f9d11773$var$vl.supportsFiber) try {
        $7596fa05f9d11773$var$kc = $7596fa05f9d11773$var$vl.inject($7596fa05f9d11773$var$ul), $7596fa05f9d11773$var$lc = $7596fa05f9d11773$var$vl;
    } catch (a) {}
}
$7596fa05f9d11773$export$ae55be85d98224ed = $7596fa05f9d11773$var$sl;
$7596fa05f9d11773$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$7596fa05f9d11773$var$nl(b)) throw Error($7596fa05f9d11773$var$p(200));
    return $7596fa05f9d11773$var$cl(a, b, null, c);
};
$7596fa05f9d11773$export$882461b6382ed46c = function(a, b) {
    if (!$7596fa05f9d11773$var$nl(a)) throw Error($7596fa05f9d11773$var$p(299));
    var c = !1, d = "", e = $7596fa05f9d11773$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $7596fa05f9d11773$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$7596fa05f9d11773$var$uf] = b.current;
    $7596fa05f9d11773$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $7596fa05f9d11773$var$ll(b);
};
$7596fa05f9d11773$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($7596fa05f9d11773$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($7596fa05f9d11773$var$p(268, a));
    }
    a = $7596fa05f9d11773$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$7596fa05f9d11773$export$cd75ccfd720a3cd4 = function(a) {
    return $7596fa05f9d11773$var$Rk(a);
};
$7596fa05f9d11773$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$7596fa05f9d11773$var$ol(b)) throw Error($7596fa05f9d11773$var$p(200));
    return $7596fa05f9d11773$var$rl(null, a, b, !0, c);
};
$7596fa05f9d11773$export$757ceba2d55c277e = function(a, b, c) {
    if (!$7596fa05f9d11773$var$nl(a)) throw Error($7596fa05f9d11773$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $7596fa05f9d11773$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $7596fa05f9d11773$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$7596fa05f9d11773$var$uf] = b.current;
    $7596fa05f9d11773$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $7596fa05f9d11773$var$ml(b);
};
$7596fa05f9d11773$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$7596fa05f9d11773$var$ol(b)) throw Error($7596fa05f9d11773$var$p(200));
    return $7596fa05f9d11773$var$rl(null, a, b, !1, c);
};
$7596fa05f9d11773$export$502457920280e6be = function(a) {
    if (!$7596fa05f9d11773$var$ol(a)) throw Error($7596fa05f9d11773$var$p(40));
    return a._reactRootContainer ? ($7596fa05f9d11773$var$Rk(function() {
        $7596fa05f9d11773$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$7596fa05f9d11773$var$uf] = null;
        });
    }), !0) : !1;
};
$7596fa05f9d11773$export$c78a37762a8d58e1 = $7596fa05f9d11773$var$Qk;
$7596fa05f9d11773$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$7596fa05f9d11773$var$ol(c)) throw Error($7596fa05f9d11773$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($7596fa05f9d11773$var$p(38));
    return $7596fa05f9d11773$var$rl(a, b, c, !1, d);
};
$7596fa05f9d11773$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("gwmVj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5sAuN"));

});
parcelRegister("5sAuN", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $3f9be08debebac13$export$c4744153514ff05d; }, function (v) { return $3f9be08debebac13$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $3f9be08debebac13$export$3e506c1ccc9cc1a7; }, function (v) { return $3f9be08debebac13$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $3f9be08debebac13$export$e26fe2ed2fa76875; }, function (v) { return $3f9be08debebac13$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $3f9be08debebac13$export$502329bbf4b505b1; }, function (v) { return $3f9be08debebac13$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $3f9be08debebac13$export$6e3807111c4874c4; }, function (v) { return $3f9be08debebac13$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $3f9be08debebac13$export$c27134553091fb3a; }, function (v) { return $3f9be08debebac13$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $3f9be08debebac13$export$33ee1acdc04fd2a2; }, function (v) { return $3f9be08debebac13$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $3f9be08debebac13$export$b00a404bbd5edef2; }, function (v) { return $3f9be08debebac13$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $3f9be08debebac13$export$8352ce38b91d0c62; }, function (v) { return $3f9be08debebac13$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $3f9be08debebac13$export$d66a1c1c77bd778b; }, function (v) { return $3f9be08debebac13$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $3f9be08debebac13$export$d3dfb8e4810cb555; }, function (v) { return $3f9be08debebac13$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $3f9be08debebac13$export$839f9183b0465a69; }, function (v) { return $3f9be08debebac13$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $3f9be08debebac13$export$72fdf0e06517287b; }, function (v) { return $3f9be08debebac13$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $3f9be08debebac13$export$4b844e58a3e414b4; }, function (v) { return $3f9be08debebac13$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $3f9be08debebac13$export$816d2913ae6b83b1; }, function (v) { return $3f9be08debebac13$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $3f9be08debebac13$export$61bcfe829111a1d0; }, function (v) { return $3f9be08debebac13$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $3f9be08debebac13$export$7ee8c9beb337bc3f; }, function (v) { return $3f9be08debebac13$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $3f9be08debebac13$export$b5836b71941fa3ed; }, function (v) { return $3f9be08debebac13$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $3f9be08debebac13$export$cf845f2c119da08a; }, function (v) { return $3f9be08debebac13$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3f9be08debebac13$export$c4744153514ff05d;
var $3f9be08debebac13$export$3e506c1ccc9cc1a7;
var $3f9be08debebac13$export$e26fe2ed2fa76875;
var $3f9be08debebac13$export$502329bbf4b505b1;
var $3f9be08debebac13$export$6e3807111c4874c4;
var $3f9be08debebac13$export$c27134553091fb3a;
var $3f9be08debebac13$export$33ee1acdc04fd2a2;
var $3f9be08debebac13$export$b00a404bbd5edef2;
var $3f9be08debebac13$export$8352ce38b91d0c62;
var $3f9be08debebac13$export$d66a1c1c77bd778b;
var $3f9be08debebac13$export$d3dfb8e4810cb555;
var $3f9be08debebac13$export$839f9183b0465a69;
var $3f9be08debebac13$export$72fdf0e06517287b;
var $3f9be08debebac13$export$4b844e58a3e414b4;
var $3f9be08debebac13$export$816d2913ae6b83b1;
var $3f9be08debebac13$export$61bcfe829111a1d0;
var $3f9be08debebac13$export$7ee8c9beb337bc3f;
var $3f9be08debebac13$export$b5836b71941fa3ed;
var $3f9be08debebac13$export$cf845f2c119da08a;
"use strict";
function $3f9be08debebac13$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3f9be08debebac13$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3f9be08debebac13$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3f9be08debebac13$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3f9be08debebac13$var$g(C, c)) n < e && 0 > $3f9be08debebac13$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3f9be08debebac13$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3f9be08debebac13$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3f9be08debebac13$var$l = performance;
    $3f9be08debebac13$export$c4744153514ff05d = function() {
        return $3f9be08debebac13$var$l.now();
    };
} else {
    var $3f9be08debebac13$var$p = Date, $3f9be08debebac13$var$q = $3f9be08debebac13$var$p.now();
    $3f9be08debebac13$export$c4744153514ff05d = function() {
        return $3f9be08debebac13$var$p.now() - $3f9be08debebac13$var$q;
    };
}
var $3f9be08debebac13$var$r = [], $3f9be08debebac13$var$t = [], $3f9be08debebac13$var$u = 1, $3f9be08debebac13$var$v = null, $3f9be08debebac13$var$y = 3, $3f9be08debebac13$var$z = !1, $3f9be08debebac13$var$A = !1, $3f9be08debebac13$var$B = !1, $3f9be08debebac13$var$D = "function" === typeof setTimeout ? setTimeout : null, $3f9be08debebac13$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3f9be08debebac13$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3f9be08debebac13$var$G(a) {
    for(var b = $3f9be08debebac13$var$h($3f9be08debebac13$var$t); null !== b;){
        if (null === b.callback) $3f9be08debebac13$var$k($3f9be08debebac13$var$t);
        else if (b.startTime <= a) $3f9be08debebac13$var$k($3f9be08debebac13$var$t), b.sortIndex = b.expirationTime, $3f9be08debebac13$var$f($3f9be08debebac13$var$r, b);
        else break;
        b = $3f9be08debebac13$var$h($3f9be08debebac13$var$t);
    }
}
function $3f9be08debebac13$var$H(a) {
    $3f9be08debebac13$var$B = !1;
    $3f9be08debebac13$var$G(a);
    if (!$3f9be08debebac13$var$A) {
        if (null !== $3f9be08debebac13$var$h($3f9be08debebac13$var$r)) $3f9be08debebac13$var$A = !0, $3f9be08debebac13$var$I($3f9be08debebac13$var$J);
        else {
            var b = $3f9be08debebac13$var$h($3f9be08debebac13$var$t);
            null !== b && $3f9be08debebac13$var$K($3f9be08debebac13$var$H, b.startTime - a);
        }
    }
}
function $3f9be08debebac13$var$J(a, b) {
    $3f9be08debebac13$var$A = !1;
    $3f9be08debebac13$var$B && ($3f9be08debebac13$var$B = !1, $3f9be08debebac13$var$E($3f9be08debebac13$var$L), $3f9be08debebac13$var$L = -1);
    $3f9be08debebac13$var$z = !0;
    var c = $3f9be08debebac13$var$y;
    try {
        $3f9be08debebac13$var$G(b);
        for($3f9be08debebac13$var$v = $3f9be08debebac13$var$h($3f9be08debebac13$var$r); null !== $3f9be08debebac13$var$v && (!($3f9be08debebac13$var$v.expirationTime > b) || a && !$3f9be08debebac13$var$M());){
            var d = $3f9be08debebac13$var$v.callback;
            if ("function" === typeof d) {
                $3f9be08debebac13$var$v.callback = null;
                $3f9be08debebac13$var$y = $3f9be08debebac13$var$v.priorityLevel;
                var e = d($3f9be08debebac13$var$v.expirationTime <= b);
                b = $3f9be08debebac13$export$c4744153514ff05d();
                "function" === typeof e ? $3f9be08debebac13$var$v.callback = e : $3f9be08debebac13$var$v === $3f9be08debebac13$var$h($3f9be08debebac13$var$r) && $3f9be08debebac13$var$k($3f9be08debebac13$var$r);
                $3f9be08debebac13$var$G(b);
            } else $3f9be08debebac13$var$k($3f9be08debebac13$var$r);
            $3f9be08debebac13$var$v = $3f9be08debebac13$var$h($3f9be08debebac13$var$r);
        }
        if (null !== $3f9be08debebac13$var$v) var w = !0;
        else {
            var m = $3f9be08debebac13$var$h($3f9be08debebac13$var$t);
            null !== m && $3f9be08debebac13$var$K($3f9be08debebac13$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3f9be08debebac13$var$v = null, $3f9be08debebac13$var$y = c, $3f9be08debebac13$var$z = !1;
    }
}
var $3f9be08debebac13$var$N = !1, $3f9be08debebac13$var$O = null, $3f9be08debebac13$var$L = -1, $3f9be08debebac13$var$P = 5, $3f9be08debebac13$var$Q = -1;
function $3f9be08debebac13$var$M() {
    return $3f9be08debebac13$export$c4744153514ff05d() - $3f9be08debebac13$var$Q < $3f9be08debebac13$var$P ? !1 : !0;
}
function $3f9be08debebac13$var$R() {
    if (null !== $3f9be08debebac13$var$O) {
        var a = $3f9be08debebac13$export$c4744153514ff05d();
        $3f9be08debebac13$var$Q = a;
        var b = !0;
        try {
            b = $3f9be08debebac13$var$O(!0, a);
        } finally{
            b ? $3f9be08debebac13$var$S() : ($3f9be08debebac13$var$N = !1, $3f9be08debebac13$var$O = null);
        }
    } else $3f9be08debebac13$var$N = !1;
}
var $3f9be08debebac13$var$S;
if ("function" === typeof $3f9be08debebac13$var$F) $3f9be08debebac13$var$S = function() {
    $3f9be08debebac13$var$F($3f9be08debebac13$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3f9be08debebac13$var$T = new MessageChannel, $3f9be08debebac13$var$U = $3f9be08debebac13$var$T.port2;
    $3f9be08debebac13$var$T.port1.onmessage = $3f9be08debebac13$var$R;
    $3f9be08debebac13$var$S = function() {
        $3f9be08debebac13$var$U.postMessage(null);
    };
} else $3f9be08debebac13$var$S = function() {
    $3f9be08debebac13$var$D($3f9be08debebac13$var$R, 0);
};
function $3f9be08debebac13$var$I(a) {
    $3f9be08debebac13$var$O = a;
    $3f9be08debebac13$var$N || ($3f9be08debebac13$var$N = !0, $3f9be08debebac13$var$S());
}
function $3f9be08debebac13$var$K(a, b) {
    $3f9be08debebac13$var$L = $3f9be08debebac13$var$D(function() {
        a($3f9be08debebac13$export$c4744153514ff05d());
    }, b);
}
$3f9be08debebac13$export$3e506c1ccc9cc1a7 = 5;
$3f9be08debebac13$export$e26fe2ed2fa76875 = 1;
$3f9be08debebac13$export$502329bbf4b505b1 = 4;
$3f9be08debebac13$export$6e3807111c4874c4 = 3;
$3f9be08debebac13$export$c27134553091fb3a = null;
$3f9be08debebac13$export$33ee1acdc04fd2a2 = 2;
$3f9be08debebac13$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3f9be08debebac13$export$8352ce38b91d0c62 = function() {
    $3f9be08debebac13$var$A || $3f9be08debebac13$var$z || ($3f9be08debebac13$var$A = !0, $3f9be08debebac13$var$I($3f9be08debebac13$var$J));
};
$3f9be08debebac13$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3f9be08debebac13$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3f9be08debebac13$export$d3dfb8e4810cb555 = function() {
    return $3f9be08debebac13$var$y;
};
$3f9be08debebac13$export$839f9183b0465a69 = function() {
    return $3f9be08debebac13$var$h($3f9be08debebac13$var$r);
};
$3f9be08debebac13$export$72fdf0e06517287b = function(a) {
    switch($3f9be08debebac13$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3f9be08debebac13$var$y;
    }
    var c = $3f9be08debebac13$var$y;
    $3f9be08debebac13$var$y = b;
    try {
        return a();
    } finally{
        $3f9be08debebac13$var$y = c;
    }
};
$3f9be08debebac13$export$4b844e58a3e414b4 = function() {};
$3f9be08debebac13$export$816d2913ae6b83b1 = function() {};
$3f9be08debebac13$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3f9be08debebac13$var$y;
    $3f9be08debebac13$var$y = a;
    try {
        return b();
    } finally{
        $3f9be08debebac13$var$y = c;
    }
};
$3f9be08debebac13$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3f9be08debebac13$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3f9be08debebac13$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3f9be08debebac13$var$f($3f9be08debebac13$var$t, a), null === $3f9be08debebac13$var$h($3f9be08debebac13$var$r) && a === $3f9be08debebac13$var$h($3f9be08debebac13$var$t) && ($3f9be08debebac13$var$B ? ($3f9be08debebac13$var$E($3f9be08debebac13$var$L), $3f9be08debebac13$var$L = -1) : $3f9be08debebac13$var$B = !0, $3f9be08debebac13$var$K($3f9be08debebac13$var$H, c - d))) : (a.sortIndex = e, $3f9be08debebac13$var$f($3f9be08debebac13$var$r, a), $3f9be08debebac13$var$A || $3f9be08debebac13$var$z || ($3f9be08debebac13$var$A = !0, $3f9be08debebac13$var$I($3f9be08debebac13$var$J)));
    return a;
};
$3f9be08debebac13$export$b5836b71941fa3ed = $3f9be08debebac13$var$M;
$3f9be08debebac13$export$cf845f2c119da08a = function(a) {
    var b = $3f9be08debebac13$var$y;
    return function() {
        var c = $3f9be08debebac13$var$y;
        $3f9be08debebac13$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3f9be08debebac13$var$y = c;
        }
    };
};

});



var $8f33693030ac5281$exports = {};
"use strict";

$8f33693030ac5281$exports = (parcelRequire("lqFeq"));



var $x1Cpm = parcelRequire("x1Cpm");
var $8592eaaa51ed4368$exports = {};

$parcel$export($8592eaaa51ed4368$exports, "createRoot", function () { return $8592eaaa51ed4368$export$882461b6382ed46c; }, function (v) { return $8592eaaa51ed4368$export$882461b6382ed46c = v; });
$parcel$export($8592eaaa51ed4368$exports, "hydrateRoot", function () { return $8592eaaa51ed4368$export$757ceba2d55c277e; }, function (v) { return $8592eaaa51ed4368$export$757ceba2d55c277e = v; });
var $8592eaaa51ed4368$export$882461b6382ed46c;
var $8592eaaa51ed4368$export$757ceba2d55c277e;
"use strict";
var $ec981bc2d1b2e86a$exports = {};
"use strict";
function $ec981bc2d1b2e86a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ec981bc2d1b2e86a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ec981bc2d1b2e86a$var$checkDCE();

$ec981bc2d1b2e86a$exports = (parcelRequire("a5Vvh"));


var $8592eaaa51ed4368$var$i;
$8592eaaa51ed4368$export$882461b6382ed46c = $ec981bc2d1b2e86a$exports.createRoot;
$8592eaaa51ed4368$export$757ceba2d55c277e = $ec981bc2d1b2e86a$exports.hydrateRoot;



/* eslint-disable react/no-unescaped-entities */ 
var $2c12eafc84bcc5a9$export$38e42c68cf43b5d4;
var $2c12eafc84bcc5a9$export$db3c28d99448dcff;
$2c12eafc84bcc5a9$export$38e42c68cf43b5d4 = `gPMrEW_header`;
$2c12eafc84bcc5a9$export$db3c28d99448dcff = `gPMrEW_logo`;



var $x1Cpm = parcelRequire("x1Cpm");
async function $df9b98b38d7c65c2$var$call(endpoint, data, signal) {
    return await fetch(endpoint, {
        method: "POST",
        cache: "no-cache",
        headers: {
            "content-type": "application/json"
        },
        body: JSON.stringify(data),
        signal: signal
    });
}
async function $df9b98b38d7c65c2$export$8f24540c37096eb6(room, version, signal) {
    const resp = await $df9b98b38d7c65c2$var$call("/list", {
        room: room,
        version: version
    }, signal);
    switch(resp.status){
        case 200:
            return await resp.json();
        case 204:
            return {
                timeout: true
            };
        case 404:
            return null;
        default:
            throw new Error(`/list returned unexpected status code ${resp.status}`);
    }
}
async function $df9b98b38d7c65c2$export$254d8d9a9e824f11(room, version, data, signal) {
    return await (await $df9b98b38d7c65c2$var$call("/commit", {
        room: room,
        version: version,
        data: data
    }, signal)).json();
}
async function $df9b98b38d7c65c2$export$5ad94f5fb1ec657b(data, signal) {
    return await (await $df9b98b38d7c65c2$var$call("/make_room", {
        data: data
    }, signal)).json();
}


var $4c9ffbddec832565$export$7cd7a93136e7148a;
(function(GameMode) {
    GameMode["TEXAS_HOLDEM"] = "texas_holdem";
    GameMode["OMAHA"] = "omaha";
})($4c9ffbddec832565$export$7cd7a93136e7148a || ($4c9ffbddec832565$export$7cd7a93136e7148a = {}));
var $4c9ffbddec832565$export$1179af6d199a01fa;
(function(RoomPhase) {
    RoomPhase["SETUP"] = "setup";
    RoomPhase["BIDDING"] = "bidding";
    RoomPhase["SCORING"] = "scoring";
})($4c9ffbddec832565$export$1179af6d199a01fa || ($4c9ffbddec832565$export$1179af6d199a01fa = {}));
const $4c9ffbddec832565$export$a0bea9b09a67f3da = {
    phase: "setup",
    players: [],
    config: {
        gameMode: "texas_holdem",
        withJokers: false,
        targetWins: 3,
        targetLosses: 3
    }
};




var $x1Cpm = parcelRequire("x1Cpm");
function $e5516a3b810d567d$export$1391212d75b2ee65(duration) {
    return new Promise((resolve)=>setTimeout(resolve, duration));
}
function $e5516a3b810d567d$export$bffa455ba8c619a6(list) {
    return [].concat(...list);
}
function $e5516a3b810d567d$export$448332262467e042(list) {
    const array = Array.from(list);
    for(let i = 1; i < array.length; i++){
        const j = Math.floor(Math.random() * (i + 1));
        if (i !== j) {
            const val = array[i];
            array[i] = array[j];
            array[j] = val;
        }
    }
    return array;
}
function $e5516a3b810d567d$export$9cb4719e2e525b7a(x, y) {
    if (x === y) return true;
    if (x == null || y == null) return false;
    if (typeof x == "object" && typeof y == "object") {
        if (Array.isArray(x) && Array.isArray(y)) {
            if (x.length !== y.length) return false;
            for(let i = 0; i < x.length; i++){
                if (!$e5516a3b810d567d$export$9cb4719e2e525b7a(x[i], y[i])) return false;
            }
            return true;
        } else if (!Array.isArray(x) && !Array.isArray(y)) {
            const xk = Object.keys(x);
            const yk = Object.keys(y);
            if (xk.length !== yk.length) return false;
            for (const key of xk){
                if (!Object.prototype.hasOwnProperty.call(y, key)) return false;
                if (!$e5516a3b810d567d$export$9cb4719e2e525b7a(x[key], y[key])) return false;
            }
            return true;
        }
    }
    return false;
}
function $e5516a3b810d567d$export$c9123f98506f8b3e(xs, index, f) {
    return xs.map((item, i)=>i === index ? f(item) : item);
}



const $f275c1bee2ad9b3e$var$Operation = {
    Remove: "remove",
    Replace: "replace",
    Add: "add"
};
// Don't use `Symbol()` just for 3rd party access the draft
const $f275c1bee2ad9b3e$var$PROXY_DRAFT = Symbol.for("__MUTATIVE_PROXY_DRAFT__");
const $f275c1bee2ad9b3e$var$RAW_RETURN_SYMBOL = Symbol("__MUTATIVE_RAW_RETURN_SYMBOL__");
const $f275c1bee2ad9b3e$var$iteratorSymbol = Symbol.iterator;
const $f275c1bee2ad9b3e$var$dataTypes = {
    mutable: "mutable",
    immutable: "immutable"
};
const $f275c1bee2ad9b3e$var$internal = {};
function $f275c1bee2ad9b3e$var$latest(proxyDraft) {
    var _a;
    return (_a = proxyDraft.copy) !== null && _a !== void 0 ? _a : proxyDraft.original;
}
/**
 * Check if the value is a draft
 */ function $f275c1bee2ad9b3e$export$541ac630993a4c84(target) {
    return !!$f275c1bee2ad9b3e$var$getProxyDraft(target);
}
function $f275c1bee2ad9b3e$var$getProxyDraft(value) {
    if (typeof value !== "object") return null;
    return value === null || value === void 0 ? void 0 : value[$f275c1bee2ad9b3e$var$PROXY_DRAFT];
}
function $f275c1bee2ad9b3e$var$getValue(value) {
    var _a;
    const proxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy) !== null && _a !== void 0 ? _a : proxyDraft.original : value;
}
/**
 * Check if a value is draftable
 */ function $f275c1bee2ad9b3e$export$16e3aed3edb85946(value, options) {
    if (!value || typeof value !== "object") return false;
    let markResult;
    return Object.getPrototypeOf(value) === Object.prototype || Array.isArray(value) || value instanceof Map || value instanceof Set || !!(options === null || options === void 0 ? void 0 : options.mark) && ((markResult = options.mark(value, $f275c1bee2ad9b3e$var$dataTypes)) === $f275c1bee2ad9b3e$var$dataTypes.immutable || typeof markResult === "function");
}
function $f275c1bee2ad9b3e$var$getPath(target, path = []) {
    if (Object.hasOwnProperty.call(target, "key")) {
        // check if the parent is a draft and the original value is not equal to the current value
        const proxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft($f275c1bee2ad9b3e$var$get(target.parent.copy, target.key));
        if (proxyDraft !== null && (proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.original) !== target.original) return null;
        path.push(target.parent.type === 3 /* DraftType.Set */  ? Array.from(target.parent.setMap.keys()).indexOf(target.key) : target.key);
    }
    if (target.parent) return $f275c1bee2ad9b3e$var$getPath(target.parent, path);
    // `target` is root draft.
    path.reverse();
    try {
        // check if the path is valid
        $f275c1bee2ad9b3e$var$resolvePath(target.copy, path);
    } catch (e) {
        return null;
    }
    return path;
}
function $f275c1bee2ad9b3e$var$getType(target) {
    if (Array.isArray(target)) return 1 /* DraftType.Array */ ;
    if (target instanceof Map) return 2 /* DraftType.Map */ ;
    if (target instanceof Set) return 3 /* DraftType.Set */ ;
    return 0 /* DraftType.Object */ ;
}
function $f275c1bee2ad9b3e$var$get(target, key) {
    return $f275c1bee2ad9b3e$var$getType(target) === 2 /* DraftType.Map */  ? target.get(key) : target[key];
}
function $f275c1bee2ad9b3e$var$set(target, key, value) {
    const type = $f275c1bee2ad9b3e$var$getType(target);
    if (type === 2 /* DraftType.Map */ ) target.set(key, value);
    else target[key] = value;
}
function $f275c1bee2ad9b3e$var$peek(target, key) {
    const state = $f275c1bee2ad9b3e$var$getProxyDraft(target);
    const source = state ? $f275c1bee2ad9b3e$var$latest(state) : target;
    return source[key];
}
function $f275c1bee2ad9b3e$var$isEqual(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $f275c1bee2ad9b3e$var$revokeProxy(proxyDraft) {
    if (!proxyDraft) return;
    while(proxyDraft.finalities.revoke.length > 0){
        const revoke = proxyDraft.finalities.revoke.pop();
        revoke();
    }
}
// handle JSON Pointer path with spec https://www.rfc-editor.org/rfc/rfc6901
function $f275c1bee2ad9b3e$var$escapePath(path, pathAsArray) {
    return pathAsArray ? path : [
        ""
    ].concat(path).map((_item)=>{
        const item = `${_item}`;
        if (item.indexOf("/") === -1 && item.indexOf("~") === -1) return item;
        return item.replace(/~/g, "~0").replace(/\//g, "~1");
    }).join("/");
}
function $f275c1bee2ad9b3e$var$unescapePath(path) {
    if (Array.isArray(path)) return path;
    return path.split("/").map((_item)=>_item.replace(/~1/g, "/").replace(/~0/g, "~")).slice(1);
}
function $f275c1bee2ad9b3e$var$resolvePath(base, path) {
    for(let index = 0; index < path.length - 1; index += 1){
        const key = path[index];
        // use `index` in Set draft
        base = $f275c1bee2ad9b3e$var$get($f275c1bee2ad9b3e$var$getType(base) === 3 /* DraftType.Set */  ? Array.from(base) : base, key);
        if (typeof base !== "object") throw new Error(`Cannot resolve patch at '${path.join("/")}'.`);
    }
    return base;
}
function $f275c1bee2ad9b3e$var$strictCopy(target) {
    const copy = Object.create(Object.getPrototypeOf(target));
    Reflect.ownKeys(target).forEach((key)=>{
        let desc = Reflect.getOwnPropertyDescriptor(target, key);
        if (desc.enumerable && desc.configurable && desc.writable) {
            copy[key] = target[key];
            return;
        }
        // for freeze
        if (!desc.writable) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) desc = {
            configurable: true,
            writable: true,
            enumerable: desc.enumerable,
            value: target[key]
        };
        Reflect.defineProperty(copy, key, desc);
    });
    return copy;
}
const $f275c1bee2ad9b3e$var$propIsEnum = Object.prototype.propertyIsEnumerable;
function $f275c1bee2ad9b3e$var$shallowCopy(original, options) {
    let markResult;
    if (Array.isArray(original)) return Array.prototype.concat.call(original);
    else if (original instanceof Set) return new Set(original.values());
    else if (original instanceof Map) return new Map(original);
    else if ((options === null || options === void 0 ? void 0 : options.mark) && (markResult = options.mark(original, $f275c1bee2ad9b3e$var$dataTypes), markResult !== undefined) && markResult !== $f275c1bee2ad9b3e$var$dataTypes.mutable) {
        if (markResult === $f275c1bee2ad9b3e$var$dataTypes.immutable) return $f275c1bee2ad9b3e$var$strictCopy(original);
        else if (typeof markResult === "function") {
            if (options.enablePatches || options.enableAutoFreeze) throw new Error(`You can't use mark and patches or auto freeze together.`);
            return markResult();
        }
        throw new Error(`Unsupported mark result: ${markResult}`);
    } else if (typeof original === "object" && Object.getPrototypeOf(original) === Object.prototype) {
        // For best performance with shallow copies,
        // don't use `Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));` by default.
        const copy = {};
        Object.keys(original).forEach((key)=>{
            copy[key] = original[key];
        });
        Object.getOwnPropertySymbols(original).forEach((key)=>{
            if ($f275c1bee2ad9b3e$var$propIsEnum.call(original, key)) copy[key] = original[key];
        });
        return copy;
    } else throw new Error(`Please check mark() to ensure that it is a stable marker draftable function.`);
}
function $f275c1bee2ad9b3e$var$ensureShallowCopy(target) {
    if (target.copy) return;
    target.copy = $f275c1bee2ad9b3e$var$shallowCopy(target.original, target.options);
}
function $f275c1bee2ad9b3e$var$deepClone(target) {
    if (!$f275c1bee2ad9b3e$export$16e3aed3edb85946(target)) return $f275c1bee2ad9b3e$var$getValue(target);
    if (Array.isArray(target)) return target.map($f275c1bee2ad9b3e$var$deepClone);
    if (target instanceof Map) return new Map(Array.from(target.entries()).map(([k, v])=>[
            k,
            $f275c1bee2ad9b3e$var$deepClone(v)
        ]));
    if (target instanceof Set) return new Set(Array.from(target).map($f275c1bee2ad9b3e$var$deepClone));
    const copy = Object.create(Object.getPrototypeOf(target));
    for(const key in target)copy[key] = $f275c1bee2ad9b3e$var$deepClone(target[key]);
    return copy;
}
function $f275c1bee2ad9b3e$var$cloneIfNeeded(target) {
    return $f275c1bee2ad9b3e$export$541ac630993a4c84(target) ? $f275c1bee2ad9b3e$var$deepClone(target) : target;
}
function $f275c1bee2ad9b3e$var$markChanged(proxyDraft) {
    var _a;
    proxyDraft.assignedMap = (_a = proxyDraft.assignedMap) !== null && _a !== void 0 ? _a : new Map();
    if (!proxyDraft.operated) {
        proxyDraft.operated = true;
        if (proxyDraft.parent) $f275c1bee2ad9b3e$var$markChanged(proxyDraft.parent);
    }
}
function $f275c1bee2ad9b3e$var$throwFrozenError() {
    throw new Error("Cannot modify frozen object");
}
function $f275c1bee2ad9b3e$var$deepFreeze(target, subKey, updatedValues, stack, keys) {
    {
        updatedValues = updatedValues !== null && updatedValues !== void 0 ? updatedValues : new WeakMap();
        stack = stack !== null && stack !== void 0 ? stack : [];
        keys = keys !== null && keys !== void 0 ? keys : [];
        const value = updatedValues.has(target) ? updatedValues.get(target) : target;
        if (stack.length > 0) {
            const index = stack.indexOf(value);
            if (value && typeof value === "object" && index !== -1) {
                if (stack[0] === value) throw new Error(`Forbids circular reference`);
                throw new Error(`Forbids circular reference: ~/${keys.slice(0, index).map((key, index)=>{
                    if (typeof key === "symbol") return `[${key.toString()}]`;
                    const parent = stack[index];
                    if (typeof key === "object" && (parent instanceof Map || parent instanceof Set)) return Array.from(parent.keys()).indexOf(key);
                    return key;
                }).join("/")}`);
            }
            stack.push(value);
            keys.push(subKey);
        } else stack.push(value);
    }
    if (Object.isFrozen(target) || $f275c1bee2ad9b3e$export$541ac630993a4c84(target)) {
        stack.pop();
        keys.pop();
        return;
    }
    const type = $f275c1bee2ad9b3e$var$getType(target);
    switch(type){
        case 2 /* DraftType.Map */ :
            for (const [key, value] of target){
                $f275c1bee2ad9b3e$var$deepFreeze(key, key, updatedValues, stack, keys);
                $f275c1bee2ad9b3e$var$deepFreeze(value, key, updatedValues, stack, keys);
            }
            target.set = target.clear = target.delete = $f275c1bee2ad9b3e$var$throwFrozenError;
            break;
        case 3 /* DraftType.Set */ :
            for (const value of target)$f275c1bee2ad9b3e$var$deepFreeze(value, value, updatedValues, stack, keys);
            target.add = target.clear = target.delete = $f275c1bee2ad9b3e$var$throwFrozenError;
            break;
        case 1 /* DraftType.Array */ :
            Object.freeze(target);
            let index = 0;
            for (const value of target){
                $f275c1bee2ad9b3e$var$deepFreeze(value, index, updatedValues, stack, keys);
                index += 1;
            }
            break;
        default:
            Object.freeze(target);
            // ignore non-enumerable or symbol properties
            Object.keys(target).forEach((name)=>{
                const value = target[name];
                $f275c1bee2ad9b3e$var$deepFreeze(value, name, updatedValues, stack, keys);
            });
    }
    stack.pop();
    keys.pop();
}
function $f275c1bee2ad9b3e$var$has(target, key) {
    return target instanceof Map ? target.has(key) : Object.prototype.hasOwnProperty.call(target, key);
}
function $f275c1bee2ad9b3e$var$getDescriptor(target, key) {
    if (key in target) {
        let prototype = Reflect.getPrototypeOf(target);
        while(prototype){
            const descriptor = Reflect.getOwnPropertyDescriptor(prototype, key);
            if (descriptor) return descriptor;
            prototype = Reflect.getPrototypeOf(prototype);
        }
    }
    return;
}
function $f275c1bee2ad9b3e$var$forEach(target, iter) {
    const type = $f275c1bee2ad9b3e$var$getType(target);
    if (type === 0 /* DraftType.Object */ ) Reflect.ownKeys(target).forEach((key)=>{
        iter(key, target[key], target);
    });
    else if (type === 1 /* DraftType.Array */ ) {
        let index = 0;
        for (const entry of target){
            iter(index, entry, target);
            index += 1;
        }
    } else target.forEach((entry, index)=>iter(index, entry, target));
}
function $f275c1bee2ad9b3e$var$handleValue(target, handledSet, options) {
    if ($f275c1bee2ad9b3e$export$541ac630993a4c84(target) || !$f275c1bee2ad9b3e$export$16e3aed3edb85946(target, options) || handledSet.has(target) || Object.isFrozen(target)) return;
    const isSet = target instanceof Set;
    const setMap = isSet ? new Map() : undefined;
    handledSet.add(target);
    $f275c1bee2ad9b3e$var$forEach(target, (key, value)=>{
        var _a;
        if ($f275c1bee2ad9b3e$export$541ac630993a4c84(value)) {
            const proxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(value);
            $f275c1bee2ad9b3e$var$ensureShallowCopy(proxyDraft);
            // A draft where a child node has been changed, or assigned a value
            const updatedValue = ((_a = proxyDraft.assignedMap) === null || _a === void 0 ? void 0 : _a.size) || proxyDraft.operated ? proxyDraft.copy : proxyDraft.original;
            // final update value
            $f275c1bee2ad9b3e$var$set(isSet ? setMap : target, key, updatedValue);
        } else $f275c1bee2ad9b3e$var$handleValue(value, handledSet, options);
    });
    if (setMap) {
        const set = target;
        const values = Array.from(set);
        set.clear();
        values.forEach((value)=>{
            set.add(setMap.has(value) ? setMap.get(value) : value);
        });
    }
}
function $f275c1bee2ad9b3e$var$finalizeAssigned(proxyDraft, key) {
    // handle the draftable assigned values， and the value is not a draft
    const copy = proxyDraft.type === 3 /* DraftType.Set */  ? proxyDraft.setMap : proxyDraft.copy;
    if (proxyDraft.finalities.revoke.length > 1 && proxyDraft.assignedMap.get(key) && copy) $f275c1bee2ad9b3e$var$handleValue($f275c1bee2ad9b3e$var$get(copy, key), proxyDraft.finalities.handledSet, proxyDraft.options);
}
function $f275c1bee2ad9b3e$var$finalizeSetValue(target) {
    if (target.type === 3 /* DraftType.Set */  && target.copy) {
        target.copy.clear();
        target.setMap.forEach((value)=>{
            target.copy.add($f275c1bee2ad9b3e$var$getValue(value));
        });
    }
}
function $f275c1bee2ad9b3e$var$finalizePatches(target, generatePatches, patches, inversePatches) {
    const shouldFinalize = target.operated && target.assignedMap && target.assignedMap.size > 0 && !target.finalized;
    if (shouldFinalize) {
        if (patches && inversePatches) {
            const basePath = $f275c1bee2ad9b3e$var$getPath(target);
            if (basePath) generatePatches(target, basePath, patches, inversePatches);
        }
        target.finalized = true;
    }
}
function $f275c1bee2ad9b3e$var$markFinalization(target, key, value, generatePatches) {
    const proxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(value);
    if (proxyDraft) {
        // !case: assign the draft value
        if (!proxyDraft.callbacks) proxyDraft.callbacks = [];
        proxyDraft.callbacks.push((patches, inversePatches)=>{
            var _a;
            const copy = target.type === 3 /* DraftType.Set */  ? target.setMap : target.copy;
            if ($f275c1bee2ad9b3e$var$isEqual($f275c1bee2ad9b3e$var$get(copy, key), value)) {
                let updatedValue = proxyDraft.original;
                if (proxyDraft.copy) updatedValue = proxyDraft.copy;
                $f275c1bee2ad9b3e$var$finalizeSetValue(target);
                $f275c1bee2ad9b3e$var$finalizePatches(target, generatePatches, patches, inversePatches);
                if (target.options.enableAutoFreeze) {
                    target.options.updatedValues = (_a = target.options.updatedValues) !== null && _a !== void 0 ? _a : new WeakMap();
                    target.options.updatedValues.set(updatedValue, proxyDraft.original);
                }
                // final update value
                $f275c1bee2ad9b3e$var$set(copy, key, updatedValue);
            }
        });
        if (target.options.enableAutoFreeze) // !case: assign the draft value in cross draft tree
        {
            if (proxyDraft.finalities !== target.finalities) target.options.enableAutoFreeze = false;
        }
    }
    if ($f275c1bee2ad9b3e$export$16e3aed3edb85946(value, target.options)) // !case: assign the non-draft value
    target.finalities.draft.push(()=>{
        const copy = target.type === 3 /* DraftType.Set */  ? target.setMap : target.copy;
        if ($f275c1bee2ad9b3e$var$isEqual($f275c1bee2ad9b3e$var$get(copy, key), value)) $f275c1bee2ad9b3e$var$finalizeAssigned(target, key);
    });
}
function $f275c1bee2ad9b3e$var$generateArrayPatches(proxyState, basePath, patches, inversePatches, pathAsArray) {
    let { original: original, assignedMap: assignedMap, options: options } = proxyState;
    let copy = proxyState.copy;
    if (copy.length < original.length) {
        [original, copy] = [
            copy,
            original
        ];
        [patches, inversePatches] = [
            inversePatches,
            patches
        ];
    }
    for(let index = 0; index < original.length; index += 1)if (assignedMap.get(index.toString()) && copy[index] !== original[index]) {
        const _path = basePath.concat([
            index
        ]);
        const path = $f275c1bee2ad9b3e$var$escapePath(_path, pathAsArray);
        patches.push({
            op: $f275c1bee2ad9b3e$var$Operation.Replace,
            path: path,
            // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
            value: $f275c1bee2ad9b3e$var$cloneIfNeeded(copy[index])
        });
        inversePatches.push({
            op: $f275c1bee2ad9b3e$var$Operation.Replace,
            path: path,
            // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
            value: $f275c1bee2ad9b3e$var$cloneIfNeeded(original[index])
        });
    }
    for(let index = original.length; index < copy.length; index += 1){
        const _path = basePath.concat([
            index
        ]);
        const path = $f275c1bee2ad9b3e$var$escapePath(_path, pathAsArray);
        patches.push({
            op: $f275c1bee2ad9b3e$var$Operation.Add,
            path: path,
            // If it is a draft, it needs to be deep cloned, and it may also be non-draft.
            value: $f275c1bee2ad9b3e$var$cloneIfNeeded(copy[index])
        });
    }
    if (original.length < copy.length) {
        // https://www.rfc-editor.org/rfc/rfc6902#appendix-A.4
        // For performance, here we only generate an operation that replaces the length of the array,
        // which is inconsistent with JSON Patch specification
        const { arrayLengthAssignment: arrayLengthAssignment = true } = options.enablePatches;
        if (arrayLengthAssignment) {
            const _path = basePath.concat([
                "length"
            ]);
            const path = $f275c1bee2ad9b3e$var$escapePath(_path, pathAsArray);
            inversePatches.push({
                op: $f275c1bee2ad9b3e$var$Operation.Replace,
                path: path,
                value: original.length
            });
        } else for(let index = copy.length; original.length < index; index -= 1){
            const _path = basePath.concat([
                index - 1
            ]);
            const path = $f275c1bee2ad9b3e$var$escapePath(_path, pathAsArray);
            inversePatches.push({
                op: $f275c1bee2ad9b3e$var$Operation.Remove,
                path: path
            });
        }
    }
}
function $f275c1bee2ad9b3e$var$generatePatchesFromAssigned({ original: original, copy: copy, assignedMap: assignedMap }, basePath, patches, inversePatches, pathAsArray) {
    assignedMap.forEach((assignedValue, key)=>{
        const originalValue = $f275c1bee2ad9b3e$var$get(original, key);
        const value = $f275c1bee2ad9b3e$var$cloneIfNeeded($f275c1bee2ad9b3e$var$get(copy, key));
        const op = !assignedValue ? $f275c1bee2ad9b3e$var$Operation.Remove : $f275c1bee2ad9b3e$var$has(original, key) ? $f275c1bee2ad9b3e$var$Operation.Replace : $f275c1bee2ad9b3e$var$Operation.Add;
        if ($f275c1bee2ad9b3e$var$isEqual(originalValue, value) && op === $f275c1bee2ad9b3e$var$Operation.Replace) return;
        const _path = basePath.concat(key);
        const path = $f275c1bee2ad9b3e$var$escapePath(_path, pathAsArray);
        patches.push(op === $f275c1bee2ad9b3e$var$Operation.Remove ? {
            op: op,
            path: path
        } : {
            op: op,
            path: path,
            value: value
        });
        inversePatches.push(op === $f275c1bee2ad9b3e$var$Operation.Add ? {
            op: $f275c1bee2ad9b3e$var$Operation.Remove,
            path: path
        } : op === $f275c1bee2ad9b3e$var$Operation.Remove ? {
            op: $f275c1bee2ad9b3e$var$Operation.Add,
            path: path,
            value: originalValue
        } : {
            op: $f275c1bee2ad9b3e$var$Operation.Replace,
            path: path,
            value: originalValue
        });
    });
}
function $f275c1bee2ad9b3e$var$generateSetPatches({ original: original, copy: copy }, basePath, patches, inversePatches, pathAsArray) {
    let index = 0;
    original.forEach((value)=>{
        if (!copy.has(value)) {
            const _path = basePath.concat([
                index
            ]);
            const path = $f275c1bee2ad9b3e$var$escapePath(_path, pathAsArray);
            patches.push({
                op: $f275c1bee2ad9b3e$var$Operation.Remove,
                path: path,
                value: value
            });
            inversePatches.unshift({
                op: $f275c1bee2ad9b3e$var$Operation.Add,
                path: path,
                value: value
            });
        }
        index += 1;
    });
    index = 0;
    copy.forEach((value)=>{
        if (!original.has(value)) {
            const _path = basePath.concat([
                index
            ]);
            const path = $f275c1bee2ad9b3e$var$escapePath(_path, pathAsArray);
            patches.push({
                op: $f275c1bee2ad9b3e$var$Operation.Add,
                path: path,
                value: value
            });
            inversePatches.unshift({
                op: $f275c1bee2ad9b3e$var$Operation.Remove,
                path: path,
                value: value
            });
        }
        index += 1;
    });
}
function $f275c1bee2ad9b3e$var$generatePatches(proxyState, basePath, patches, inversePatches) {
    const { pathAsArray: pathAsArray = true } = proxyState.options.enablePatches;
    switch(proxyState.type){
        case 0 /* DraftType.Object */ :
        case 2 /* DraftType.Map */ :
            return $f275c1bee2ad9b3e$var$generatePatchesFromAssigned(proxyState, basePath, patches, inversePatches, pathAsArray);
        case 1 /* DraftType.Array */ :
            return $f275c1bee2ad9b3e$var$generateArrayPatches(proxyState, basePath, patches, inversePatches, pathAsArray);
        case 3 /* DraftType.Set */ :
            return $f275c1bee2ad9b3e$var$generateSetPatches(proxyState, basePath, patches, inversePatches, pathAsArray);
    }
}
let $f275c1bee2ad9b3e$var$readable = false;
const $f275c1bee2ad9b3e$var$checkReadable = (value, options, ignoreCheckDraftable = false)=>{
    if (typeof value === "object" && value !== null && (!$f275c1bee2ad9b3e$export$16e3aed3edb85946(value, options) || ignoreCheckDraftable) && !$f275c1bee2ad9b3e$var$readable) throw new Error(`Strict mode: Mutable data cannot be accessed directly, please use 'unsafe(callback)' wrap.`);
};
/**
 * `unsafe(callback)` to access mutable data directly in strict mode.
 *
 * ## Example
 *
 * ```ts
 * import { create, unsafe } from '../index';
 *
 * class Foobar {
 *   bar = 1;
 * }
 *
 * const baseState = { foobar: new Foobar() };
 * const state = create(
 *   baseState,
 *   (draft) => {
 *    unsafe(() => {
 *      draft.foobar.bar = 2;
 *    });
 *   },
 *   {
 *     strict: true,
 *   }
 * );
 *
 * expect(state).toBe(baseState);
 * expect(state.foobar).toBe(baseState.foobar);
 * expect(state.foobar.bar).toBe(2);
 * ```
 */ function $f275c1bee2ad9b3e$export$aa1c11b655786597(callback) {
    $f275c1bee2ad9b3e$var$readable = true;
    let result;
    try {
        result = callback();
    } finally{
        $f275c1bee2ad9b3e$var$readable = false;
    }
    return result;
}
const $f275c1bee2ad9b3e$var$mapHandler = {
    get size () {
        const current = $f275c1bee2ad9b3e$var$latest($f275c1bee2ad9b3e$var$getProxyDraft(this));
        return current.size;
    },
    has (key) {
        return $f275c1bee2ad9b3e$var$latest($f275c1bee2ad9b3e$var$getProxyDraft(this)).has(key);
    },
    set (key, value) {
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        const source = $f275c1bee2ad9b3e$var$latest(target);
        if (!source.has(key) || !$f275c1bee2ad9b3e$var$isEqual(source.get(key), value)) {
            $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
            $f275c1bee2ad9b3e$var$markChanged(target);
            target.assignedMap.set(key, true);
            target.copy.set(key, value);
            $f275c1bee2ad9b3e$var$markFinalization(target, key, value, $f275c1bee2ad9b3e$var$generatePatches);
        }
        return this;
    },
    delete (key) {
        if (!this.has(key)) return false;
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
        $f275c1bee2ad9b3e$var$markChanged(target);
        if (target.original.has(key)) target.assignedMap.set(key, false);
        else target.assignedMap.delete(key);
        target.copy.delete(key);
        return true;
    },
    clear () {
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        if (!this.size) return;
        $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
        $f275c1bee2ad9b3e$var$markChanged(target);
        target.assignedMap = new Map();
        for (const [key] of target.original)target.assignedMap.set(key, false);
        target.copy.clear();
    },
    forEach (callback, thisArg) {
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        $f275c1bee2ad9b3e$var$latest(target).forEach((_value, _key)=>{
            callback.call(thisArg, this.get(_key), _key, this);
        });
    },
    get (key) {
        var _a, _b;
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        const value = $f275c1bee2ad9b3e$var$latest(target).get(key);
        const mutable = ((_b = (_a = target.options).mark) === null || _b === void 0 ? void 0 : _b.call(_a, value, $f275c1bee2ad9b3e$var$dataTypes)) === $f275c1bee2ad9b3e$var$dataTypes.mutable;
        if (target.options.strict) $f275c1bee2ad9b3e$var$checkReadable(value, target.options, mutable);
        if (mutable) return value;
        if (target.finalized || !$f275c1bee2ad9b3e$export$16e3aed3edb85946(value, target.options)) return value;
        // drafted or reassigned
        if (value !== target.original.get(key)) return value;
        const draft = $f275c1bee2ad9b3e$var$internal.createDraft({
            original: value,
            parentDraft: target,
            key: key,
            finalities: target.finalities,
            options: target.options
        });
        $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
        target.copy.set(key, draft);
        return draft;
    },
    keys () {
        return $f275c1bee2ad9b3e$var$latest($f275c1bee2ad9b3e$var$getProxyDraft(this)).keys();
    },
    values () {
        const iterator = this.keys();
        return {
            [$f275c1bee2ad9b3e$var$iteratorSymbol]: ()=>this.values(),
            next: ()=>{
                const result = iterator.next();
                if (result.done) return result;
                const value = this.get(result.value);
                return {
                    done: false,
                    value: value
                };
            }
        };
    },
    entries () {
        const iterator = this.keys();
        return {
            [$f275c1bee2ad9b3e$var$iteratorSymbol]: ()=>this.entries(),
            next: ()=>{
                const result = iterator.next();
                if (result.done) return result;
                const value = this.get(result.value);
                return {
                    done: false,
                    value: [
                        result.value,
                        value
                    ]
                };
            }
        };
    },
    [$f275c1bee2ad9b3e$var$iteratorSymbol] () {
        return this.entries();
    }
};
const $f275c1bee2ad9b3e$var$mapHandlerKeys = Reflect.ownKeys($f275c1bee2ad9b3e$var$mapHandler);
const $f275c1bee2ad9b3e$var$getNextIterator = (target, iterator, { isValuesIterator: isValuesIterator })=>()=>{
        var _a, _b;
        const result = iterator.next();
        if (result.done) return result;
        const key = result.value;
        let value = target.setMap.get(key);
        const currentDraft = $f275c1bee2ad9b3e$var$getProxyDraft(value);
        const mutable = ((_b = (_a = target.options).mark) === null || _b === void 0 ? void 0 : _b.call(_a, value, $f275c1bee2ad9b3e$var$dataTypes)) === $f275c1bee2ad9b3e$var$dataTypes.mutable;
        if (target.options.strict) $f275c1bee2ad9b3e$var$checkReadable(key, target.options, mutable);
        if (!mutable && !currentDraft && $f275c1bee2ad9b3e$export$16e3aed3edb85946(key, target.options) && !target.finalized && target.original.has(key)) {
            // draft a draftable original set item
            const proxy = $f275c1bee2ad9b3e$var$internal.createDraft({
                original: key,
                parentDraft: target,
                key: key,
                finalities: target.finalities,
                options: target.options
            });
            target.setMap.set(key, proxy);
            value = proxy;
        } else if (currentDraft) // drafted
        value = currentDraft.proxy;
        return {
            done: false,
            value: isValuesIterator ? value : [
                value,
                value
            ]
        };
    };
const $f275c1bee2ad9b3e$var$setHandler = {
    get size () {
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        return target.setMap.size;
    },
    has (value) {
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        // reassigned or non-draftable values
        if (target.setMap.has(value)) return true;
        $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
        const valueProxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(value);
        // drafted
        if (valueProxyDraft && target.setMap.has(valueProxyDraft.original)) return true;
        return false;
    },
    add (value) {
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        if (!this.has(value)) {
            $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
            $f275c1bee2ad9b3e$var$markChanged(target);
            target.assignedMap.set(value, true);
            target.setMap.set(value, value);
            $f275c1bee2ad9b3e$var$markFinalization(target, value, value, $f275c1bee2ad9b3e$var$generatePatches);
        }
        return this;
    },
    delete (value) {
        if (!this.has(value)) return false;
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
        $f275c1bee2ad9b3e$var$markChanged(target);
        const valueProxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(value);
        if (valueProxyDraft && target.setMap.has(valueProxyDraft.original)) {
            // delete drafted
            target.assignedMap.set(valueProxyDraft.original, false);
            return target.setMap.delete(valueProxyDraft.original);
        }
        if (!valueProxyDraft && target.setMap.has(value)) // non-draftable values
        target.assignedMap.set(value, false);
        else // reassigned
        target.assignedMap.delete(value);
        // delete reassigned or non-draftable values
        return target.setMap.delete(value);
    },
    clear () {
        if (!this.size) return;
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
        $f275c1bee2ad9b3e$var$markChanged(target);
        for (const value of target.original)target.assignedMap.set(value, false);
        target.setMap.clear();
    },
    values () {
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
        const iterator = target.setMap.keys();
        return {
            [Symbol.iterator]: ()=>this.values(),
            next: $f275c1bee2ad9b3e$var$getNextIterator(target, iterator, {
                isValuesIterator: true
            })
        };
    },
    entries () {
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(this);
        $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
        const iterator = target.setMap.keys();
        return {
            [Symbol.iterator]: ()=>this.entries(),
            next: $f275c1bee2ad9b3e$var$getNextIterator(target, iterator, {
                isValuesIterator: false
            })
        };
    },
    keys () {
        return this.values();
    },
    [$f275c1bee2ad9b3e$var$iteratorSymbol] () {
        return this.values();
    },
    forEach (callback, thisArg) {
        const iterator = this.values();
        let result = iterator.next();
        while(!result.done){
            callback.call(thisArg, result.value, result.value, this);
            result = iterator.next();
        }
    }
};
const $f275c1bee2ad9b3e$var$setHandlerKeys = Reflect.ownKeys($f275c1bee2ad9b3e$var$setHandler);
const $f275c1bee2ad9b3e$var$draftsCache = new WeakSet();
const $f275c1bee2ad9b3e$var$proxyHandler = {
    get (target, key, receiver) {
        var _a, _b;
        const copy = (_a = target.copy) === null || _a === void 0 ? void 0 : _a[key];
        // Improve draft reading performance by caching the draft copy.
        if (copy && $f275c1bee2ad9b3e$var$draftsCache.has(copy)) return copy;
        if (key === $f275c1bee2ad9b3e$var$PROXY_DRAFT) return target;
        let markResult;
        if (target.options.mark) {
            // handle `Uncaught TypeError: Method get Map.prototype.size called on incompatible receiver #<Map>`
            // or `Uncaught TypeError: Method get Set.prototype.size called on incompatible receiver #<Set>`
            const value = key === "size" && (target.original instanceof Map || target.original instanceof Set) ? Reflect.get(target.original, key) : Reflect.get(target.original, key, receiver);
            markResult = target.options.mark(value, $f275c1bee2ad9b3e$var$dataTypes);
            if (markResult === $f275c1bee2ad9b3e$var$dataTypes.mutable) {
                if (target.options.strict) $f275c1bee2ad9b3e$var$checkReadable(value, target.options, true);
                return value;
            }
        }
        const source = $f275c1bee2ad9b3e$var$latest(target);
        if (source instanceof Map && $f275c1bee2ad9b3e$var$mapHandlerKeys.includes(key)) {
            if (key === "size") return Object.getOwnPropertyDescriptor($f275c1bee2ad9b3e$var$mapHandler, "size").get.call(target.proxy);
            const handle = $f275c1bee2ad9b3e$var$mapHandler[key];
            if (handle) return handle.bind(target.proxy);
        }
        if (source instanceof Set && $f275c1bee2ad9b3e$var$setHandlerKeys.includes(key)) {
            if (key === "size") return Object.getOwnPropertyDescriptor($f275c1bee2ad9b3e$var$setHandler, "size").get.call(target.proxy);
            const handle = $f275c1bee2ad9b3e$var$setHandler[key];
            if (handle) return handle.bind(target.proxy);
        }
        if (!$f275c1bee2ad9b3e$var$has(source, key)) {
            const desc = $f275c1bee2ad9b3e$var$getDescriptor(source, key);
            return desc ? `value` in desc ? desc.value : (_b = desc.get) === null || _b === void 0 ? void 0 : _b.call(target.proxy) : undefined;
        }
        const value = source[key];
        if (target.options.strict) $f275c1bee2ad9b3e$var$checkReadable(value, target.options);
        if (target.finalized || !$f275c1bee2ad9b3e$export$16e3aed3edb85946(value, target.options)) return value;
        // Ensure that the assigned values are not drafted
        if (value === $f275c1bee2ad9b3e$var$peek(target.original, key)) {
            $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
            target.copy[key] = $f275c1bee2ad9b3e$var$createDraft({
                original: target.original[key],
                parentDraft: target,
                key: target.type === 1 /* DraftType.Array */  ? Number(key) : key,
                finalities: target.finalities,
                options: target.options
            });
            // !case: support for custom shallow copy function
            if (typeof markResult === "function") {
                const subProxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(target.copy[key]);
                $f275c1bee2ad9b3e$var$ensureShallowCopy(subProxyDraft);
                // Trigger a custom shallow copy to update to a new copy
                $f275c1bee2ad9b3e$var$markChanged(subProxyDraft);
                return subProxyDraft.copy;
            }
            return target.copy[key];
        }
        return value;
    },
    set (target, key, value) {
        var _a;
        if (target.type === 3 /* DraftType.Set */  || target.type === 2 /* DraftType.Map */ ) throw new Error(`Map/Set draft does not support any property assignment.`);
        let _key;
        if (target.type === 1 /* DraftType.Array */  && key !== "length" && !(Number.isInteger(_key = Number(key)) && _key >= 0 && (key === 0 || _key === 0 || String(_key) === String(key)))) throw new Error(`Only supports setting array indices and the 'length' property.`);
        const desc = $f275c1bee2ad9b3e$var$getDescriptor($f275c1bee2ad9b3e$var$latest(target), key);
        if (desc === null || desc === void 0 ? void 0 : desc.set) {
            // !case: cover the case of setter
            desc.set.call(target.proxy, value);
            return true;
        }
        const current = $f275c1bee2ad9b3e$var$peek($f275c1bee2ad9b3e$var$latest(target), key);
        const currentProxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(current);
        if (currentProxyDraft && $f275c1bee2ad9b3e$var$isEqual(currentProxyDraft.original, value)) {
            // !case: ignore the case of assigning the original draftable value to a draft
            target.copy[key] = value;
            target.assignedMap = (_a = target.assignedMap) !== null && _a !== void 0 ? _a : new Map();
            target.assignedMap.set(key, false);
            return true;
        }
        // !case: handle new props with value 'undefined'
        if ($f275c1bee2ad9b3e$var$isEqual(value, current) && (value !== undefined || $f275c1bee2ad9b3e$var$has(target.original, key))) return true;
        $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
        $f275c1bee2ad9b3e$var$markChanged(target);
        if ($f275c1bee2ad9b3e$var$has(target.original, key) && $f275c1bee2ad9b3e$var$isEqual(value, target.original[key])) // !case: handle the case of assigning the original non-draftable value to a draft
        target.assignedMap.delete(key);
        else target.assignedMap.set(key, true);
        target.copy[key] = value;
        $f275c1bee2ad9b3e$var$markFinalization(target, key, value, $f275c1bee2ad9b3e$var$generatePatches);
        return true;
    },
    has (target, key) {
        return key in $f275c1bee2ad9b3e$var$latest(target);
    },
    ownKeys (target) {
        return Reflect.ownKeys($f275c1bee2ad9b3e$var$latest(target));
    },
    getOwnPropertyDescriptor (target, key) {
        const source = $f275c1bee2ad9b3e$var$latest(target);
        const descriptor = Reflect.getOwnPropertyDescriptor(source, key);
        if (!descriptor) return descriptor;
        return {
            writable: true,
            configurable: target.type !== 1 /* DraftType.Array */  || key !== "length",
            enumerable: descriptor.enumerable,
            value: source[key]
        };
    },
    getPrototypeOf (target) {
        return Reflect.getPrototypeOf(target.original);
    },
    setPrototypeOf () {
        throw new Error(`Cannot call 'setPrototypeOf()' on drafts`);
    },
    defineProperty () {
        throw new Error(`Cannot call 'defineProperty()' on drafts`);
    },
    deleteProperty (target, key) {
        var _a;
        if (target.type === 1 /* DraftType.Array */ ) return $f275c1bee2ad9b3e$var$proxyHandler.set.call(this, target, key, undefined, target.proxy);
        if ($f275c1bee2ad9b3e$var$peek(target.original, key) !== undefined || key in target.original) {
            // !case: delete an existing key
            $f275c1bee2ad9b3e$var$ensureShallowCopy(target);
            $f275c1bee2ad9b3e$var$markChanged(target);
            target.assignedMap.set(key, false);
        } else {
            target.assignedMap = (_a = target.assignedMap) !== null && _a !== void 0 ? _a : new Map();
            // The original non-existent key has been deleted
            target.assignedMap.delete(key);
        }
        if (target.copy) delete target.copy[key];
        return true;
    }
};
function $f275c1bee2ad9b3e$var$createDraft(createDraftOptions) {
    const { original: original, parentDraft: parentDraft, key: key, finalities: finalities, options: options } = createDraftOptions;
    const type = $f275c1bee2ad9b3e$var$getType(original);
    const proxyDraft = {
        type: type,
        finalized: false,
        parent: parentDraft,
        original: original,
        copy: null,
        proxy: null,
        finalities: finalities,
        options: options,
        // Mapping of draft Set items to their corresponding draft values.
        setMap: type === 3 /* DraftType.Set */  ? new Map(original.entries()) : undefined
    };
    // !case: undefined as a draft map key
    if (key || "key" in createDraftOptions) proxyDraft.key = key;
    const { proxy: proxy, revoke: revoke } = Proxy.revocable(type === 1 /* DraftType.Array */  ? Object.assign([], proxyDraft) : proxyDraft, $f275c1bee2ad9b3e$var$proxyHandler);
    finalities.revoke.push(revoke);
    $f275c1bee2ad9b3e$var$draftsCache.add(proxy);
    proxyDraft.proxy = proxy;
    if (parentDraft) {
        const target = parentDraft;
        target.finalities.draft.push((patches, inversePatches)=>{
            var _a, _b;
            const oldProxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(proxy);
            // if target is a Set draft, `setMap` is the real Set copies proxy mapping.
            let copy = target.type === 3 /* DraftType.Set */  ? target.setMap : target.copy;
            const draft = $f275c1bee2ad9b3e$var$get(copy, key);
            const proxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(draft);
            if (proxyDraft) {
                // assign the updated value to the copy object
                let updatedValue = proxyDraft.original;
                if (proxyDraft.operated) updatedValue = $f275c1bee2ad9b3e$var$getValue(draft);
                $f275c1bee2ad9b3e$var$finalizeSetValue(proxyDraft);
                $f275c1bee2ad9b3e$var$finalizePatches(proxyDraft, $f275c1bee2ad9b3e$var$generatePatches, patches, inversePatches);
                if (target.options.enableAutoFreeze) {
                    target.options.updatedValues = (_a = target.options.updatedValues) !== null && _a !== void 0 ? _a : new WeakMap();
                    target.options.updatedValues.set(updatedValue, proxyDraft.original);
                }
                // final update value
                $f275c1bee2ad9b3e$var$set(copy, key, updatedValue);
            }
            // !case: handle the deleted key
            (_b = oldProxyDraft.callbacks) === null || _b === void 0 || _b.forEach((callback)=>{
                callback(patches, inversePatches);
            });
        });
    } else {
        // !case: handle the root draft
        const target = $f275c1bee2ad9b3e$var$getProxyDraft(proxy);
        target.finalities.draft.push((patches, inversePatches)=>{
            $f275c1bee2ad9b3e$var$finalizeSetValue(target);
            $f275c1bee2ad9b3e$var$finalizePatches(target, $f275c1bee2ad9b3e$var$generatePatches, patches, inversePatches);
        });
    }
    return proxy;
}
$f275c1bee2ad9b3e$var$internal.createDraft = $f275c1bee2ad9b3e$var$createDraft;
function $f275c1bee2ad9b3e$var$finalizeDraft(result, returnedValue, patches, inversePatches, enableAutoFreeze) {
    var _a;
    const proxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(result);
    const original = (_a = proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.original) !== null && _a !== void 0 ? _a : result;
    const hasReturnedValue = !!returnedValue.length;
    if (proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.operated) while(proxyDraft.finalities.draft.length > 0){
        const finalize = proxyDraft.finalities.draft.pop();
        finalize(patches, inversePatches);
    }
    const state = hasReturnedValue ? returnedValue[0] : proxyDraft ? proxyDraft.operated ? proxyDraft.copy : proxyDraft.original : result;
    if (proxyDraft) $f275c1bee2ad9b3e$var$revokeProxy(proxyDraft);
    if (enableAutoFreeze) $f275c1bee2ad9b3e$var$deepFreeze(state, state, proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.options.updatedValues);
    return [
        state,
        patches && hasReturnedValue ? [
            {
                op: $f275c1bee2ad9b3e$var$Operation.Replace,
                path: [],
                value: returnedValue[0]
            }
        ] : patches,
        inversePatches && hasReturnedValue ? [
            {
                op: $f275c1bee2ad9b3e$var$Operation.Replace,
                path: [],
                value: original
            }
        ] : inversePatches
    ];
}
function $f275c1bee2ad9b3e$var$draftify(baseState, options) {
    var _a;
    const finalities = {
        draft: [],
        revoke: [],
        handledSet: new WeakSet()
    };
    let patches;
    let inversePatches;
    if (options.enablePatches) {
        patches = [];
        inversePatches = [];
    }
    const isMutable = ((_a = options.mark) === null || _a === void 0 ? void 0 : _a.call(options, baseState, $f275c1bee2ad9b3e$var$dataTypes)) === $f275c1bee2ad9b3e$var$dataTypes.mutable || !$f275c1bee2ad9b3e$export$16e3aed3edb85946(baseState, options);
    const draft = isMutable ? baseState : $f275c1bee2ad9b3e$var$createDraft({
        original: baseState,
        parentDraft: null,
        finalities: finalities,
        options: options
    });
    return [
        draft,
        (returnedValue = [])=>{
            const [finalizedState, finalizedPatches, finalizedInversePatches] = $f275c1bee2ad9b3e$var$finalizeDraft(draft, returnedValue, patches, inversePatches, options.enableAutoFreeze);
            return options.enablePatches ? [
                finalizedState,
                finalizedPatches,
                finalizedInversePatches
            ] : finalizedState;
        }
    ];
}
function $f275c1bee2ad9b3e$var$handleReturnValue(options) {
    const { rootDraft: rootDraft, value: value, useRawReturn: useRawReturn = false, isRoot: isRoot = true } = options;
    $f275c1bee2ad9b3e$var$forEach(value, (key, item, source)=>{
        const proxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(item);
        // just handle the draft which is created by the same rootDraft
        if (proxyDraft && rootDraft && proxyDraft.finalities === rootDraft.finalities) {
            options.isContainDraft = true;
            const currentValue = proxyDraft.original;
            // final update value, but just handle return value
            if (source instanceof Set) {
                const arr = Array.from(source);
                source.clear();
                arr.forEach((_item)=>source.add(key === _item ? currentValue : _item));
            } else $f275c1bee2ad9b3e$var$set(source, key, currentValue);
        } else if (typeof item === "object" && item !== null) {
            options.value = item;
            options.isRoot = false;
            $f275c1bee2ad9b3e$var$handleReturnValue(options);
        }
    });
    if (isRoot) {
        if (!options.isContainDraft) console.warn(`The return value does not contain any draft, please use 'rawReturn()' to wrap the return value to improve performance.`);
        if (useRawReturn) console.warn(`The return value contains drafts, please don't use 'rawReturn()' to wrap the return value.`);
    }
}
function $f275c1bee2ad9b3e$var$getCurrent(target) {
    const proxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(target);
    if (!$f275c1bee2ad9b3e$export$16e3aed3edb85946(target, proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.options)) return target;
    const type = $f275c1bee2ad9b3e$var$getType(target);
    if (proxyDraft && !proxyDraft.operated) return proxyDraft.original;
    let currentValue;
    function ensureShallowCopy() {
        currentValue = type === 2 /* DraftType.Map */  ? new Map(target) : type === 3 /* DraftType.Set */  ? Array.from(proxyDraft.setMap.values()) : $f275c1bee2ad9b3e$var$shallowCopy(target, proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.options);
    }
    if (proxyDraft) {
        // It's a proxy draft, let's create a shallow copy eagerly
        proxyDraft.finalized = true;
        try {
            ensureShallowCopy();
        } finally{
            proxyDraft.finalized = false;
        }
    } else // It's not a proxy draft, let's use the target directly and let's see
    // lazily if we need to create a shallow copy
    currentValue = target;
    $f275c1bee2ad9b3e$var$forEach(currentValue, (key, value)=>{
        if (proxyDraft && $f275c1bee2ad9b3e$var$isEqual($f275c1bee2ad9b3e$var$get(proxyDraft.original, key), value)) return;
        const newValue = $f275c1bee2ad9b3e$var$getCurrent(value);
        if (newValue !== value) {
            if (currentValue === target) ensureShallowCopy();
            $f275c1bee2ad9b3e$var$set(currentValue, key, newValue);
        }
    });
    return type === 3 /* DraftType.Set */  ? new Set(currentValue) : currentValue;
}
/**
 * `current(draft)` to get current state in the draft mutation function.
 *
 * ## Example
 *
 * ```ts
 * import { create, current } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const state = create(
 *   baseState,
 *   (draft) => {
 *     draft.foo.bar = 'str2';
 *     expect(current(draft.foo)).toEqual({ bar: 'str2' });
 *   },
 * );
 * ```
 */ function $f275c1bee2ad9b3e$export$97aac956da55dae9(target) {
    if (!$f275c1bee2ad9b3e$export$541ac630993a4c84(target)) throw new Error(`current() is only used for Draft, parameter: ${target}`);
    return $f275c1bee2ad9b3e$var$getCurrent(target);
}
/**
 * `makeCreator(options)` to make a creator function.
 *
 * ## Example
 *
 * ```ts
 * import { makeCreator } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const create = makeCreator({ enableAutoFreeze: true });
 * const state = create(
 *   baseState,
 *   (draft) => {
 *     draft.foo.bar = 'str2';
 *   },
 * );
 *
 * expect(state).toEqual({ foo: { bar: 'str2' }, arr: [] });
 * expect(state).not.toBe(baseState);
 * expect(state.foo).not.toBe(baseState.foo);
 * expect(state.arr).toBe(baseState.arr);
 * expect(Object.isFrozen(state)).toBeTruthy();
 * ```
 */ const $f275c1bee2ad9b3e$export$3cbf9dcc9483e820 = (arg)=>{
    if (arg !== undefined && Object.prototype.toString.call(arg) !== "[object Object]") throw new Error(`Invalid options: ${String(arg)}, 'options' should be an object.`);
    return function create(arg0, arg1, arg2) {
        var _a, _b, _c;
        if (typeof arg0 === "function" && typeof arg1 !== "function") return function(base, ...args) {
            return create(base, (draft)=>arg0.call(this, draft, ...args), arg1);
        };
        const base = arg0;
        const mutate = arg1;
        let options = arg2;
        if (typeof arg1 !== "function") options = arg1;
        if (options !== undefined && Object.prototype.toString.call(options) !== "[object Object]") throw new Error(`Invalid options: ${options}, 'options' should be an object.`);
        options = Object.assign(Object.assign({}, arg), options);
        const state = $f275c1bee2ad9b3e$export$541ac630993a4c84(base) ? $f275c1bee2ad9b3e$export$97aac956da55dae9(base) : base;
        const mark = Array.isArray(options.mark) ? (value, types)=>{
            for (const mark of options.mark){
                if (typeof mark !== "function") throw new Error(`Invalid mark: ${mark}, 'mark' should be a function.`);
                const result = mark(value, types);
                if (result) return result;
            }
            return;
        } : options.mark;
        const enablePatches = (_a = options.enablePatches) !== null && _a !== void 0 ? _a : false;
        const strict = (_b = options.strict) !== null && _b !== void 0 ? _b : false;
        const enableAutoFreeze = (_c = options.enableAutoFreeze) !== null && _c !== void 0 ? _c : false;
        const _options = {
            enableAutoFreeze: enableAutoFreeze,
            mark: mark,
            strict: strict,
            enablePatches: enablePatches
        };
        if (!$f275c1bee2ad9b3e$export$16e3aed3edb85946(state, _options) && typeof state === "object" && state !== null) throw new Error(`Invalid base state: create() only supports plain objects, arrays, Set, Map or using mark() to mark the state as immutable.`);
        const [draft, finalize] = $f275c1bee2ad9b3e$var$draftify(state, _options);
        if (typeof arg1 !== "function") {
            if (!$f275c1bee2ad9b3e$export$16e3aed3edb85946(state, _options)) throw new Error(`Invalid base state: create() only supports plain objects, arrays, Set, Map or using mark() to mark the state as immutable.`);
            return [
                draft,
                finalize
            ];
        }
        let result;
        try {
            result = mutate(draft);
        } catch (error) {
            $f275c1bee2ad9b3e$var$revokeProxy($f275c1bee2ad9b3e$var$getProxyDraft(draft));
            throw error;
        }
        const returnValue = (value)=>{
            const proxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(draft);
            if (!$f275c1bee2ad9b3e$export$541ac630993a4c84(value)) {
                if (value !== undefined && !$f275c1bee2ad9b3e$var$isEqual(value, draft) && (proxyDraft === null || proxyDraft === void 0 ? void 0 : proxyDraft.operated)) throw new Error(`Either the value is returned as a new non-draft value, or only the draft is modified without returning any value.`);
                const rawReturnValue = value === null || value === void 0 ? void 0 : value[$f275c1bee2ad9b3e$var$RAW_RETURN_SYMBOL];
                if (rawReturnValue) {
                    const _value = rawReturnValue[0];
                    if (_options.strict && typeof value === "object" && value !== null) $f275c1bee2ad9b3e$var$handleReturnValue({
                        rootDraft: proxyDraft,
                        value: value,
                        useRawReturn: true
                    });
                    return finalize([
                        _value
                    ]);
                }
                if (value !== undefined) {
                    if (typeof value === "object" && value !== null) $f275c1bee2ad9b3e$var$handleReturnValue({
                        rootDraft: proxyDraft,
                        value: value
                    });
                    return finalize([
                        value
                    ]);
                }
            }
            if (value === draft || value === undefined) return finalize([]);
            const returnedProxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(value);
            if (_options === returnedProxyDraft.options) {
                if (returnedProxyDraft.operated) throw new Error(`Cannot return a modified child draft.`);
                return finalize([
                    $f275c1bee2ad9b3e$export$97aac956da55dae9(value)
                ]);
            }
            return finalize([
                value
            ]);
        };
        if (result instanceof Promise) return result.then(returnValue, (error)=>{
            $f275c1bee2ad9b3e$var$revokeProxy($f275c1bee2ad9b3e$var$getProxyDraft(draft));
            throw error;
        });
        return returnValue(result);
    };
};
/**
 * `create(baseState, callback, options)` to create the next state
 *
 * ## Example
 *
 * ```ts
 * import { create } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const state = create(
 *   baseState,
 *   (draft) => {
 *     draft.foo.bar = 'str2';
 *   },
 * );
 *
 * expect(state).toEqual({ foo: { bar: 'str2' }, arr: [] });
 * expect(state).not.toBe(baseState);
 * expect(state.foo).not.toBe(baseState.foo);
 * expect(state.arr).toBe(baseState.arr);
 * ```
 */ const $f275c1bee2ad9b3e$export$185802fd694ee1f5 = $f275c1bee2ad9b3e$export$3cbf9dcc9483e820();
/**
 * `apply(state, patches)` to apply patches to state
 *
 * ## Example
 *
 * ```ts
 * import { create, apply } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const [state, patches] = create(
 *   baseState,
 *   (draft) => {
 *     draft.foo.bar = 'str2';
 *   },
 *   { enablePatches: true }
 * );
 * expect(state).toEqual({ foo: { bar: 'str2' }, arr: [] });
 * expect(patches).toEqual([{ op: 'replace', path: ['foo', 'bar'], value: 'str2' }]);
 * expect(state).toEqual(apply(baseState, patches));
 * ```
 */ function $f275c1bee2ad9b3e$export$5635d7ef4b8fee1c(state, patches, applyOptions) {
    let i;
    for(i = patches.length - 1; i >= 0; i -= 1){
        const { value: value, op: op, path: path } = patches[i];
        if (!path.length && op === $f275c1bee2ad9b3e$var$Operation.Replace || path === "" && op === $f275c1bee2ad9b3e$var$Operation.Add) {
            state = value;
            break;
        }
    }
    if (i > -1) patches = patches.slice(i + 1);
    const mutate = (draft)=>{
        patches.forEach((patch)=>{
            const { path: _path, op: op } = patch;
            const path = $f275c1bee2ad9b3e$var$unescapePath(_path);
            let base = draft;
            for(let index = 0; index < path.length - 1; index += 1){
                const parentType = $f275c1bee2ad9b3e$var$getType(base);
                let key = path[index];
                if (typeof key !== "string" && typeof key !== "number") key = String(key);
                if ((parentType === 0 /* DraftType.Object */  || parentType === 1 /* DraftType.Array */ ) && (key === "__proto__" || key === "constructor") || typeof base === "function" && key === "prototype") throw new Error(`Patching reserved attributes like __proto__ and constructor is not allowed.`);
                // use `index` in Set draft
                base = $f275c1bee2ad9b3e$var$get(parentType === 3 /* DraftType.Set */  ? Array.from(base) : base, key);
                if (typeof base !== "object") throw new Error(`Cannot apply patch at '${path.join("/")}'.`);
            }
            const type = $f275c1bee2ad9b3e$var$getType(base);
            // ensure the original patch is not modified.
            const value = $f275c1bee2ad9b3e$var$deepClone(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case $f275c1bee2ad9b3e$var$Operation.Replace:
                    switch(type){
                        case 2 /* DraftType.Map */ :
                            return base.set(key, value);
                        case 3 /* DraftType.Set */ :
                            throw new Error(`Cannot apply replace patch to set.`);
                        default:
                            return base[key] = value;
                    }
                case $f275c1bee2ad9b3e$var$Operation.Add:
                    switch(type){
                        case 1 /* DraftType.Array */ :
                            // If the "-" character is used to
                            // index the end of the array (see [RFC6901](https://datatracker.ietf.org/doc/html/rfc6902)),
                            // this has the effect of appending the value to the array.
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* DraftType.Map */ :
                            return base.set(key, value);
                        case 3 /* DraftType.Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case $f275c1bee2ad9b3e$var$Operation.Remove:
                    switch(type){
                        case 1 /* DraftType.Array */ :
                            return base.splice(key, 1);
                        case 2 /* DraftType.Map */ :
                            return base.delete(key);
                        case 3 /* DraftType.Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    throw new Error(`Unsupported patch operation: ${op}.`);
            }
        });
    };
    if ($f275c1bee2ad9b3e$export$541ac630993a4c84(state)) {
        if (applyOptions !== undefined) throw new Error(`Cannot apply patches with options to a draft.`);
        mutate(state);
        return state;
    }
    return $f275c1bee2ad9b3e$export$185802fd694ee1f5(state, mutate, Object.assign(Object.assign({}, applyOptions), {
        enablePatches: false
    }));
}
/**
 * `original(draft)` to get original state in the draft mutation function.
 *
 * ## Example
 *
 * ```ts
 * import { create, original } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const state = create(
 *   baseState,
 *   (draft) => {
 *     draft.foo.bar = 'str2';
 *     expect(original(draft.foo)).toEqual({ bar: 'str' });
 *   }
 * );
 * ```
 */ function $f275c1bee2ad9b3e$export$22e8af3f75a010e3(target) {
    const proxyDraft = $f275c1bee2ad9b3e$var$getProxyDraft(target);
    if (!proxyDraft) throw new Error(`original() is only used for a draft, parameter: ${target}`);
    return proxyDraft.original;
}
/**
 * Use rawReturn() to wrap the return value to skip the draft check and thus improve performance.
 *
 * ## Example
 *
 * ```ts
 * import { create, rawReturn } from '../index';
 *
 * const baseState = { foo: { bar: 'str' }, arr: [] };
 * const state = create(
 *   baseState,
 *   (draft) => {
 *     return rawReturn(baseState);
 *   },
 * );
 * expect(state).toBe(baseState);
 * ```
 */ function $f275c1bee2ad9b3e$export$cd901fda21a18b43(value) {
    if (arguments.length === 0) throw new Error("rawReturn() must be called with a value.");
    if (arguments.length > 1) throw new Error("rawReturn() must be called with one argument.");
    if (value !== undefined && (typeof value !== "object" || value === null)) console.warn("rawReturn() must be called with an object(including plain object, arrays, Set, Map, etc.) or `undefined`, other types do not need to be returned via rawReturn().");
    return {
        [$f275c1bee2ad9b3e$var$RAW_RETURN_SYMBOL]: [
            value
        ]
    };
}
const $f275c1bee2ad9b3e$var$constructorString = Object.prototype.constructor.toString();
/**
 * Check if the value is a simple object(No prototype chain object or iframe same-origin object),
 * support case: https://github.com/unadlib/mutative/issues/17
 */ const $f275c1bee2ad9b3e$var$isSimpleObject = (value)=>{
    if (!value || typeof value !== "object") return false;
    const prototype = Object.getPrototypeOf(value);
    if (prototype === null) return true;
    const constructor = Object.hasOwnProperty.call(prototype, "constructor") && prototype.constructor;
    if (constructor === Object) return true;
    return typeof constructor === "function" && Function.toString.call(constructor) === $f275c1bee2ad9b3e$var$constructorString;
};
const $f275c1bee2ad9b3e$export$d16063589ba51e59 = (value)=>{
    if ($f275c1bee2ad9b3e$var$isSimpleObject(value)) return $f275c1bee2ad9b3e$var$dataTypes.immutable;
    return;
};
/**
 * Cast a value to an Draft type value.
 */ function $f275c1bee2ad9b3e$export$c05b21e3257751e5(value) {
    return value;
}
/**
 * Cast a value to an Immutable type value.
 */ function $f275c1bee2ad9b3e$export$20f911b3f8cf0b74(value) {
    return value;
}



var $5ad47a8446dd1296$export$5bdeb9e4de225b16;
(function(Suit) {
    Suit[Suit["Clubs"] = 0] = "Clubs";
    Suit[Suit["Diamonds"] = 1] = "Diamonds";
    Suit[Suit["Hearts"] = 2] = "Hearts";
    Suit[Suit["Spades"] = 3] = "Spades";
})($5ad47a8446dd1296$export$5bdeb9e4de225b16 || ($5ad47a8446dd1296$export$5bdeb9e4de225b16 = {}));
const $5ad47a8446dd1296$export$efcc524239c32c73 = [
    0,
    1,
    2,
    3
];
var $5ad47a8446dd1296$export$5062880c778c5dd2;
(function(CardValue) {
    CardValue[CardValue["Ace"] = 14] = "Ace";
    CardValue[CardValue["Two"] = 2] = "Two";
    CardValue[CardValue["Three"] = 3] = "Three";
    CardValue[CardValue["Four"] = 4] = "Four";
    CardValue[CardValue["Five"] = 5] = "Five";
    CardValue[CardValue["Six"] = 6] = "Six";
    CardValue[CardValue["Seven"] = 7] = "Seven";
    CardValue[CardValue["Eight"] = 8] = "Eight";
    CardValue[CardValue["Nine"] = 9] = "Nine";
    CardValue[CardValue["Ten"] = 10] = "Ten";
    CardValue[CardValue["Jack"] = 11] = "Jack";
    CardValue[CardValue["Queen"] = 12] = "Queen";
    CardValue[CardValue["King"] = 13] = "King";
})($5ad47a8446dd1296$export$5062880c778c5dd2 || ($5ad47a8446dd1296$export$5062880c778c5dd2 = {}));
const $5ad47a8446dd1296$export$801f53f8ff768e98 = [
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14
];



function $11ebf6d0f732b2a9$export$eafd19060c8b57dd(withJokers) {
    const baseDeck = (0, $5ad47a8446dd1296$export$efcc524239c32c73).flatMap((suit)=>(0, $5ad47a8446dd1296$export$801f53f8ff768e98).map((value)=>({
                suit: suit,
                value: value
            })));
    if (withJokers) baseDeck.push(...Array.from({
        length: 2
    }).map((_, i)=>({
            joker: i
        })));
    return (0, $e5516a3b810d567d$export$448332262467e042)(baseDeck);
}
const $11ebf6d0f732b2a9$export$47cd02e2cf937030 = [
    {
        cards: 0
    },
    {
        cards: 3
    },
    {
        cards: 1
    },
    {
        cards: 1
    }
];
function $11ebf6d0f732b2a9$export$aab0d876bb6c7a7f(players, config, winRecord) {
    const deck = $11ebf6d0f732b2a9$export$eafd19060c8b57dd(config.withJokers);
    const numCards = config.gameMode === (0, $4c9ffbddec832565$export$7cd7a93136e7148a).OMAHA ? 4 : 2;
    const state = {
        phase: (0, $4c9ffbddec832565$export$1179af6d199a01fa).BIDDING,
        config: config,
        players: players.map((p)=>({
                name: p.name,
                // deal cards to each player (2 for Hold'em, 4 for Omaha)
                hand: deck.splice(0, numCards),
                pastTokens: [],
                token: null
            })),
        communityCards: [],
        deck: deck,
        pastRounds: [],
        futureRounds: $11ebf6d0f732b2a9$export$47cd02e2cf937030,
        jokerLog: [],
        log: [],
        winRecord: winRecord ?? {
            wins: 0,
            losses: 0,
            targetWins: config.targetWins ?? (0, $4c9ffbddec832565$export$a0bea9b09a67f3da).config.targetWins,
            targetLosses: config.targetLosses ?? (0, $4c9ffbddec832565$export$a0bea9b09a67f3da).config.targetLosses
        },
        // start out with null tokens in case we need to resolve jokers
        tokens: players.map(()=>null)
    };
    return $11ebf6d0f732b2a9$export$d68aabd9451ab6d8(state);
}
function $11ebf6d0f732b2a9$var$allHandsResolved(players) {
    return players.every((p)=>p.hand.every((c)=>!(c instanceof Array) && !("joker" in c)));
}
function $11ebf6d0f732b2a9$export$4f2c9bb64a518c51(game) {
    return $11ebf6d0f732b2a9$var$allHandsResolved(game.players);
}
function $11ebf6d0f732b2a9$export$d68aabd9451ab6d8(game) {
    if ($11ebf6d0f732b2a9$export$4f2c9bb64a518c51(game)) return $11ebf6d0f732b2a9$export$9ffc307867ecb30d(game);
    return (0, $f275c1bee2ad9b3e$export$185802fd694ee1f5)(game, (draft)=>{
        draft.players.forEach((player, playerIx)=>{
            if (player.hand.every((obj)=>!(obj instanceof Array))) {
                const ix = player.hand.findIndex((obj)=>"joker" in obj);
                if (ix !== -1) {
                    player.hand[ix] = draft.deck.splice(0, 2);
                    draft.jokerLog.push({
                        player: playerIx
                    });
                }
            }
        });
    });
}
function $11ebf6d0f732b2a9$export$9ffc307867ecb30d(game) {
    const [draft, finalize] = (0, $f275c1bee2ad9b3e$export$185802fd694ee1f5)(game);
    const currentRound = draft.futureRounds.shift();
    if (currentRound == null) return {
        phase: (0, $4c9ffbddec832565$export$1179af6d199a01fa).SCORING,
        config: game.config,
        players: game.players,
        communityCards: game.communityCards,
        deck: game.deck,
        jokerLog: game.jokerLog,
        log: game.log,
        winRecord: game.winRecord,
        pastRounds: game.pastRounds,
        revealIndex: 1
    };
    draft.pastRounds.push(currentRound);
    // update history bookkeeping for a new round
    const roundIndex = draft.log.length;
    if (roundIndex > 0) for (const p of draft.players){
        if (!p.token) throw new Error("can't advance round unless every player has a token!");
        p.pastTokens.push(p.token);
        p.token = null;
    }
    draft.log.push([]);
    // deal new community card(s)
    for(let i = 0; i < currentRound.cards; i += 1){
        const slot = [];
        let cardsInSlot = 1;
        while(cardsInSlot > 0){
            const draw = draft.deck.shift();
            if ("joker" in draw) cardsInSlot += 1;
            else {
                cardsInSlot -= 1;
                slot.push(draw);
            }
        }
        draft.communityCards.push(slot);
    }
    // mint new tokens
    draft.tokens = draft.players.map((_, i)=>({
            index: i + 1,
            round: roundIndex
        }));
    return finalize();
}




var $x1Cpm = parcelRequire("x1Cpm");
function $790317b0321ae339$var$starting(args) {
    const n = parseInt(args || "3");
    return {
        ...(0, $4c9ffbddec832565$export$a0bea9b09a67f3da),
        players: Array.from({
            length: n
        }).map((_, i)=>({
                name: `player${i + 1}`
            }))
    };
}
function $790317b0321ae339$var$makeResolveJokers(args) {
    const deck = (0, $11ebf6d0f732b2a9$export$eafd19060c8b57dd)(false);
    return (0, $11ebf6d0f732b2a9$export$d68aabd9451ab6d8)({
        phase: (0, $4c9ffbddec832565$export$1179af6d199a01fa).BIDDING,
        config: (0, $4c9ffbddec832565$export$a0bea9b09a67f3da).config,
        players: $790317b0321ae339$var$starting(args).players.map((p, i)=>({
                name: p.name,
                hand: i === 0 ? [
                    {
                        joker: 0
                    },
                    deck.shift()
                ] : deck.splice(0, 2),
                pastTokens: [],
                token: null
            })),
        communityCards: [],
        deck: [
            {
                joker: 1
            },
            ...deck
        ],
        pastRounds: [],
        futureRounds: (0, $11ebf6d0f732b2a9$export$47cd02e2cf937030),
        jokerLog: [],
        log: [],
        tokens: [
            null,
            null,
            null
        ],
        winRecord: {
            wins: 0,
            losses: 0,
            targetWins: 3,
            targetLosses: 3
        }
    });
}
function $790317b0321ae339$var$makeFinishing(args) {
    const deck = (0, $11ebf6d0f732b2a9$export$eafd19060c8b57dd)(false);
    return {
        phase: (0, $4c9ffbddec832565$export$1179af6d199a01fa).BIDDING,
        config: (0, $4c9ffbddec832565$export$a0bea9b09a67f3da).config,
        players: $790317b0321ae339$var$starting(args).players.map((p, i)=>({
                name: p.name,
                hand: deck.splice(0, 2),
                pastTokens: Array.from({
                    length: 3
                }).map((_, j)=>({
                        round: j,
                        index: i + 1
                    })),
                token: {
                    index: i + 1,
                    round: 3
                }
            })),
        communityCards: [
            ...deck.splice(0, 4).map((x)=>[
                    x
                ]),
            deck.splice(0, 2)
        ],
        deck: deck,
        pastRounds: (0, $11ebf6d0f732b2a9$export$47cd02e2cf937030),
        futureRounds: [],
        jokerLog: [],
        log: [
            []
        ],
        tokens: [
            null,
            null,
            null
        ],
        winRecord: {
            wins: 2,
            losses: 2,
            targetWins: 3,
            targetLosses: 3
        }
    };
}
const $790317b0321ae339$export$e0dfa59be8d5deec = {
    starting: $790317b0321ae339$var$starting,
    resolveJokers: $790317b0321ae339$var$makeResolveJokers,
    finishing: $790317b0321ae339$var$makeFinishing
};
let $790317b0321ae339$var$STATE = {};
if (null) {
    null.dispose((data)=>{
        data.state = $790317b0321ae339$var$STATE;
    });
    null.accept(()=>{
        $790317b0321ae339$var$STATE = null?.data.state;
    });
}
function $790317b0321ae339$export$f43f349e7f6bb870(roomName, args) {
    const [state, setState] = (0, $x1Cpm.useState)(null);
    (0, $x1Cpm.useEffect)(()=>{
        if (!Object.prototype.hasOwnProperty.call($790317b0321ae339$export$e0dfa59be8d5deec, roomName)) return;
        const makeSetGameState = (version)=>(newState)=>{
                $790317b0321ae339$var$STATE[roomName] = newState;
                setState({
                    roomName: roomName,
                    gameState: newState,
                    stateVersion: version + 1,
                    setGameState: makeSetGameState(version + 1)
                });
            };
        if (!(roomName in $790317b0321ae339$var$STATE)) $790317b0321ae339$var$STATE[roomName] = $790317b0321ae339$export$e0dfa59be8d5deec[roomName](args);
        setState({
            roomName: roomName,
            gameState: $790317b0321ae339$var$STATE[roomName],
            stateVersion: 1,
            setGameState: makeSetGameState(1)
        });
    }, [
        roomName,
        args
    ]);
    return state;
}


function $bf1eafd6cf5d17c7$var$useDevGame(roomName) {
    // not really my favourite
    const [a, b] = roomName.split("/", 2);
    const useFake = Object.prototype.hasOwnProperty.call((0, $790317b0321ae339$export$e0dfa59be8d5deec), a);
    const fake = (0, $790317b0321ae339$export$f43f349e7f6bb870)(a, b ?? "");
    const real = $bf1eafd6cf5d17c7$var$useRealGame(useFake ? "" : roomName);
    return useFake ? fake : real;
}
const $bf1eafd6cf5d17c7$export$b33a393274d59d25 = $bf1eafd6cf5d17c7$var$useRealGame;
async function $bf1eafd6cf5d17c7$var$listLoop(roomName, version, signal) {
    let backoff = 1000;
    while(true)try {
        const result = await (0, $df9b98b38d7c65c2$export$8f24540c37096eb6)(roomName, version, signal);
        backoff = 1000;
        if (result == null) // TODO: potentially add error state
        return null;
        else if ("timeout" in result) continue;
        else return {
            roomName: roomName,
            gameState: result.data,
            stateVersion: result.version,
            setGameState: (newState, abortSignal)=>{
                (0, $df9b98b38d7c65c2$export$254d8d9a9e824f11)(roomName, result.version, newState, abortSignal).then((response)=>{
                    if (!response.success) console.log("commit failed; race condition occurred");
                }).catch((reason)=>{
                    if (!abortSignal.aborted) console.error(reason);
                });
            }
        };
    } catch (e) {
        if (signal.aborted) return null;
        console.error(e);
        // back off and retry
        console.log(`Backing off for ${backoff} ms`);
        await (0, $e5516a3b810d567d$export$1391212d75b2ee65)(backoff);
        backoff *= Math.random() + 0.5;
        backoff = Math.min(backoff, 30000);
        continue;
    }
}
function $bf1eafd6cf5d17c7$var$useRealGame(roomName) {
    const [state, setState] = (0, $x1Cpm.useState)(null);
    const version = state?.stateVersion || 0;
    (0, $x1Cpm.useEffect)(()=>{
        const abortController = new AbortController();
        if (roomName) $bf1eafd6cf5d17c7$var$listLoop(roomName, version, abortController.signal).then(setState);
        return ()=>abortController.abort();
    }, [
        roomName,
        version
    ]);
    return state;
}
function $bf1eafd6cf5d17c7$export$e133dff257bbd218(game, mutator, initial) {
    const { gameState: gameState, setGameState: setGameState } = game;
    const [mutation, setMutation] = (0, $x1Cpm.useState)(initial);
    (0, $x1Cpm.useEffect)(()=>{
        if (mutation === undefined) return;
        const newState = mutator(gameState, mutation);
        if ((0, $e5516a3b810d567d$export$9cb4719e2e525b7a)(gameState, newState)) {
            // noop.
            setMutation(undefined);
            return;
        }
        const abortController = new AbortController();
        setGameState(newState, abortController.signal);
        return ()=>abortController.abort();
    }, [
        setGameState,
        gameState,
        mutator,
        mutation
    ]);
    return [
        mutation,
        setMutation
    ];
}






var $dbc5cdb5e7583bd1$export$e15a579eead45913;
var $dbc5cdb5e7583bd1$export$aa3e815946b80764;
var $dbc5cdb5e7583bd1$export$d4f9a5f4ca31f0b6;
var $dbc5cdb5e7583bd1$export$ff214d0d604522b5;
var $dbc5cdb5e7583bd1$export$a3c666151edc0af1;
var $dbc5cdb5e7583bd1$export$57744285f109f80a;
var $dbc5cdb5e7583bd1$export$15b07da190767bbe;
var $dbc5cdb5e7583bd1$export$d83f873d3f5ec352;
var $dbc5cdb5e7583bd1$export$34e0f9847d4c02dd;
var $dbc5cdb5e7583bd1$export$5ce6e2f0ed680964;
var $dbc5cdb5e7583bd1$export$dc9aaa456befc6ef;
var $dbc5cdb5e7583bd1$export$ab2b7135509352b8;
var $dbc5cdb5e7583bd1$export$59e091b63458fcad;
var $dbc5cdb5e7583bd1$export$f9d2386380135291;
var $dbc5cdb5e7583bd1$export$46e4a324ac90507f;
var $dbc5cdb5e7583bd1$export$186885b852792ae6;
var $dbc5cdb5e7583bd1$export$1ca2d5cca6ec0684;
var $dbc5cdb5e7583bd1$export$bef1f36f5486a6a3;
var $dbc5cdb5e7583bd1$export$5695df298eac90c7;
var $dbc5cdb5e7583bd1$export$2478040385952f4;
var $dbc5cdb5e7583bd1$export$6363130eec868cea;
var $dbc5cdb5e7583bd1$export$ae96dc96a6d2b85;
var $dbc5cdb5e7583bd1$export$9fc9795b76ef397;
var $dbc5cdb5e7583bd1$export$b96c721ebdea39c5;
var $dbc5cdb5e7583bd1$export$615455393ee443ca;
var $dbc5cdb5e7583bd1$export$777feab933bd57da;
var $dbc5cdb5e7583bd1$export$2b8dccb26e41f6c2;
var $dbc5cdb5e7583bd1$export$c19b0e76dce888eb;
var $dbc5cdb5e7583bd1$export$f99014d66fbedb21;
var $dbc5cdb5e7583bd1$export$7c019dd0d8dd20e9;
var $dbc5cdb5e7583bd1$export$7817e5b9f07d367d;
var $dbc5cdb5e7583bd1$export$684005c1234186c6;
var $dbc5cdb5e7583bd1$export$766d56154a07562d;
var $dbc5cdb5e7583bd1$export$274575f92f7d9549;
var $dbc5cdb5e7583bd1$export$9e1725a4cfeada27;
var $dbc5cdb5e7583bd1$export$295a54748b69c781;
var $dbc5cdb5e7583bd1$export$dce947101b6c7e1f;
var $dbc5cdb5e7583bd1$export$6975c428062f2314;
var $dbc5cdb5e7583bd1$export$e5260f96c83f90f4;
var $dbc5cdb5e7583bd1$export$49ccc6e12fc9278a;
var $dbc5cdb5e7583bd1$export$1009eb603770e7e2;
var $dbc5cdb5e7583bd1$export$10a0f131c0eea21b;
var $dbc5cdb5e7583bd1$export$d77e2c2b3d2d6ff8;
$dbc5cdb5e7583bd1$export$e15a579eead45913 = `xL7ZpG_blackSuit`;
$dbc5cdb5e7583bd1$export$aa3e815946b80764 = `xL7ZpG_card`;
$dbc5cdb5e7583bd1$export$d4f9a5f4ca31f0b6 = `xL7ZpG_cardClickable`;
$dbc5cdb5e7583bd1$export$ff214d0d604522b5 = `xL7ZpG_cardHighlight`;
$dbc5cdb5e7583bd1$export$a3c666151edc0af1 = `xL7ZpG_cardJoker`;
$dbc5cdb5e7583bd1$export$57744285f109f80a = `xL7ZpG_cardStack`;
$dbc5cdb5e7583bd1$export$15b07da190767bbe = `xL7ZpG_clubsSuit`;
$dbc5cdb5e7583bd1$export$d83f873d3f5ec352 = `xL7ZpG_communityCards`;
$dbc5cdb5e7583bd1$export$34e0f9847d4c02dd = `xL7ZpG_container`;
$dbc5cdb5e7583bd1$export$5ce6e2f0ed680964 = `xL7ZpG_diamondsSuit`;
$dbc5cdb5e7583bd1$export$dc9aaa456befc6ef = `xL7ZpG_futureRound`;
$dbc5cdb5e7583bd1$export$ab2b7135509352b8 = `xL7ZpG_gameResult`;
$dbc5cdb5e7583bd1$export$59e091b63458fcad = `xL7ZpG_hand`;
$dbc5cdb5e7583bd1$export$f9d2386380135291 = `xL7ZpG_handScore`;
$dbc5cdb5e7583bd1$export$46e4a324ac90507f = `xL7ZpG_heading`;
$dbc5cdb5e7583bd1$export$186885b852792ae6 = `xL7ZpG_heartsSuit`;
$dbc5cdb5e7583bd1$export$1ca2d5cca6ec0684 = `xL7ZpG_highlightPlayer`;
$dbc5cdb5e7583bd1$export$bef1f36f5486a6a3 = `xL7ZpG_log`;
$dbc5cdb5e7583bd1$export$5695df298eac90c7 = `xL7ZpG_loss`;
$dbc5cdb5e7583bd1$export$2478040385952f4 = `xL7ZpG_noCard`;
$dbc5cdb5e7583bd1$export$6363130eec868cea = `xL7ZpG_noToken`;
$dbc5cdb5e7583bd1$export$ae96dc96a6d2b85 = `xL7ZpG_notLoss`;
$dbc5cdb5e7583bd1$export$9fc9795b76ef397 = `xL7ZpG_notWin`;
$dbc5cdb5e7583bd1$export$b96c721ebdea39c5 = `xL7ZpG_pastToken`;
$dbc5cdb5e7583bd1$export$615455393ee443ca = `xL7ZpG_player`;
$dbc5cdb5e7583bd1$export$777feab933bd57da = `xL7ZpG_playerName`;
$dbc5cdb5e7583bd1$export$2b8dccb26e41f6c2 = `xL7ZpG_players`;
$dbc5cdb5e7583bd1$export$c19b0e76dce888eb = `xL7ZpG_redSuit`;
$dbc5cdb5e7583bd1$export$f99014d66fbedb21 = `xL7ZpG_revealLog`;
$dbc5cdb5e7583bd1$export$7c019dd0d8dd20e9 = `xL7ZpG_roundCards`;
$dbc5cdb5e7583bd1$export$7817e5b9f07d367d = `xL7ZpG_roundLog`;
$dbc5cdb5e7583bd1$export$684005c1234186c6 = `xL7ZpG_roundLogEntry`;
$dbc5cdb5e7583bd1$export$766d56154a07562d = `xL7ZpG_smallToken`;
$dbc5cdb5e7583bd1$export$274575f92f7d9549 = `xL7ZpG_spadesSuit`;
$dbc5cdb5e7583bd1$export$9e1725a4cfeada27 = `xL7ZpG_token`;
$dbc5cdb5e7583bd1$export$295a54748b69c781 = `xL7ZpG_token1`;
$dbc5cdb5e7583bd1$export$dce947101b6c7e1f = `xL7ZpG_token2`;
$dbc5cdb5e7583bd1$export$6975c428062f2314 = `xL7ZpG_token3`;
$dbc5cdb5e7583bd1$export$e5260f96c83f90f4 = `xL7ZpG_token4`;
$dbc5cdb5e7583bd1$export$49ccc6e12fc9278a = `xL7ZpG_tokenPlaceholder`;
$dbc5cdb5e7583bd1$export$1009eb603770e7e2 = `xL7ZpG_tokenPool`;
$dbc5cdb5e7583bd1$export$10a0f131c0eea21b = `xL7ZpG_win`;
$dbc5cdb5e7583bd1$export$d77e2c2b3d2d6ff8 = `xL7ZpG_winRecord`;




var $e52b9210ca254aaf$export$717297effe2ca6d9;
(function(HandKind) {
    HandKind[HandKind["HighCard"] = 1] = "HighCard";
    HandKind[HandKind["Pair"] = 2] = "Pair";
    HandKind[HandKind["TwoPair"] = 3] = "TwoPair";
    HandKind[HandKind["ThreeOfAKind"] = 4] = "ThreeOfAKind";
    HandKind[HandKind["Straight"] = 5] = "Straight";
    HandKind[HandKind["Flush"] = 6] = "Flush";
    HandKind[HandKind["FullHouse"] = 7] = "FullHouse";
    HandKind[HandKind["FourOfAKind"] = 8] = "FourOfAKind";
    HandKind[HandKind["StraightFlush"] = 9] = "StraightFlush";
})($e52b9210ca254aaf$export$717297effe2ca6d9 || ($e52b9210ca254aaf$export$717297effe2ca6d9 = {}));
function $e52b9210ca254aaf$export$341946c3512d5b4f(a, b) {
    if (a.kind !== b.kind) return a.kind < b.kind;
    for(let i = 0; i < a.order.length; i += 1){
        if (a.order[i] !== b.order[i]) return a.order[i] < b.order[i];
    }
    return false;
}
function $e52b9210ca254aaf$export$9429a84df33c7b5e(inputHand) {
    if (inputHand.length !== 5) throw new Error("what game is this?");
    const hand = inputHand.toSorted((a, b)=>{
        if (a.value === b.value) return a.suit - b.suit;
        return a.value - b.value;
    });
    const isFlush = hand.every((c)=>c.suit === hand[0].suit);
    const isStraight = hand.every((c, i)=>i === 0 || c.value === hand[i - 1].value + 1 || /* Special case: ace counts as 1 for a straight */ c.value === (0, $5ad47a8446dd1296$export$5062880c778c5dd2).Ace && hand[i - 1].value === (0, $5ad47a8446dd1296$export$5062880c778c5dd2).Five);
    const straightValue = isStraight ? hand[4].value === (0, $5ad47a8446dd1296$export$5062880c778c5dd2).Ace && hand[3].value === (0, $5ad47a8446dd1296$export$5062880c778c5dd2).Five ? (0, $5ad47a8446dd1296$export$5062880c778c5dd2).Five : hand[4].value : null;
    if (isFlush && straightValue != null) // Straight flush and/or royal flush
    // i am obliged to consider a royal flush to be a special case of a straight flush that doesn't require extra handling
    return {
        kind: 9,
        order: [
            straightValue
        ]
    };
    // why is this spelled out?
    let pair, secondPair, triple, quad;
    for (const cardValue of (0, $5ad47a8446dd1296$export$801f53f8ff768e98)){
        const count = hand.reduce((count, card)=>count + (card.value === cardValue ? 1 : 0), 0);
        if (count === 2) {
            if (pair != null) secondPair = cardValue;
            else pair = cardValue;
        } else if (count === 3) triple = cardValue;
        else if (count === 4) quad = cardValue;
    }
    if (quad) {
        const kicker = hand.find((c)=>c.value !== quad);
        return {
            kind: 8,
            order: [
                quad,
                kicker.value
            ]
        };
    }
    if (triple && pair) return {
        kind: 7,
        order: [
            triple,
            pair
        ]
    };
    if (isFlush) return {
        kind: 6,
        order: hand.reverse().map((c)=>c.value)
    };
    if (straightValue != null) return {
        kind: 5,
        order: [
            straightValue
        ]
    };
    if (triple) {
        const kicker = hand.filter((c)=>c.value !== triple);
        return {
            kind: 4,
            order: [
                triple,
                kicker[1].value,
                kicker[0].value
            ]
        };
    }
    if (secondPair) {
        const kicker = hand.find((c)=>c.value !== pair && c.value !== secondPair);
        // secondPair is always higher than pair
        return {
            kind: 3,
            order: [
                secondPair,
                pair,
                kicker.value
            ]
        };
    }
    if (pair) {
        const kicker = hand.filter((c)=>c.value !== pair);
        return {
            kind: 2,
            order: [
                pair,
                kicker[2].value,
                kicker[1].value,
                kicker[0].value
            ]
        };
    }
    return {
        kind: 1,
        order: hand.reverse().map((c)=>c.value)
    };
}
function $e52b9210ca254aaf$export$49fc09f142764042(cards) {
    if (cards.length < 5) throw new Error("no");
    const picked = [];
    let best = null;
    const dfs = (i)=>{
        if (picked.length === 5) {
            const score = $e52b9210ca254aaf$export$9429a84df33c7b5e(picked);
            if (best == null || $e52b9210ca254aaf$export$341946c3512d5b4f(best[1], score)) best = [
                [
                    ...picked
                ],
                score
            ];
            return;
        }
        if (cards.length - i < 5 - picked.length) return;
        if (cards[i] instanceof Array) for (const card of cards[i]){
            picked.push(card);
            dfs(i + 1);
            picked.pop();
        }
        else {
            picked.push(cards[i]);
            dfs(i + 1);
            picked.pop();
        }
        dfs(i + 1);
    };
    dfs(0);
    return best;
}
function $e52b9210ca254aaf$export$9bb0b1c644f80ff4(holeCards, communityCards) {
    if (holeCards.length !== 4) throw new Error("Omaha requires 4 hole cards");
    if (communityCards.length !== 5) throw new Error("Omaha requires 5 community cards");
    // Flatten community cards (handle joker expansions)
    const flatCommunity = communityCards.map((c)=>c instanceof Array ? c : [
            c
        ]);
    let best = null;
    // Try all C(4,2) = 6 combinations of hole cards
    for(let h1 = 0; h1 < 4; h1++)for(let h2 = h1 + 1; h2 < 4; h2++){
        // Try all C(5,3) = 10 combinations of community cards
        for(let c1 = 0; c1 < 5; c1++)for(let c2 = c1 + 1; c2 < 5; c2++){
            for(let c3 = c2 + 1; c3 < 5; c3++)// Handle joker card arrays
            for (const card1 of flatCommunity[c1]){
                for (const card2 of flatCommunity[c2])for (const card3 of flatCommunity[c3]){
                    const hand = [
                        holeCards[h1],
                        holeCards[h2],
                        card1,
                        card2,
                        card3
                    ];
                    const score = $e52b9210ca254aaf$export$9429a84df33c7b5e(hand);
                    if (best == null || $e52b9210ca254aaf$export$341946c3512d5b4f(best[1], score)) best = [
                        hand,
                        score
                    ];
                }
            }
        }
    }
    return best;
}



var $x1Cpm = parcelRequire("x1Cpm");



var $x1Cpm = parcelRequire("x1Cpm");
const $b3a4620d7b727d99$var$TokenAnimatorContext = /*#__PURE__*/ (0, $x1Cpm.createContext)(null);
function $b3a4620d7b727d99$export$98719c5386511477({ children: children }) {
    const m = (0, $x1Cpm.useRef)(null);
    if (m.current == null) m.current = new Map();
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($b3a4620d7b727d99$var$TokenAnimatorContext.Provider, {
        value: m.current,
        children: children
    });
}
function $b3a4620d7b727d99$var$tokenStr(t) {
    return `${t.round}-${t.index}`;
}
const $b3a4620d7b727d99$export$46749a52babc13e3 = [
    $dbc5cdb5e7583bd1$export$295a54748b69c781,
    $dbc5cdb5e7583bd1$export$dce947101b6c7e1f,
    $dbc5cdb5e7583bd1$export$6975c428062f2314,
    $dbc5cdb5e7583bd1$export$e5260f96c83f90f4
];
function $b3a4620d7b727d99$export$bfce916c5bf59899(props) {
    const { token: token, disabled: disabled, past: past, onClick: onClick } = props;
    const animatorContext = (0, $x1Cpm.useContext)($b3a4620d7b727d99$var$TokenAnimatorContext);
    const containerRef = (0, $x1Cpm.useRef)(null);
    const ref = (0, $x1Cpm.useRef)(null);
    (0, $x1Cpm.useLayoutEffect)(()=>{
        if (!token || !animatorContext) return;
        const name = $b3a4620d7b727d99$var$tokenStr(token);
        if (!ref.current || !containerRef.current) return;
        const x = containerRef.current.offsetLeft;
        const y = containerRef.current.offsetTop;
        const existing = animatorContext.get(name);
        if (existing) {
            const dx = existing.x - x;
            const dy = existing.y - y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            const time = distance / 1200 + 0.1;
            ref.current.style.transition = "";
            ref.current.style.position = "relative";
            ref.current.style.left = `${dx}px`;
            ref.current.style.top = `${dy}px`;
            ref.current.offsetLeft; // force a relayout
            const timingFunction = "cubic-bezier(0.285, 0.880, 0.790, 1)";
            ref.current.style.transition = `top ${time}s ${timingFunction}, left ${time}s ${timingFunction}`;
            ref.current.style.left = "0";
            ref.current.style.top = "0";
        }
        animatorContext.set(name, {
            x: x,
            y: y
        });
        const observer = new ResizeObserver(()=>{
            if (containerRef.current) animatorContext.set(name, {
                x: containerRef.current.offsetLeft,
                y: containerRef.current.offsetTop
            });
        });
        observer.observe(document.body);
        return ()=>observer.disconnect();
    }, [
        token,
        animatorContext
    ]);
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
        className: $dbc5cdb5e7583bd1$export$6363130eec868cea,
        ref: containerRef,
        children: token && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
            className: `${$dbc5cdb5e7583bd1$export$9e1725a4cfeada27} ${past ? $dbc5cdb5e7583bd1$export$b96c721ebdea39c5 : ""} ${$b3a4620d7b727d99$export$46749a52babc13e3[token.round]}`,
            disabled: disabled,
            onClick: onClick,
            ref: ref,
            children: token.index
        })
    });
}




var $x1Cpm = parcelRequire("x1Cpm");
const $0d381e8093a15450$var$FX_FPS = 90;
var $0d381e8093a15450$var$ParticleBufferOffset;
(function(ParticleBufferOffset) {
    ParticleBufferOffset[ParticleBufferOffset["TTL"] = 0] = "TTL";
    ParticleBufferOffset[ParticleBufferOffset["X"] = 1] = "X";
    ParticleBufferOffset[ParticleBufferOffset["Y"] = 2] = "Y";
    ParticleBufferOffset[ParticleBufferOffset["ANGLE"] = 3] = "ANGLE";
    ParticleBufferOffset[ParticleBufferOffset["DX"] = 4] = "DX";
    ParticleBufferOffset[ParticleBufferOffset["DY"] = 5] = "DY";
    ParticleBufferOffset[ParticleBufferOffset["DANGLE"] = 6] = "DANGLE";
    ParticleBufferOffset[ParticleBufferOffset["T0"] = 7] = "T0";
    ParticleBufferOffset[ParticleBufferOffset["LENGTH"] = 8] = "LENGTH";
})($0d381e8093a15450$var$ParticleBufferOffset || ($0d381e8093a15450$var$ParticleBufferOffset = {}));
class $0d381e8093a15450$var$ParticleSystem {
    constructor({ maxParticles: maxParticles, particleLifespanS: particleLifespanS, gravity: gravity, drag: drag }){
        this.maxParticles = maxParticles;
        this.particleLifespan = particleLifespanS;
        this.gravity = gravity ?? 0;
        this.drag = drag;
        this.numParticles = 0;
        this.startOffset = 0;
        this.particleBuffer = new Float32Array(maxParticles * 8);
    }
    addParticle(x, y, angle, dx, dy, dangle, time) {
        const particleOffset = (this.startOffset + this.numParticles) % this.maxParticles * 8;
        this.particleBuffer[particleOffset + 0] = this.particleLifespan;
        this.particleBuffer[particleOffset + 1] = x;
        this.particleBuffer[particleOffset + 2] = y;
        this.particleBuffer[particleOffset + 3] = angle;
        this.particleBuffer[particleOffset + 4] = dx;
        this.particleBuffer[particleOffset + 5] = dy;
        this.particleBuffer[particleOffset + 6] = dangle;
        this.particleBuffer[particleOffset + 7] = time;
        if (this.numParticles + 1 > this.maxParticles) {
            this.startOffset += 1;
            this.numParticles = this.maxParticles;
        } else this.numParticles += 1;
    }
    forEachParticle(time, cb) {
        const { drag: drag, gravity: gravity } = this;
        for(let i = 0; i < this.numParticles; i++){
            const idx = (this.startOffset + i) % this.maxParticles;
            const particleOffset = idx * 8;
            const t0 = this.particleBuffer[particleOffset + 7];
            const t = time - t0;
            const ttl = this.particleBuffer[particleOffset + 0] - t;
            if (ttl < 0) continue;
            const expt = Math.expm1(drag * t);
            const x0 = this.particleBuffer[particleOffset + 1];
            const dx0 = this.particleBuffer[particleOffset + 4];
            const x = dx0 * expt / drag + x0;
            const y0 = this.particleBuffer[particleOffset + 2];
            const dy0 = this.particleBuffer[particleOffset + 5];
            const y = ((dy0 + gravity / drag) * expt - gravity * t) / drag + y0;
            const angle = this.particleBuffer[particleOffset + 3] + time * this.particleBuffer[particleOffset + 6];
            cb({
                idx: idx,
                ttl: ttl,
                x: x,
                y: y,
                angle: angle
            });
        }
    }
}
class $0d381e8093a15450$var$ConfettiEmitter {
    constructor(){
        this.particleSystem = new $0d381e8093a15450$var$ParticleSystem({
            maxParticles: 10000,
            particleLifespanS: 8,
            gravity: 1000,
            drag: -3
        });
    }
    shootConfetti(x, y, angle, power, time) {
        for(let i = 0; i < 600; i++){
            const angleDeviation = Math.PI * 0.8 * (Math.random() - 0.5);
            const powerDeviation = -0.95 * Math.random() * power;
            this.particleSystem.addParticle(x, y, Math.random() * Math.PI * 2, Math.cos(angle + angleDeviation) * (power + powerDeviation), Math.sin(angle + angleDeviation) * (power + powerDeviation), (Math.random() - 0.5) * 4, time);
        }
    }
    render(gfx, time) {
        let particles = 0;
        this.particleSystem.forEachParticle(time, ({ idx: idx, ttl: ttl, x: x, y: y, angle: angle })=>{
            const alpha = Math.min(ttl, 1.0);
            gfx.fillStyle = `rgba(${[
                "168,100,253",
                "41,205,255",
                "120,255,68",
                "255,113,141",
                "253,255,106"
            ][idx % 5]},${alpha})`;
            const xOffset = Math.sin(angle) * 30;
            gfx.translate(x + xOffset, y);
            gfx.rotate(angle);
            gfx.fillRect(-5, -3, 10, 6);
            gfx.resetTransform();
            particles += 1;
        });
        return particles;
    }
}
const $0d381e8093a15450$export$b8875e128ae6a5e2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($x1Cpm))).createContext({
    shootConfetti: ()=>{}
});
const $0d381e8093a15450$export$9dda24da7a3e1479 = ({ children: children })=>{
    const canvasRef = (0, $x1Cpm.useRef)(null);
    const confettiRef = (0, $x1Cpm.useRef)();
    (0, $x1Cpm.useEffect)(()=>{
        if (canvasRef.current === null) return;
        const fx = $0d381e8093a15450$var$createFxContext(canvasRef.current);
        if (fx === null) return;
        const confettiEmitter = new $0d381e8093a15450$var$ConfettiEmitter();
        fx.emitters.push(confettiEmitter);
        confettiRef.current = (x, y, angle)=>{
            confettiEmitter.shootConfetti(x, y, angle, 6000, document.timeline.currentTime / 1000);
            $0d381e8093a15450$var$startFxLoop(fx);
        };
        return ()=>{
            fx.active = false;
        };
    }, []);
    const shootConfetti = (0, $x1Cpm.useCallback)((x, y, angle)=>{
        confettiRef.current?.(x, y, angle);
    }, [
        confettiRef
    ]);
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)($0d381e8093a15450$export$b8875e128ae6a5e2.Provider, {
        value: {
            shootConfetti: shootConfetti
        },
        children: [
            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("canvas", {
                ref: canvasRef,
                style: {
                    top: 0,
                    left: 0,
                    position: "fixed",
                    pointerEvents: "none"
                }
            }),
            children
        ]
    });
};
function $0d381e8093a15450$var$startFxLoop(fx) {
    if (!fx.paused) return;
    fx.paused = false;
    const loopImpl = (nowMs)=>{
        if (!fx.active) return;
        const now = (nowMs ?? document.timeline.currentTime) / 1000;
        if (fx.lastRender == null || now - fx.lastRender > 1 / $0d381e8093a15450$var$FX_FPS) {
            fx.lastRender = now;
            // Throttle animation, since this is just silly effect
            if (!$0d381e8093a15450$var$renderFxFrame(fx, now)) {
                // No particles left, stop looping.
                fx.paused = true;
                return;
            }
        }
        requestAnimationFrame(loopImpl);
    };
    loopImpl(null);
}
function $0d381e8093a15450$var$createFxContext(canvas) {
    const gfx = canvas.getContext("2d");
    if (gfx === null) return null;
    return {
        canvas: canvas,
        gfx: gfx,
        emitters: [],
        active: true,
        lastRender: null,
        paused: true
    };
}
function $0d381e8093a15450$var$renderFxFrame(fx, time) {
    const width = window.innerWidth;
    const height = window.innerHeight;
    fx.canvas.width = width;
    fx.canvas.height = height;
    fx.gfx.clearRect(0, 0, width, height);
    let particles = 0;
    for (const emitter of fx.emitters)particles += emitter.render(fx.gfx, time);
    return particles;
}





var $x1Cpm = parcelRequire("x1Cpm");
const $0727822e6bb8853d$var$DEFAULT_PREFERENCES = {
    fourColourSuits: false
};
const $0727822e6bb8853d$var$STORAGE_KEY = "ruffians-preferences";
function $0727822e6bb8853d$var$loadPreferences() {
    try {
        const stored = localStorage.getItem($0727822e6bb8853d$var$STORAGE_KEY);
        if (stored) return {
            ...$0727822e6bb8853d$var$DEFAULT_PREFERENCES,
            ...JSON.parse(stored)
        };
    } catch (e) {
        console.error("Failed to load preferences:", e);
    }
    return $0727822e6bb8853d$var$DEFAULT_PREFERENCES;
}
function $0727822e6bb8853d$var$savePreferences(prefs) {
    try {
        localStorage.setItem($0727822e6bb8853d$var$STORAGE_KEY, JSON.stringify(prefs));
    } catch (e) {
        console.error("Failed to save preferences:", e);
    }
}
const $0727822e6bb8853d$var$PreferencesContext = /*#__PURE__*/ (0, $x1Cpm.createContext)(null);
function $0727822e6bb8853d$export$3d5a0a3e1b7bc50c({ children: children }) {
    const [preferences, setPreferencesState] = (0, $x1Cpm.useState)($0727822e6bb8853d$var$loadPreferences);
    const setPreferences = (updates)=>{
        setPreferencesState((prev)=>{
            const next = {
                ...prev,
                ...updates
            };
            $0727822e6bb8853d$var$savePreferences(next);
            return next;
        });
    };
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($0727822e6bb8853d$var$PreferencesContext.Provider, {
        value: {
            preferences: preferences,
            setPreferences: setPreferences
        },
        children: children
    });
}
function $0727822e6bb8853d$export$bbd7d970555e2952() {
    const context = (0, $x1Cpm.useContext)($0727822e6bb8853d$var$PreferencesContext);
    if (!context) throw new Error("usePreferences must be used within PreferencesProvider");
    return [
        context.preferences,
        context.setPreferences
    ];
}


var $97656cf21305f8df$export$6d59db4903f20f7d;
var $97656cf21305f8df$export$a75d1723e6bda2ec;
var $97656cf21305f8df$export$29dd17c7f3c81c36;
var $97656cf21305f8df$export$21f42ab9b6679f44;
$97656cf21305f8df$export$6d59db4903f20f7d = `IRU1Ha_description`;
$97656cf21305f8df$export$a75d1723e6bda2ec = `IRU1Ha_option`;
$97656cf21305f8df$export$29dd17c7f3c81c36 = `IRU1Ha_overlay`;
$97656cf21305f8df$export$21f42ab9b6679f44 = `IRU1Ha_panel`;


function $36a7a41fb8398a5f$export$a8eae1dfb4299f8(props) {
    const { onClose: onClose } = props;
    const [preferences, setPreferences] = (0, $0727822e6bb8853d$export$bbd7d970555e2952)();
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
        className: $97656cf21305f8df$export$29dd17c7f3c81c36,
        onClick: onClose,
        children: /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
            className: $97656cf21305f8df$export$21f42ab9b6679f44,
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("h2", {
                    children: "Preferences"
                }),
                /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                    className: $97656cf21305f8df$export$a75d1723e6bda2ec,
                    children: [
                        /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("input", {
                            type: "checkbox",
                            id: "fourColourSuits",
                            checked: preferences.fourColourSuits,
                            onChange: (e)=>setPreferences({
                                    fourColourSuits: e.target.checked
                                })
                        }),
                        /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("label", {
                            htmlFor: "fourColourSuits",
                            children: "Four-colour suits"
                        }),
                        /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("p", {
                            className: $97656cf21305f8df$export$6d59db4903f20f7d,
                            children: "Display each suit in a different colour."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                    onClick: onClose,
                    children: "Close"
                })
            ]
        })
    });
}


function $e7256e8c5c8fe034$export$985739bfa5723e08(props) {
    const { username: username, setUsername: setUsername, roomName: roomName } = props;
    const game = (0, $bf1eafd6cf5d17c7$export$b33a393274d59d25)(roomName);
    if (!game) return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
        children: "loading..."
    });
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $0727822e6bb8853d$export$3d5a0a3e1b7bc50c), {
        children: /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$GameInner, {
            username: username,
            setUsername: setUsername,
            game: game
        })
    });
}
function $e7256e8c5c8fe034$var$GameInner(props) {
    const { username: username, setUsername: setUsername, game: game } = props;
    switch(game.gameState.phase){
        case (0, $4c9ffbddec832565$export$1179af6d199a01fa).SETUP:
            // https://github.com/microsoft/TypeScript/issues/18758
            return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$SetupGame, {
                username: username,
                game: {
                    ...game,
                    gameState: game.gameState
                }
            });
        case (0, $4c9ffbddec832565$export$1179af6d199a01fa).BIDDING:
            return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $b3a4620d7b727d99$export$98719c5386511477), {
                children: /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$BiddingGame, {
                    username: username,
                    setUsername: setUsername,
                    game: {
                        ...game,
                        gameState: game.gameState
                    }
                })
            });
        case (0, $4c9ffbddec832565$export$1179af6d199a01fa).SCORING:
            return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $0d381e8093a15450$export$9dda24da7a3e1479), {
                children: /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$ScoringGame, {
                    username: username,
                    game: {
                        ...game,
                        gameState: game.gameState
                    }
                })
            });
    }
}
function $e7256e8c5c8fe034$var$joinRoomMutator(game, username) {
    if (game.players.some((p)=>p.name === username)) return game;
    return {
        ...game,
        players: [
            ...game.players,
            {
                name: username
            }
        ]
    };
}
function $e7256e8c5c8fe034$var$leaveRoomMutator(game, username) {
    return {
        ...game,
        players: game.players.filter((p)=>p.name !== username)
    };
}
function $e7256e8c5c8fe034$var$withJokersMutator(game, withJokers) {
    return (0, $f275c1bee2ad9b3e$export$185802fd694ee1f5)(game, (draft)=>{
        draft.config.withJokers = withJokers;
    });
}
function $e7256e8c5c8fe034$var$gameModeMutator(game, gameMode) {
    return (0, $f275c1bee2ad9b3e$export$185802fd694ee1f5)(game, (draft)=>{
        draft.config.gameMode = gameMode;
    });
}
function $e7256e8c5c8fe034$var$startGameMutator(game) {
    return (0, $11ebf6d0f732b2a9$export$aab0d876bb6c7a7f)(game.players, game.config);
}
function $e7256e8c5c8fe034$var$SetupGame(props) {
    const { username: username, game: game } = props;
    const inRoom = game.gameState.players.some((p)=>p.name === username);
    const [, setJoinRoom] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$joinRoomMutator);
    const [, setLeaveRoom] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$leaveRoomMutator);
    const joinRoom = ()=>setJoinRoom(username);
    const [withJokersMutation, setWithJokers] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$withJokersMutator);
    const [gameModeMutation, setGameMode] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$gameModeMutator);
    const [, setStartGame] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$startGameMutator);
    const startGame = ()=>setStartGame(true);
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
        className: $dbc5cdb5e7583bd1$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                className: $dbc5cdb5e7583bd1$export$2b8dccb26e41f6c2,
                children: [
                    game.gameState.players.map((p, pi)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                            className: $dbc5cdb5e7583bd1$export$615455393ee443ca,
                            children: [
                                /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                                    className: $dbc5cdb5e7583bd1$export$777feab933bd57da,
                                    style: p.name === username ? {} : {
                                        color: $e7256e8c5c8fe034$var$playerColour(pi)
                                    },
                                    children: p.name
                                }),
                                inRoom && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)((0, $8f33693030ac5281$exports.Fragment), {
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                                            onClick: ()=>setLeaveRoom(p.name),
                                            children: p.name === username ? "Leave" : "Kick"
                                        })
                                    ]
                                })
                            ]
                        }, p.name)),
                    !inRoom && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                        className: $dbc5cdb5e7583bd1$export$615455393ee443ca,
                        children: /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                            onClick: joinRoom,
                            children: "Join room"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                children: [
                    game.gameState.winRecord && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)((0, $8f33693030ac5281$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$WinRecordView, {
                                record: game.gameState.winRecord
                            }),
                            game.gameState.winRecord.wins === game.gameState.winRecord.targetWins && "You won!",
                            game.gameState.winRecord.losses === game.gameState.winRecord.targetLosses && "You unwon."
                        ]
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                        className: $dbc5cdb5e7583bd1$export$46e4a324ac90507f,
                        children: "Creating a new game"
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("input", {
                        type: "checkbox",
                        checked: withJokersMutation ?? game.gameState.config.withJokers,
                        onChange: (e)=>setWithJokers(e.target.checked),
                        id: "with_jokers"
                    }),
                    " ",
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("label", {
                        htmlFor: "with_jokers",
                        children: "Include jokers in the deck"
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("label", {
                                children: "Game mode:"
                            }),
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("input", {
                                        type: "radio",
                                        name: "gameMode",
                                        id: "texas_holdem",
                                        checked: (gameModeMutation ?? game.gameState.config.gameMode ?? (0, $4c9ffbddec832565$export$7cd7a93136e7148a).TEXAS_HOLDEM) === (0, $4c9ffbddec832565$export$7cd7a93136e7148a).TEXAS_HOLDEM,
                                        onChange: ()=>setGameMode((0, $4c9ffbddec832565$export$7cd7a93136e7148a).TEXAS_HOLDEM)
                                    }),
                                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("label", {
                                        htmlFor: "texas_holdem",
                                        children: "Texas Hold'em (2 cards)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("input", {
                                        type: "radio",
                                        name: "gameMode",
                                        id: "omaha",
                                        checked: (gameModeMutation ?? game.gameState.config.gameMode ?? (0, $4c9ffbddec832565$export$7cd7a93136e7148a).TEXAS_HOLDEM) === (0, $4c9ffbddec832565$export$7cd7a93136e7148a).OMAHA,
                                        onChange: ()=>setGameMode((0, $4c9ffbddec832565$export$7cd7a93136e7148a).OMAHA)
                                    }),
                                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("label", {
                                        htmlFor: "omaha",
                                        children: "Omaha (4 cards)"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                        className: "startGame",
                        disabled: !inRoom || game.gameState.players.length < 2 || withJokersMutation != null || gameModeMutation != null,
                        onClick: startGame,
                        children: "Start game"
                    })
                ]
            })
        ]
    });
}
function $e7256e8c5c8fe034$var$moveTokenMutator(game, [username, token, from]) {
    return (0, $f275c1bee2ad9b3e$export$185802fd694ee1f5)(game, (draft)=>{
        const toPlayerIndex = draft.players.findIndex((p)=>p.name === username);
        if (toPlayerIndex === -1) return;
        const toPlayer = draft.players[toPlayerIndex];
        const log = draft.log[draft.log.length - 1];
        const relinquish = ()=>{
            if (toPlayer.token) {
                const t = toPlayer.token;
                draft.tokens[toPlayer.token.index - 1] = t;
                toPlayer.token = null;
                return t;
            }
            return null;
        };
        if (!token) {
            const put = relinquish();
            if (put) log.push({
                player: toPlayerIndex,
                action: {
                    put: put
                }
            });
        } else if (from != null) {
            if (from === username) return; // this makes no sense
            // take from another player
            const fromPlayerIndex = draft.players.findIndex((p)=>p.name === from);
            if (fromPlayerIndex !== -1) {
                const fromPlayer = draft.players[fromPlayerIndex];
                if ((0, $e5516a3b810d567d$export$9cb4719e2e525b7a)(fromPlayer.token, token)) {
                    const put = relinquish();
                    log.push({
                        player: toPlayerIndex,
                        action: {
                            from: fromPlayerIndex,
                            put: put,
                            take: token
                        }
                    });
                    toPlayer.token = fromPlayer.token;
                    fromPlayer.token = null;
                }
            }
        } else {
            const ix = draft.tokens.findIndex((t)=>(0, $e5516a3b810d567d$export$9cb4719e2e525b7a)(t, token));
            if (ix !== -1) {
                draft.tokens[ix] = null;
                const put = relinquish();
                log.push({
                    player: toPlayerIndex,
                    action: {
                        from: null,
                        put: put,
                        take: token
                    }
                });
                toPlayer.token = token;
            }
        }
    });
}
function $e7256e8c5c8fe034$var$advanceRoundMutator(game) {
    if (!(0, $11ebf6d0f732b2a9$export$4f2c9bb64a518c51)(game)) return game;
    if (!game.tokens.every((t)=>t == null)) return game;
    return (0, $11ebf6d0f732b2a9$export$9ffc307867ecb30d)(game);
}
function $e7256e8c5c8fe034$var$selectCardMutator(game, [username, card, index]) {
    const [draft, finalize] = (0, $f275c1bee2ad9b3e$export$185802fd694ee1f5)(game);
    const player = draft.players.find((p)=>p.name === username);
    if (!player) return game;
    const stackIndex = player.hand.findIndex((cards)=>cards instanceof Array);
    if (stackIndex === -1) return game;
    if (!(0, $e5516a3b810d567d$export$9cb4719e2e525b7a)(player.hand[stackIndex][index], card)) return game;
    player.hand[stackIndex] = card;
    return (0, $11ebf6d0f732b2a9$export$d68aabd9451ab6d8)(finalize());
}
function $e7256e8c5c8fe034$var$BiddingGame(props) {
    const { username: username, setUsername: setUsername, game: game } = props;
    const inRoom = game.gameState.players.some((p)=>p.name === username);
    const [preferences] = (0, $0727822e6bb8853d$export$bbd7d970555e2952)();
    const [showPreferences, setShowPreferences] = (0, $x1Cpm.useState)(false);
    const [, setSelectCard] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$selectCardMutator);
    const selectCard = (card, index)=>{
        setSelectCard([
            username,
            card,
            index
        ]);
    };
    const [, setMoveToken] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$moveTokenMutator);
    const [, setAdvanceRound] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$advanceRoundMutator);
    const waitingForJoker = !(0, $11ebf6d0f732b2a9$export$4f2c9bb64a518c51)(game.gameState);
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
        className: $dbc5cdb5e7583bd1$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                className: $dbc5cdb5e7583bd1$export$2b8dccb26e41f6c2,
                children: game.gameState.players.map((p, pi)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                        className: $dbc5cdb5e7583bd1$export$615455393ee443ca,
                        children: [
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                                className: $dbc5cdb5e7583bd1$export$777feab933bd57da,
                                style: p.name === username ? {} : {
                                    color: $e7256e8c5c8fe034$var$playerColour(pi)
                                },
                                children: p.name
                            }),
                            false,
                            p.name === username && " (You)",
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                                className: $dbc5cdb5e7583bd1$export$59e091b63458fcad,
                                children: [
                                    p.hand.map((c, i)=>!inRoom || p.name === username ? c instanceof Array ? /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$CardStack, {
                                            cards: c,
                                            onClick: p.name === username ? selectCard : undefined,
                                            fourColourSuits: preferences.fourColourSuits
                                        }, i) : /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$Card, {
                                            card: c,
                                            fourColourSuits: preferences.fourColourSuits
                                        }, i) : /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$NoCard, {}, i)),
                                    p.pastTokens.map((t, i)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $b3a4620d7b727d99$export$bfce916c5bf59899), {
                                            token: t,
                                            past: true,
                                            disabled: true
                                        }, i)),
                                    !waitingForJoker && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $b3a4620d7b727d99$export$bfce916c5bf59899), {
                                        token: p.token,
                                        disabled: !inRoom,
                                        onClick: ()=>setMoveToken([
                                                username,
                                                username === p.name ? null : p.token,
                                                p.name
                                            ])
                                    }),
                                    game.gameState.futureRounds.map((_, i)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                                            className: $dbc5cdb5e7583bd1$export$49ccc6e12fc9278a
                                        }, i))
                                ]
                            }),
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                                className: $dbc5cdb5e7583bd1$export$f9d2386380135291,
                                children: "\xa0"
                            })
                        ]
                    }, p.name))
            }),
            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$WinRecordView, {
                        record: game.gameState.winRecord
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                        className: $dbc5cdb5e7583bd1$export$46e4a324ac90507f,
                        children: [
                            waitingForJoker ? "Waiting for players to choose their cards" : `Round ${game.gameState.log.length} - ${(game.gameState.config.gameMode ?? (0, $4c9ffbddec832565$export$7cd7a93136e7148a).TEXAS_HOLDEM) === (0, $4c9ffbddec832565$export$7cd7a93136e7148a).OMAHA ? "Omaha" : "Hold'em"}`,
                            " ",
                            !inRoom && "(You are spectating.) ",
                            inRoom && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$KillGameButton, {
                                game: game
                            }),
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                                onClick: ()=>setShowPreferences(true),
                                children: "\u2699"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$CommunityCards, {
                        gameState: game.gameState,
                        fourColourSuits: preferences.fourColourSuits
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                        className: $dbc5cdb5e7583bd1$export$1009eb603770e7e2,
                        children: game.gameState.tokens.map((token, i)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $b3a4620d7b727d99$export$bfce916c5bf59899), {
                                token: token,
                                disabled: !inRoom,
                                onClick: ()=>setMoveToken([
                                        username,
                                        token,
                                        null
                                    ])
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                        disabled: !inRoom || waitingForJoker || !game.gameState.tokens.every((t)=>t == null),
                        onClick: ()=>setAdvanceRound(true),
                        children: game.gameState.futureRounds.length === 0 ? "Finish" : "Next round"
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$GameLog, {
                        players: game.gameState.players,
                        jokerLog: game.gameState.jokerLog,
                        log: game.gameState.log,
                        username: username
                    })
                ]
            }),
            showPreferences && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $36a7a41fb8398a5f$export$a8eae1dfb4299f8), {
                onClose: ()=>setShowPreferences(false)
            })
        ]
    });
}
function $e7256e8c5c8fe034$var$killGameMutator(game) {
    return {
        phase: (0, $4c9ffbddec832565$export$1179af6d199a01fa).SETUP,
        players: game.players.map((p)=>({
                name: p.name
            })),
        config: game.config
    };
}
function $e7256e8c5c8fe034$var$KillGameButton({ game: game }) {
    const [, setKillGame] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$killGameMutator);
    const [reallyKillGame, setReallyKillGame] = (0, $x1Cpm.useState)(false);
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)((0, $8f33693030ac5281$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                onClick: ()=>{
                    if (reallyKillGame) setKillGame(true);
                    else setReallyKillGame(true);
                },
                children: reallyKillGame ? "Really go back to game setup" : "Go back to game setup"
            }),
            reallyKillGame && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                onClick: ()=>setReallyKillGame(false),
                children: "Just kidding"
            })
        ]
    });
}
function $e7256e8c5c8fe034$var$setRevealIndexMutator(game, newRevealIndex) {
    return {
        ...game,
        revealIndex: Math.max(game.revealIndex, newRevealIndex)
    };
}
function $e7256e8c5c8fe034$var$isWinRecordFinished(record) {
    return record.wins === record.targetWins || record.losses === record.targetLosses;
}
function $e7256e8c5c8fe034$var$startNextGameMutator(game, newWinRecord) {
    if ($e7256e8c5c8fe034$var$isWinRecordFinished(newWinRecord)) return {
        ...$e7256e8c5c8fe034$var$killGameMutator(game),
        winRecord: newWinRecord
    };
    return (0, $11ebf6d0f732b2a9$export$aab0d876bb6c7a7f)(game.players, game.config, newWinRecord);
}
function $e7256e8c5c8fe034$var$ScoringGame(props) {
    const { username: username, game: game } = props;
    const { players: players, communityCards: communityCards, revealIndex: revealIndex } = game.gameState;
    const [preferences] = (0, $0727822e6bb8853d$export$bbd7d970555e2952)();
    const [showPreferences, setShowPreferences] = (0, $x1Cpm.useState)(false);
    const handScores = (0, $x1Cpm.useMemo)(()=>players.map((p)=>{
            const mode = game.gameState.config.gameMode ?? (0, $4c9ffbddec832565$export$7cd7a93136e7148a).TEXAS_HOLDEM;
            return mode === (0, $4c9ffbddec832565$export$7cd7a93136e7148a).OMAHA ? (0, $e52b9210ca254aaf$export$9bb0b1c644f80ff4)(p.hand, communityCards) : (0, $e52b9210ca254aaf$export$49fc09f142764042)([
                ...p.hand,
                ...communityCards
            ]);
        }), [
        players,
        communityCards,
        game.gameState.config.gameMode
    ]);
    const inRoom = players.some((p)=>p.name === username);
    const [, setRevealIndex] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$setRevealIndexMutator);
    const [, setStartNextGame] = (0, $bf1eafd6cf5d17c7$export$e133dff257bbd218)(game, $e7256e8c5c8fe034$var$startNextGameMutator);
    const revealedPlayerIndex = players.findIndex((p)=>p.token.index === revealIndex);
    const revealedPlayerBestHand = new Set(handScores[revealedPlayerIndex][0]);
    const playerScores = (0, $x1Cpm.useMemo)(()=>players.map((p, i)=>({
                index: p.token.index,
                score: handScores[i][1],
                playerIndex: i
            })).sort((p, q)=>p.index - q.index), [
        players,
        handScores
    ]);
    const gameWon = (0, $x1Cpm.useMemo)(()=>{
        return playerScores.every((p, i)=>i === 0 || !(0, $e52b9210ca254aaf$export$341946c3512d5b4f)(p.score, playerScores[i - 1].score));
    }, [
        playerScores
    ]);
    const { shootConfetti: shootConfetti } = (0, $x1Cpm.useContext)((0, $0d381e8093a15450$export$b8875e128ae6a5e2));
    const doneRevealing = revealIndex === players.length;
    (0, $x1Cpm.useEffect)(()=>{
        if (doneRevealing && gameWon) {
            shootConfetti(0, window.innerHeight, -Math.PI / 2 + 0.3);
            setTimeout(()=>{
                shootConfetti(window.innerWidth, window.innerHeight, -Math.PI / 2 - 0.3);
            }, 400);
        }
    }, [
        doneRevealing,
        gameWon,
        shootConfetti
    ]);
    const nextWinRecord = doneRevealing ? {
        wins: (game.gameState.winRecord?.wins ?? 0) + (gameWon ? 1 : 0),
        losses: (game.gameState.winRecord?.losses ?? 0) + (gameWon ? 0 : 1),
        targetWins: game.gameState.winRecord?.targetWins ?? (0, $4c9ffbddec832565$export$a0bea9b09a67f3da).config.targetWins,
        targetLosses: game.gameState.winRecord?.targetLosses ?? (0, $4c9ffbddec832565$export$a0bea9b09a67f3da).config.targetLosses
    } : game.gameState.winRecord;
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
        className: $dbc5cdb5e7583bd1$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                className: $dbc5cdb5e7583bd1$export$2b8dccb26e41f6c2,
                children: players.map((p, pi)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                        className: `${$dbc5cdb5e7583bd1$export$615455393ee443ca} ${pi === revealedPlayerIndex ? $dbc5cdb5e7583bd1$export$1ca2d5cca6ec0684 : ""}`,
                        children: [
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                                className: $dbc5cdb5e7583bd1$export$777feab933bd57da,
                                style: p.name === username ? {} : {
                                    color: $e7256e8c5c8fe034$var$playerColour(pi)
                                },
                                children: p.name
                            }),
                            p.name === username && " (You)",
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                                className: $dbc5cdb5e7583bd1$export$59e091b63458fcad,
                                children: [
                                    p.hand.map((c, i)=>!inRoom || p.name === username || p.token.index <= revealIndex ? /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$Card, {
                                            card: c,
                                            highlight: revealedPlayerBestHand.has(c),
                                            fourColourSuits: preferences.fourColourSuits
                                        }, i) : /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$NoCard, {}, i)),
                                    p.pastTokens.map((t, i)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $b3a4620d7b727d99$export$bfce916c5bf59899), {
                                            token: t,
                                            past: true,
                                            disabled: true
                                        }, i)),
                                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $b3a4620d7b727d99$export$bfce916c5bf59899), {
                                        token: p.token,
                                        disabled: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                                className: $dbc5cdb5e7583bd1$export$f9d2386380135291,
                                children: p.token.index <= revealIndex ? $e7256e8c5c8fe034$var$formatScore(handScores[pi][1]) : /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $8f33693030ac5281$exports.Fragment), {
                                    children: "\xa0"
                                })
                            })
                        ]
                    }, p.name))
            }),
            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$WinRecordView, {
                        record: nextWinRecord
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                        className: $dbc5cdb5e7583bd1$export$46e4a324ac90507f,
                        children: [
                            "Scoring: ",
                            revealIndex,
                            " (",
                            players[revealedPlayerIndex].name,
                            ") -",
                            " ",
                            (game.gameState.config.gameMode ?? (0, $4c9ffbddec832565$export$7cd7a93136e7148a).TEXAS_HOLDEM) === (0, $4c9ffbddec832565$export$7cd7a93136e7148a).OMAHA ? "Omaha" : "Hold'em",
                            " ",
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                                onClick: ()=>setShowPreferences(true),
                                children: "\u2699"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$CommunityCards, {
                        gameState: game.gameState,
                        highlight: revealedPlayerBestHand,
                        fourColourSuits: preferences.fourColourSuits
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                        className: $dbc5cdb5e7583bd1$export$f99014d66fbedb21,
                        children: playerScores.slice(1, revealIndex).map((p, j)=>{
                            const i = j + 1;
                            const beat = !(0, $e52b9210ca254aaf$export$341946c3512d5b4f)(playerScores[i].score, playerScores[i - 1].score);
                            const tied = beat && !(0, $e52b9210ca254aaf$export$341946c3512d5b4f)(playerScores[i - 1].score, playerScores[i].score);
                            return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                                        className: $dbc5cdb5e7583bd1$export$777feab933bd57da,
                                        children: players[playerScores[i].playerIndex].name
                                    }),
                                    "'s hand ",
                                    tied ? "tied" : beat ? "beat" : "didn't beat",
                                    " ",
                                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                                        className: $dbc5cdb5e7583bd1$export$777feab933bd57da,
                                        children: players[playerScores[i - 1].playerIndex].name
                                    }),
                                    "."
                                ]
                            }, i);
                        })
                    }),
                    revealIndex < players.length && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("button", {
                        disabled: !inRoom,
                        onClick: ()=>setRevealIndex(revealIndex + 1),
                        children: [
                            "Reveal ",
                            revealIndex + 1,
                            " (",
                            players.find((p)=>p.token.index === revealIndex + 1)?.name,
                            ")"
                        ]
                    }),
                    doneRevealing && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)((0, $8f33693030ac5281$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                                className: $dbc5cdb5e7583bd1$export$ab2b7135509352b8,
                                children: gameWon ? "You won this one!" : "You didn't wonnered."
                            }),
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                                onClick: ()=>setStartNextGame(nextWinRecord),
                                children: $e7256e8c5c8fe034$var$isWinRecordFinished(nextWinRecord) ? "Finish" : "Next game"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$GameLog, {
                        players: game.gameState.players,
                        jokerLog: game.gameState.jokerLog,
                        log: game.gameState.log,
                        username: username
                    })
                ]
            }),
            showPreferences && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $36a7a41fb8398a5f$export$a8eae1dfb4299f8), {
                onClose: ()=>setShowPreferences(false)
            })
        ]
    });
}
function $e7256e8c5c8fe034$var$CommunityCards({ gameState: gameState, highlight: highlight, fourColourSuits: fourColourSuits }) {
    // Group up cards into their rounds
    const rounds = gameState.pastRounds ? "futureRounds" in gameState ? [
        ...gameState.pastRounds,
        ...gameState.futureRounds
    ] : gameState.pastRounds : /* migration */ (0, $11ebf6d0f732b2a9$export$47cd02e2cf937030);
    let ix = 0;
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
        className: $dbc5cdb5e7583bd1$export$d83f873d3f5ec352,
        children: rounds.map(({ cards: cards }, i)=>{
            const start = ix;
            const end = ix + cards;
            ix = end;
            if (!cards) return;
            return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
                className: `${(0, $b3a4620d7b727d99$export$46749a52babc13e3)[i]} ${$dbc5cdb5e7583bd1$export$7c019dd0d8dd20e9} ${start >= gameState.communityCards.length ? $dbc5cdb5e7583bd1$export$dc9aaa456befc6ef : ""}`,
                children: start < gameState.communityCards.length ? gameState.communityCards.slice(start, end).map((c, j)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$CardStack, {
                        cards: c,
                        highlight: highlight,
                        fourColourSuits: fourColourSuits
                    }, j)) : Array.from({
                    length: cards
                }).map((_, j)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$NoCard, {}, j))
            }, i);
        })
    });
}
function $e7256e8c5c8fe034$var$GameLog({ players: players, jokerLog: jokerLog, log: log, username: username }) {
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $8f33693030ac5281$exports.Fragment), {
        children: /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
            className: $dbc5cdb5e7583bd1$export$bef1f36f5486a6a3,
            children: [
                jokerLog.length > 0 && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                    className: $dbc5cdb5e7583bd1$export$7817e5b9f07d367d,
                    children: [
                        /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("h2", {
                            children: "Setup"
                        }),
                        jokerLog.map((entry, i)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                                className: $dbc5cdb5e7583bd1$export$684005c1234186c6,
                                children: [
                                    /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                                        className: $dbc5cdb5e7583bd1$export$777feab933bd57da,
                                        children: players[entry.player].name
                                    }),
                                    " discarded a joker"
                                ]
                            }, i))
                    ]
                }),
                log.map((roundLog, roundIndex)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                        className: $dbc5cdb5e7583bd1$export$7817e5b9f07d367d,
                        children: [
                            /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("h2", {
                                children: [
                                    "Round ",
                                    roundIndex + 1
                                ]
                            }),
                            roundLog.map((logEntry, i)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                                    className: $dbc5cdb5e7583bd1$export$684005c1234186c6,
                                    children: [
                                        /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                                            className: $dbc5cdb5e7583bd1$export$777feab933bd57da,
                                            style: players[logEntry.player].name === username ? {} : {
                                                color: $e7256e8c5c8fe034$var$playerColour(logEntry.player)
                                            },
                                            children: players[logEntry.player].name
                                        }),
                                        "take" in logEntry.action ? /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)((0, $8f33693030ac5281$exports.Fragment), {
                                            children: [
                                                " ",
                                                "took the ",
                                                /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$SmallToken, {
                                                    token: logEntry.action.take
                                                }),
                                                " from",
                                                " ",
                                                logEntry.action.from == null ? /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $8f33693030ac5281$exports.Fragment), {
                                                    children: "the middle"
                                                }) : /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                                                    className: $dbc5cdb5e7583bd1$export$777feab933bd57da,
                                                    style: players[logEntry.action.from].name === username ? {} : {
                                                        color: $e7256e8c5c8fe034$var$playerColour(logEntry.action.from)
                                                    },
                                                    children: players[logEntry.action.from].name
                                                }),
                                                logEntry.action.put != null && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)((0, $8f33693030ac5281$exports.Fragment), {
                                                    children: [
                                                        " ",
                                                        "and returned the ",
                                                        /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$SmallToken, {
                                                            token: logEntry.action.put
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)((0, $8f33693030ac5281$exports.Fragment), {
                                            children: [
                                                " ",
                                                "returned the ",
                                                /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$SmallToken, {
                                                    token: logEntry.action.put
                                                })
                                            ]
                                        })
                                    ]
                                }, i))
                        ]
                    }, roundIndex))
            ]
        })
    });
}
function $e7256e8c5c8fe034$var$playerColour(i) {
    return `hsl(${190 + i * 137} 90 80)`;
}
const $e7256e8c5c8fe034$var$BREAK = {
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).Flush]: null,
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).HighCard]: null,
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).Straight]: null,
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).StraightFlush]: null,
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).FourOfAKind]: 1,
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).Pair]: 1,
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).TwoPair]: 2,
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).ThreeOfAKind]: 1,
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).FullHouse]: null
};
const $e7256e8c5c8fe034$var$HAND_KIND_NAME = {
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).Flush]: "Flush",
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).HighCard]: "High card",
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).Straight]: "Straight",
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).StraightFlush]: "Straight flush",
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).FourOfAKind]: "Four of a kind",
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).Pair]: "Pair",
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).TwoPair]: "Two pair",
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).ThreeOfAKind]: "Three of a kind",
    [(0, $e52b9210ca254aaf$export$717297effe2ca6d9).FullHouse]: "Full house"
};
function $e7256e8c5c8fe034$var$formatScore(score) {
    const brk = $e7256e8c5c8fe034$var$BREAK[score.kind];
    if (score.kind === (0, $e52b9210ca254aaf$export$717297effe2ca6d9).StraightFlush && score.order[0] === (0, $5ad47a8446dd1296$export$5062880c778c5dd2).Ace) // wow you are so cool
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $8f33693030ac5281$exports.Fragment), {
        children: "Royal Flush!!!"
    });
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)((0, $8f33693030ac5281$exports.Fragment), {
        children: [
            $e7256e8c5c8fe034$var$HAND_KIND_NAME[score.kind],
            " (",
            score.order.slice(0, brk != null ? brk : score.order.length).map($e7256e8c5c8fe034$var$formatCardValue).join(","),
            brk != null ? "; " + score.order.slice(brk).map($e7256e8c5c8fe034$var$formatCardValue).join(",") : "",
            ")"
        ]
    });
}
const $e7256e8c5c8fe034$var$STRING_VALUES = {
    [(0, $5ad47a8446dd1296$export$5062880c778c5dd2).Ace]: "A",
    [(0, $5ad47a8446dd1296$export$5062880c778c5dd2).Jack]: "J",
    [(0, $5ad47a8446dd1296$export$5062880c778c5dd2).Queen]: "Q",
    [(0, $5ad47a8446dd1296$export$5062880c778c5dd2).King]: "K"
};
function $e7256e8c5c8fe034$var$formatCardValue(value) {
    return $e7256e8c5c8fe034$var$STRING_VALUES[value] ?? value.toString();
}
const $e7256e8c5c8fe034$var$UNICODE_SUITS = {
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Diamonds]: "\u2666",
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Hearts]: "\u2665",
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Clubs]: "\u2663",
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Spades]: "\u2660"
};
const $e7256e8c5c8fe034$var$FOUR_COLOUR_SUIT_STYLES = {
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Clubs]: $dbc5cdb5e7583bd1$export$15b07da190767bbe,
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Diamonds]: $dbc5cdb5e7583bd1$export$5ce6e2f0ed680964,
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Hearts]: $dbc5cdb5e7583bd1$export$186885b852792ae6,
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Spades]: $dbc5cdb5e7583bd1$export$274575f92f7d9549
};
const $e7256e8c5c8fe034$var$TWO_COLOUR_SUIT_STYLES = {
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Clubs]: $dbc5cdb5e7583bd1$export$e15a579eead45913,
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Diamonds]: $dbc5cdb5e7583bd1$export$c19b0e76dce888eb,
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Hearts]: $dbc5cdb5e7583bd1$export$c19b0e76dce888eb,
    [(0, $5ad47a8446dd1296$export$5bdeb9e4de225b16).Spades]: $dbc5cdb5e7583bd1$export$e15a579eead45913
};
function $e7256e8c5c8fe034$var$Card(props) {
    const { card: card, onClick: onClick, highlight: highlight, fourColourSuits: fourColourSuits = true } = props;
    const suitStyles = fourColourSuits ? $e7256e8c5c8fe034$var$FOUR_COLOUR_SUIT_STYLES : $e7256e8c5c8fe034$var$TWO_COLOUR_SUIT_STYLES;
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
        className: `${$dbc5cdb5e7583bd1$export$aa3e815946b80764} ${highlight ? $dbc5cdb5e7583bd1$export$ff214d0d604522b5 : ""} ${onClick != null ? $dbc5cdb5e7583bd1$export$d4f9a5f4ca31f0b6 : ""} ${"joker" in card ? $dbc5cdb5e7583bd1$export$a3c666151edc0af1 : ""}`,
        onClick: onClick,
        children: "joker" in card ? /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $8f33693030ac5281$exports.Fragment), {
            children: "\u2728"
        }) : /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)((0, $8f33693030ac5281$exports.Fragment), {
            children: [
                $e7256e8c5c8fe034$var$formatCardValue(card.value),
                /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                    className: suitStyles[card.suit],
                    children: $e7256e8c5c8fe034$var$UNICODE_SUITS[card.suit]
                })
            ]
        })
    });
}
function $e7256e8c5c8fe034$var$CardStack(props) {
    const { cards: cards, onClick: onClick, highlight: highlight, fourColourSuits: fourColourSuits } = props;
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
        className: $dbc5cdb5e7583bd1$export$57744285f109f80a,
        children: cards.map((card, i)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)($e7256e8c5c8fe034$var$Card, {
                card: card,
                onClick: onClick != null ? ()=>onClick(card, i) : undefined,
                highlight: highlight?.has(card),
                fourColourSuits: fourColourSuits
            }, i))
    });
}
function $e7256e8c5c8fe034$var$NoCard() {
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("div", {
        className: $dbc5cdb5e7583bd1$export$2478040385952f4
    });
}
function $e7256e8c5c8fe034$var$SmallToken({ token: token }) {
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
        className: $dbc5cdb5e7583bd1$export$766d56154a07562d,
        children: token.index
    });
}
function $e7256e8c5c8fe034$var$WinRecordView({ record: record }) {
    if (!record) return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $8f33693030ac5281$exports.Fragment), {}); // for migration purposes
    const { wins: wins, losses: losses, targetWins: targetWins, targetLosses: targetLosses } = record;
    return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
        className: $dbc5cdb5e7583bd1$export$d77e2c2b3d2d6ff8,
        children: [
            Array.from({
                length: targetWins
            }).map((_, i)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                    className: i < targetWins - wins ? $dbc5cdb5e7583bd1$export$9fc9795b76ef397 : $dbc5cdb5e7583bd1$export$10a0f131c0eea21b
                }, i)),
            Array.from({
                length: targetLosses
            }).map((_, i)=>/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("span", {
                    className: i < losses ? $dbc5cdb5e7583bd1$export$5695df298eac90c7 : $dbc5cdb5e7583bd1$export$ae96dc96a6d2b85
                }, i + targetWins))
        ]
    });
}


function $5c121a02b943fe91$var$useUsername() {
    const [username, setUsername] = (0, $x1Cpm.useState)(()=>window.localStorage.getItem("username"));
    return [
        username,
        (name)=>{
            window.localStorage.setItem("username", name);
            setUsername(name);
        }
    ];
}
function $5c121a02b943fe91$var$useRoomName() {
    const [hash, setHash] = (0, $x1Cpm.useState)(()=>window.location.hash);
    (0, $x1Cpm.useEffect)(()=>{
        const listener = ()=>{
            setHash(window.location.hash);
        };
        window.addEventListener("hashchange", listener);
        return ()=>window.removeEventListener("hashchange", listener);
    });
    const roomName = hash.replace("#", "");
    return [
        roomName || null,
        (newRoomName)=>{
            window.location.hash = newRoomName ? "#" + newRoomName : "";
        }
    ];
}
var $6b9a02cf8b38bac9$exports = {};
$6b9a02cf8b38bac9$exports = new URL("uwu_plain.89c01b2b.svg", import.meta.url).toString();


const $5c121a02b943fe91$var$LOGO = new URL($6b9a02cf8b38bac9$exports);
function $5c121a02b943fe91$var$App() {
    const [username, saveUsername] = $5c121a02b943fe91$var$useUsername();
    const [roomName, setRoomName] = $5c121a02b943fe91$var$useRoomName();
    const [inGame, setInGame] = (0, $x1Cpm.useState)(Boolean(username && roomName));
    if (!username || !roomName || !inGame) {
        if (inGame) setInGame(false); // bad practice
        const newRoom = async ()=>{
            if (!username) return;
            setRoomName((await (0, $df9b98b38d7c65c2$export$5ad94f5fb1ec657b)({
                ...(0, $4c9ffbddec832565$export$a0bea9b09a67f3da),
                players: [
                    {
                        name: username
                    }
                ]
            })).room);
            setInGame(true);
        };
        return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("header", {
            className: $2c12eafc84bcc5a9$export$38e42c68cf43b5d4,
            children: [
                /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("img", {
                    className: $2c12eafc84bcc5a9$export$db3c28d99448dcff,
                    src: $5c121a02b943fe91$var$LOGO.toString(),
                    alt: "the ruffians"
                }),
                /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("div", {
                    children: [
                        "What's your name?",
                        /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("input", {
                            type: "input",
                            value: username ?? "",
                            onChange: (e)=>saveUsername(e.target.value)
                        })
                    ]
                }),
                !roomName && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $8f33693030ac5281$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)("button", {
                        disabled: !username,
                        onClick: newRoom,
                        children: "New game"
                    })
                }),
                roomName && /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $8f33693030ac5281$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsxs)("button", {
                        onClick: ()=>setInGame(true),
                        children: [
                            "View game (",
                            roomName,
                            ")"
                        ]
                    })
                })
            ]
        });
    } else return /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $e7256e8c5c8fe034$export$985739bfa5723e08), {
        username: username,
        setUsername: saveUsername,
        roomName: roomName
    }, roomName);
}
var $5c121a02b943fe91$export$2e2bcd8739ae039 = $5c121a02b943fe91$var$App;


const $d7ff3ee147cb4273$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8592eaaa51ed4368$exports))).createRoot(document.getElementById("root"));
$d7ff3ee147cb4273$var$root.render(/*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($x1Cpm))).StrictMode, {
    children: /*#__PURE__*/ (0, $8f33693030ac5281$exports.jsx)((0, $5c121a02b943fe91$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.0141047e.js.map
